import React, { Component, createRef } from "react";
import {
  Alert,
  View,
  StyleSheet,
  Text,
  ActivityIndicator,
  TouchableOpacity,
  ScrollView,
  TouchableHighlight,
  KeyboardAvoidingView,
  Platform,
  Animated,
  Keyboard,
  Dimensions,
  Modal,
} from "react-native";
import { Table, Row } from 'react-native-table-component';
import { connect } from "react-redux";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import { submitForm, getForm, beginSubmit, checkRecordStatus, showStatusError, checkLogStatus, showLogStatusError, approved } from "../actions/menu";
import { sendSubmit, setBigFileIsLoading, loadingIssue } from "../actions/submissions";
import { setStatusChange, unsetStatusChange, getMyInventoryTypes, getMyItems, getMyPackaging } from "../actions/records";
import { setIsLogGroup, getGroupDetail, setLogGroupsSubAction } from "../actions/loggroups";
import { quitOrderForm } from "../actions/tasks";
import moment from "moment-timezone";
import FormComponent from "./component";
//import uuid from "uuid";
import * as uuid from 'expo-crypto';
import LogDialog from "./dialogs/log";
import Section from "./components/section";
import RecordActions from "./widgets/recordActions";
import colors from "../constants/colors";
import alerts from "./components/alert"
import StorageService from "../services/storage";
import PaymentInfo from './dialogs/paymentInfo';
import Swal from "sweetalert2";
import "./styles.css";
import { viewContainer } from "./functions";
import NewIssue from "./dialogs/newIssue";
import { editDefaultData } from "../actions/menu";
import { getLocations } from "../actions/submissions";
import { getIngredientLotsByName } from "../actions/submissions";
import LotsByLocation from "./widgets/LotsByLocation";
import KeyboardBar from "./widgets/KeyboardBar";
import { confirmationAlert, formatStringNumber, validateDecimals, getComponentByanotherComponentId, getRequiredAmount, syncLotCodesFromQuantityChange } from "../utils";
import { isMobileWeb, isMobileWebDevice } from "../utils/mobileWeb";
import { installGlobalChromeEnterTrap, releaseGlobalChromeEnterTrap, installGlobalScannerGuard, releaseGlobalScannerGuard, resolveLocationForItemsFetch, ensureSymbolWedgeCaptureReady } from "../utils/locationScan";
import {
  exceedsRemainingLotAmount,
  findBlockingAllocation,
  formatAlreadyAllocatedShipmentAlertMessage,
  getLotStockAmount,
  getRemainingLotAmount,
  getTotalRemainingAcrossLots,
  isLotFullyAllocated,
  normalizeAllocatedShipmentList,
} from "../utils/shipmentAllocations";

class Form extends Component {
  scrollViewRef = createRef();
  animationTextBar = new Animated.Value(0);
  _keyboardRemove = [];
  /** Pending `setShowTextBar` debounce; cleared on unmount and when closing lots so stale opens do not run. */
  _showTextBarTimer = null;
  /** After closing LotsByLocation on web, ignore `openLotsView` from refocus-driven `setShowTextBar` briefly. */
  _suppressLotsReopenUntil = 0;
  moveScrollToElement = (node) => {}
  constructor(props) {
    super(props);

    this.state = {
      submission: {},
      lastStatus: false,
      checkboxkey: 0, // increment by 1 each time yesnoall is clicked
      components: [],
      choicelist: {},
      shipmentLotOptionsByRow: {},
      uuid: "",
      derived: false,
      autosave: false,
      tmpIssues: [],
      showPaymentInfo: false,
      callOnSave: false,
      lotConsecutive: 1,
      formLoaded: false,
      width: window.innerWidth,
      rerenderTable: false,
      openTableIssue: false,
      compIssueId: null,
      issueLabel: '',
      issuePosition: null,
      issueWidth: "small",
      palletComponentChanged: false,
      itemComponentChanged: false,
      updatedWizard: false,
      disableButton: false,
      batchSizeToCalculate: null,
      resetInventorySearch: { 
        changed: false,
        position: 0
      },
      inventoryLocations: [],
      inventoryLocationsLoading: false,
      locationItemsLoading: false,
      /** Direct signal for ItemsByLocation to fetch inventory (does not rely on submission re-render). */
      locationItemsFetch: null,
      dropDownOpen: -1,
      sectionDropDown: -1,
      componentDropDown: -1,
      dropDownOptions: null,
      tableSearchOpenMap: {},
      scrollableTables: {},
      scrollableTablesUpdated: false,
      closeSearch: false,
      focusedInput_id: -1,
      focusedInput_idx: -1,
      lotcodeFirstPreselection: true,
      focusLotCode: false,
      focusComponent: null,
      focusQuantity: null,
      batchSizeChanged: false,
      quantityChanged: false,
      quantityChangedPosition: -1,
      openBarCodeScanner: null,
      showTextBar: null,
      formScroll: true,
      keyboardLoaded: false,
      keyboarWithScandOpened: false,
      showLotsByLocation: false,
      KeyBoardTop: -1,
      navBarHeight: 0,
      formWidth: 0,
      minorAmountAndroid: [],
      /** iOS Safari / mobile web: keyboard overlap from visualViewport when RN Keyboard API is silent */
      webKeyboardBottomInset: 0,
      /** Captured render-time error so we can show a safe fallback UI instead of a white screen. */
      renderError: null,
    };
    this.timeSubmissions = {};
    this._renderErrorAlertShown = false;
  }

  usesLocationShipmentLoading = () => {
    const { isShipmentByLocation, isTransferByLocation } = this.props;
    return !!(isShipmentByLocation || isTransferByLocation);
  };

  isLocationByFormScanField(component) {
    const { isShipmentByLocation, isTransferByLocation } = this.props;
    if (!component) return false;
    if (isShipmentByLocation && component.defaultLabel === "location") return true;
    if (isTransferByLocation && (component.defaultLabel === "fromLocation" || component.defaultLabel === "toLocation")) return true;
    // Receiving destination uses the same scan/resolve UX as transfer-by-location toLocation.
    if (this.isReceivingLogToLocationField(component)) return true;
    return false;
  }

  /** Visible receiving toLocation (API hide=false) — same scan behavior as transfer-by-location. */
  isReceivingLogToLocationField(component) {
    const { isReceivingLog } = this.props;
    if (!isReceivingLog || !component) return false;
    if (component.hide) return false;
    return component.defaultLabel === "toLocation";
  }

  /** Recipe Yield "To Location" — searchable destination like receiving toLocation. */
  isRecipeYieldToLocationField(component) {
    const { isRecipe } = this.props;
    if (!isRecipe || !component) return false;
    if (component.hide) return false;
    return component.defaultLabel === "toLocation";
  }

  shouldUseLocationScanForComponent(component) {
    return !!(
      component?.showLocationsSearch ||
      this.isLocationByFormScanField(component) ||
      this.isRecipeYieldToLocationField(component)
    );
  }

  shouldEnableScannerForComponent(component) {
    return !!(component?.showScanner || this.isLocationByFormScanField(component) || this.isRecipeYieldToLocationField(component));
  }

  getLocationScanShowScanner(mobileScan, component, isInventoryTransfer) {
    const { isShipmentByLocation, isTransferByLocation } = this.props;
    const locationScanField = this.isLocationByFormScanField(component);
    if (!mobileScan) return null;
    const scannerFlag = component?.showScanner ?? (locationScanField || this.isRecipeYieldToLocationField(component) ? true : null);
    if (!scannerFlag) return null;
    const allowed =
      !this.isInventoryForm() ||
      isInventoryTransfer ||
      locationScanField ||
      this.isRecipeYieldToLocationField(component) ||
      ((isShipmentByLocation || isTransferByLocation) && this.shouldUseLocationScanForComponent(component));
    return allowed ? scannerFlag : null;
  }

  resolveScannerInput() {
    const { scannerInput, isShipmentByLocation, isTransferByLocation } = this.props;
    if (scannerInput) return scannerInput;
    if (isShipmentByLocation || isTransferByLocation) return true;
    return false;
  }

  requestLocationItemsFetch = (section_id, position, location) => {
    const { isShipmentByLocation, isTransferByLocation } = this.props;
    if (!isShipmentByLocation && !isTransferByLocation) return;
    if (location == null || location === "") return;

    const { inventoryLocations } = this.state;
    const resolved = resolveLocationForItemsFetch(location, inventoryLocations);
    const rowPosition = position != null ? position : 0;
    this.setState({
      locationItemsFetch: {
        section_id,
        position: rowPosition,
        location: (resolved && typeof resolved === "object") ? resolved : location,
        nonce: Date.now(),
      },
    });
  };

  setLocationItemsLoading = (loading) => {
    if (!this.usesLocationShipmentLoading()) {
      if (!loading && (this.state.locationItemsLoading || this.state.inventoryLocationsLoading)) {
        this.setState({ locationItemsLoading: false, inventoryLocationsLoading: false });
      }
      return;
    }
    if (loading) {
      this.setState({ locationItemsLoading: true, inventoryLocationsLoading: false });
      return;
    }
    this.setState({ locationItemsLoading: false });
  };

  static getDerivedStateFromError(error) {
    return { renderError: error };
  }

  componentDidCatch(error, info) {
    this._showRenderErrorAlert(error, info);
  }

  _buildRenderErrorDebugInfo = (error, info) => {
    const safe = (fn, fallback = "n/a") => {
      try { const v = fn(); return v === undefined || v === null ? fallback : v; } catch (_) { return fallback; }
    };
    const trimStack = (stack, maxLines = 12) => {
      if (!stack) return "n/a";
      const lines = String(stack).split("\n").map(l => l.trim()).filter(Boolean);
      return lines.slice(0, maxLines).join("\n");
    };
    const {
      isRecipe, isReceivingLog, isOrder, isInvoice, isShipmentLog,
      isReconciliationLog, isInventoryTransfer, isPallet, isRequisitionForm,
      formId, title, newReport, task_id, submissionSelected, complete_date,
    } = this.props || {};
    const s = this.state || {};
    const formType = isRecipe ? "Recipe"
      : isReceivingLog ? "Receiving"
      : isShipmentLog ? "Shipment"
      : isInventoryTransfer ? "InventoryTransfer"
      : isReconciliationLog ? "Reconciliation"
      : isInvoice ? "Invoice"
      : isOrder ? "Order"
      : isPallet ? "Pallet"
      : isRequisitionForm ? "Requisition"
      : "Generic";
    const ctx = {
      formType,
      formId: safe(() => formId),
      title: safe(() => title),
      newReport: safe(() => !!newReport, false),
      task_id: safe(() => task_id),
      submissionId: safe(() => submissionSelected?._id),
      status: safe(() => submissionSelected?.status, "new"),
      complete_date: safe(() => complete_date || submissionSelected?.complete_date, null),
      platform: Platform.OS,
      isMobileWeb: safe(() => (Platform.OS === "web" ? isMobileWeb() : false), false),
      windowWidth: safe(() => (typeof window !== "undefined" ? window.innerWidth : null)),
      windowHeight: safe(() => (typeof window !== "undefined" ? window.innerHeight : null)),
      userAgent: safe(() => (typeof navigator !== "undefined" ? navigator.userAgent : null)),
    };
    const stateSnapshot = {
      formLoaded: safe(() => s.formLoaded, false),
      componentsCount: safe(() => (Array.isArray(s.components) ? s.components.length : 0), 0),
      sectionsCount: safe(() => (Array.isArray(s.components) ? s.components.filter(c => c?.type === "section").length : 0), 0),
      submissionKeys: safe(() => (s.submission ? Object.keys(s.submission).length : 0), 0),
      choicelistKeys: safe(() => (s.choicelist ? Object.keys(s.choicelist).length : 0), 0),
      tmpIssues: safe(() => (Array.isArray(s.tmpIssues) ? s.tmpIssues.length : 0), 0),
      dropDownOpen: safe(() => s.dropDownOpen, -1),
      sectionDropDown: safe(() => s.sectionDropDown, -1),
      componentDropDown: safe(() => s.componentDropDown, -1),
      showTextBarId: safe(() => s.showTextBar?.id, null),
      showTextBarPosition: safe(() => s.showTextBar?.position, null),
      showLotsByLocation: safe(() => !!s.showLotsByLocation, false),
      keyboarWithScandOpened: safe(() => !!s.keyboarWithScandOpened, false),
      keyboardLoaded: safe(() => !!s.keyboardLoaded, false),
      webKeyboardBottomInset: safe(() => s.webKeyboardBottomInset, 0),
      autosave: safe(() => !!s.autosave, false),
      disableButton: safe(() => !!s.disableButton, false),
      batchSizeToCalculate: safe(() => s.batchSizeToCalculate, null),
    };
    const errorName = safe(() => error?.name, "Error");
    const errorMessage = safe(() => (error?.message || (error && error.toString())) || "Unknown error", "Unknown error");
    const errorStack = trimStack(safe(() => error?.stack, ""), 12);
    const componentStack = trimStack(safe(() => info?.componentStack, ""), 10);
    return { ctx, stateSnapshot, errorName, errorMessage, errorStack, componentStack };
  };

  _formatRenderErrorPlainText = (debug) => {
    const { ctx, stateSnapshot, errorName, errorMessage, errorStack, componentStack } = debug;
    const lines = [];
    lines.push(`${errorName}: ${errorMessage}`);
    lines.push("");
    lines.push("— Form —");
    Object.keys(ctx).forEach(k => lines.push(`${k}: ${ctx[k]}`));
    lines.push("");
    lines.push("— State —");
    Object.keys(stateSnapshot).forEach(k => lines.push(`${k}: ${stateSnapshot[k]}`));
    lines.push("");
    lines.push("— Where (component tree) —");
    lines.push(componentStack);
    lines.push("");
    lines.push("— Stack —");
    lines.push(errorStack);
    return lines.join("\n");
  };

  _formatRenderErrorHtml = (debug) => {
    const escape = (v) => String(v == null ? "" : v)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const { ctx, stateSnapshot, errorName, errorMessage, errorStack, componentStack } = debug;
    const renderKV = (obj) => Object.keys(obj).map(k =>
      `<div><b>${escape(k)}:</b> <code>${escape(obj[k])}</code></div>`
    ).join("");
    return (
      `<div style="text-align:left;font-size:12px;line-height:1.4;max-height:55vh;overflow:auto;">` +
      `<div style="margin-bottom:8px;"><b>${escape(errorName)}:</b> ${escape(errorMessage)}</div>` +
      `<div style="margin-top:8px;"><b>Form</b></div>${renderKV(ctx)}` +
      `<div style="margin-top:8px;"><b>State</b></div>${renderKV(stateSnapshot)}` +
      `<div style="margin-top:8px;"><b>Where (component tree)</b></div>` +
      `<pre style="white-space:pre-wrap;background:#f5f5f5;padding:6px;border-radius:4px;">${escape(componentStack)}</pre>` +
      `<div style="margin-top:8px;"><b>Stack</b></div>` +
      `<pre style="white-space:pre-wrap;background:#f5f5f5;padding:6px;border-radius:4px;">${escape(errorStack)}</pre>` +
      `</div>`
    );
  };

  _showRenderErrorAlert = (error, info) => {
    if (this._renderErrorAlertShown) return;
    this._renderErrorAlertShown = true;
    const debug = this._buildRenderErrorDebugInfo(error, info);
    this._lastRenderErrorDebug = debug;
    const context = this.props.isRecipe ? " (Recipe form)" : "";
    const title = "Something went wrong" + context;
    try {
      if (typeof console !== "undefined" && console.error) {
        console.error("Form render error" + context + ":", error, info, debug);
      }
    } catch (_) {}
    try {
      if (Platform.OS === "web" && typeof Swal !== "undefined" && Swal?.fire) {
        Swal.fire({
          title,
          html: this._formatRenderErrorHtml(debug),
          confirmButtonText: "OK",
          confirmButtonColor: colors.orange,
          backdrop: false,
          width: 720,
        });
        return;
      }
    } catch (_) {}
    const plain = this._formatRenderErrorPlainText(debug);
    try {
      if (Alert && typeof Alert.alert === "function") {
        Alert.alert(title, plain);
        return;
      }
    } catch (_) {}
    try {
      if (typeof window !== "undefined" && typeof window.alert === "function") {
        window.alert(title + "\n\n" + plain);
      }
    } catch (_) {}
  };

  handleResize = () => {
    this.setState({ width: window.innerWidth });
    if (Platform.OS === "web" && isMobileWeb() && this.state.keyboarWithScandOpened) {
      this._syncWebKeyboardInsetFromViewport();
    }
  };

  _webVvCleanup = null;
  _webKeyboardInsetTimeouts = [];

  /** Mobile web: distance from bottom of layout viewport to top of soft keyboard (CSS px). */
  _readWebKeyboardBottomInset() {
    if (typeof window === "undefined" || !window.visualViewport) return 0;
    const vv = window.visualViewport;
    const doc = window.document?.documentElement;
    const layoutH =
      doc?.clientHeight && doc.clientHeight > 0
        ? Math.max(doc.clientHeight, window.innerHeight || 0)
        : window.innerHeight || 0;
    return Math.round(Math.max(0, layoutH - vv.height - vv.offsetTop));
  }

  _webKeyboardCloseTimer = null;
  /** Suppress auto-hide briefly after explicit transitions (e.g. ABC → open picker) to avoid race with visualViewport. */
  _suppressAutoHideUntil = 0;

  _syncWebKeyboardInsetFromViewport = () => {
    if (Platform.OS !== "web" || typeof window === "undefined" || !window.visualViewport) return;
    if (!isMobileWeb()) return;
    const apply = () => {
      const inset = this._readWebKeyboardBottomInset();
      this.setState((s) =>
        s.webKeyboardBottomInset === inset ? null : { webKeyboardBottomInset: inset }
      );
      /* Mobile web: keyboardDidHide is unreliable. Treat a stable inset of 0 as keyboard closed and hide the bar.
         Skip while LotsByLocation is open — pressing ABC dismisses the keyboard intentionally and we must keep
         showTextBar populated for the picker. */
      if (this._webKeyboardCloseTimer) {
        clearTimeout(this._webKeyboardCloseTimer);
        this._webKeyboardCloseTimer = null;
      }
      if (
        inset === 0 &&
        this.state.keyboarWithScandOpened &&
        !this.state.showLotsByLocation &&
        Date.now() >= this._suppressAutoHideUntil
      ) {
        this._webKeyboardCloseTimer = setTimeout(() => {
          this._webKeyboardCloseTimer = null;
          if (
            this._readWebKeyboardBottomInset() === 0 &&
            this.state.keyboarWithScandOpened &&
            !this.state.showLotsByLocation &&
            Date.now() >= this._suppressAutoHideUntil
          ) {
            this.setState(
              {
                showTextBar: null,
                keyboarWithScandOpened: false,
                rerenderTable: !this.state.rerenderTable,
              },
              () => this.showTextbarAnimation(0, 100)
            );
          }
        }, 350);
      }
    };
    apply();
    if (typeof requestAnimationFrame !== "undefined") {
      requestAnimationFrame(apply);
    }
  };

  /** iOS animates the keyboard over several frames; re-read visualViewport a few times. */
  _scheduleWebKeyboardInsetSync = () => {
    if (Platform.OS !== "web" || !isMobileWeb()) return;
    if (this._webKeyboardInsetTimeouts?.length) {
      this._webKeyboardInsetTimeouts.forEach(clearTimeout);
      this._webKeyboardInsetTimeouts = [];
    }
    const delays = [0, 60, 150, 280, 450, 700];
    delays.forEach((ms) => {
      const id = setTimeout(() => {
        this._syncWebKeyboardInsetFromViewport();
        this._webKeyboardInsetTimeouts = this._webKeyboardInsetTimeouts.filter((t) => t !== id);
      }, ms);
      this._webKeyboardInsetTimeouts.push(id);
    });
  };

  componentDidMount() {
    this.props.getForm(this.props.submissionSelected?._id, () => {
      this.checkLotSubmissions();
      this.setState({ formLoaded: true });
    });
    window.addEventListener("resize", this.handleResize);
    if (
      Platform.OS === "web" &&
      typeof window !== "undefined" &&
      window.visualViewport
    ) {
      const vv = window.visualViewport;
      const onVv = () => this._syncWebKeyboardInsetFromViewport();
      vv.addEventListener("resize", onVv);
      vv.addEventListener("scroll", onVv);
      this._webVvCleanup = () => {
        vv.removeEventListener("resize", onVv);
        vv.removeEventListener("scroll", onVv);
      };
    }
    if (this.props.isPallet || this.props.isInvoice || this.props.isShipmentLog || this.props.isInventoryTransfer) {
      this.props.getMyInventoryTypes({
        ignoreFilters: true,
        page: 1,
        ...(this.props.isInventoryTransfer ? { fromInventoryTransfer: true } : {}),
      });
    }
    if (this.props.isRecipe || this.props.isReceivingLog || this.props.isOrder || this.props.isShipmentLog || this.props.isReconciliationLog || this.props.isInventoryTransfer) {
      var itemsData = { ignoreFilters: true, page: 1 };
      if(this.props.isShipmentLog || this.props.isInventoryTransfer)itemsData.fromShipmentLog = true;
      if(this.props.isInventoryTransfer)itemsData.fromInventoryTransfer = true;
      if(this.props.isRecipe)itemsData.forRecipe = true;
      this.props.getMyItems(itemsData);
      this.props.getMyPackaging({
        ignoreFilters: true,
        page: 1,
        ...(this.props.isInventoryTransfer ? { fromInventoryTransfer: true } : {}),
      })
    }
    if(this.props.isInventoryTransfer || this.props.isRecipe || this.props.isShipmentByLocation || this.props.isTransferByLocation || this.props.isReceivingLog){
      if (this.props.isShipmentByLocation || this.props.isTransferByLocation) {
        this.setState({ inventoryLocationsLoading: true });
      }
      var data = {
        page: 1, 
        ignoreFilters: true,
        company_id: this.props.company_id,
      };
      if(this.props.isShipmentByLocation || this.props.isTransferByLocation || this.props.isReceivingLog)data.fromApp = true;
      if(this.props.isReceivingLog)data.fromReceivingLog = true;
      this.props.getLocations(data, (res)=>{
        const updates = { inventoryLocationsLoading: false };
        if(res?.locations?.length){
          updates.inventoryLocations = res.locations;
          updates.itemComponentChanged = !this.state.itemComponentChanged;
        }
        this.setState(updates);
      });
      if (this.props.isShipmentByLocation || this.props.isTransferByLocation) {
        if (this.state.inventoryLocationsLoading) {
          this.setState({ inventoryLocationsLoading: false });
        }
      }
    }
    if (Platform.OS === "web" && isMobileWebDevice() && (this.props.isShipmentByLocation || this.props.isTransferByLocation || this.props.isReceivingLog)) {
      installGlobalChromeEnterTrap();
      ensureSymbolWedgeCaptureReady();
    }
    if (Platform.OS === "web" && isMobileWebDevice()) {
      installGlobalScannerGuard();
    }
    if (Platform.OS !== "ios") {
      const screenHeight = Dimensions.get("screen").height;
      const KEYBOARD_SCREEN_Y_THRESHOLD = screenHeight * 0.6;
      const KEYBOARD_ADJUSTMENT_HEIGHT = 55;
      this._keyboardRemove.push(
        Keyboard.addListener("keyboardDidHide", () => {
          const webMobileKeepAccessory =
            Platform.OS === "web" &&
            isMobileWeb() &&
            this.state.showTextBar &&
            this.state.keyboarWithScandOpened;
          const wedgeLocationBar =
            Platform.OS === "web" &&
            isMobileWeb() &&
            !!this.state.showTextBar?.hideLotsView;
          if (!webMobileKeepAccessory) {
            this.showTextbarAnimation(0, 100);
          }
          this.setState({
            keyboardLoaded: false,
            ...(webMobileKeepAccessory ? {} : { keyboarWithScandOpened: false }),
            ...(webMobileKeepAccessory || wedgeLocationBar
              ? {}
              : { rerenderTable: !this.state.rerenderTable }),
          });
        })
      );
      this._keyboardRemove.push(
        Keyboard.addListener("keyboardDidShow", (event) => {
          const plusHeight =
            event.endCoordinates.screenY > KEYBOARD_SCREEN_Y_THRESHOLD
              ? KEYBOARD_ADJUSTMENT_HEIGHT
              : 0;
          this.setState(
            {
              keyboardLoaded: true,
              KeyBoardTop:
                event.endCoordinates.screenY -
                (this.state.navBarHeight + plusHeight),
              rerenderTable: !this.state.rerenderTable,
            },
            () => this.showTextbarAnimation(1, 500)
          );
        })
      );
      this._keyboardRemove.push(
        Keyboard.addListener("keyboardWillHide", () => {
          const webMobileKeepAccessory =
            Platform.OS === "web" &&
            isMobileWeb() &&
            this.state.showTextBar &&
            this.state.keyboarWithScandOpened;
          if (!webMobileKeepAccessory) this.showTextbarAnimation(0, 100);
        })
      );
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.showTextBar !== this.state.showTextBar) {
      //alert('showTextBar: ' + JSON.stringify(this.state.showTextBar));
    }
    if (
      Platform.OS === "web" &&
      isMobileWeb() &&
      !prevState.keyboarWithScandOpened &&
      this.state.keyboarWithScandOpened
    ) {
      this._scheduleWebKeyboardInsetSync();
    }
    if (
      !this.usesLocationShipmentLoading() &&
      (this.state.locationItemsLoading || this.state.inventoryLocationsLoading)
    ) {
      this.setState({ locationItemsLoading: false, inventoryLocationsLoading: false });
    }
  }
  componentWillUnmount() {
    if (Platform.OS === "web" && isMobileWebDevice() && (this.props.isShipmentByLocation || this.props.isTransferByLocation || this.props.isReceivingLog)) {
      releaseGlobalChromeEnterTrap();
    }
    if (Platform.OS === "web" && isMobileWebDevice()) {
      releaseGlobalScannerGuard();
    }
    window.removeEventListener("resize", this.handleResize);
    if (this._webKeyboardInsetTimeouts?.length) {
      this._webKeyboardInsetTimeouts.forEach(clearTimeout);
      this._webKeyboardInsetTimeouts = [];
    }
    if (this._webKeyboardCloseTimer) {
      clearTimeout(this._webKeyboardCloseTimer);
      this._webKeyboardCloseTimer = null;
    }
    if (this._webVvCleanup) {
      this._webVvCleanup();
      this._webVvCleanup = null;
    }
    if (this._keyboardRemove?.length) {
      this._keyboardRemove.forEach((sub) => sub.remove());
      this._keyboardRemove = [];
    }
    if (this._showTextBarTimer) {
      clearTimeout(this._showTextBarTimer);
      this._showTextBarTimer = null;
    }
  }
  checkLotSubmissions() {
    const { submissionSelected } = this.props;
    let num_array = [];
    if (submissionSelected) {
      let sub_id = submissionSelected._id.slice(-8);
      for (let component of submissionSelected.components) {
        let obj = submissionSelected.submission[component.id];
        if (obj) {
          obj = obj.toString();
          if (component.type === "lotcode" || component.type === "customlotcode") {
            if (obj.includes(sub_id)) {
              obj = parseInt(obj.replace(sub_id, ""));
              num_array.push(obj);
            }
          }
          if (component.type === "inventory") {
            if (obj.lotcode && obj.lotcode.includes(sub_id)) {
              obj = parseInt(obj.replace(sub_id, ""));
              num_array.push(obj);
            }
          }
        }
      }
      var max = Math.max(...num_array);
      var min = Math.min(...num_array);
      if (max && max > 0) {
        this.setState({ lotConsecutive: max + 1 })
      }
    }
  }

  setCompleteStatus() {
    const { submission } = this.state;
    if (submission.status) {
      this.setState({ lastStatus: submission.status })
    }
    submission.status = "complete";
    this.setState({ submission: submission }, () => {
      this.submitForm("complete");
    });
  }

  saveForm = () => {
    this.setState(
      {
        autosave: true,
      },
      () => {
        this.props.autoSave(
          this.state.components,
          this.state.choicelist,
          this.state.submission,
          this.props.newReport ? uuid.randomUUID() : this.state.uuid,
          this.props.task_id,
          this.state.autosave
        );
      }
    );
  };

  getComponentById(id) {
    const { components } = this.state;
    var r = null;
    for (var i = 0; i < components.length; i++) {
      if (components[i]["id"] == id) return components[i];
    }
  }
  getItemSelected(value, type, by) {
    const { items, packagingMaterials } = this.props;
    var itemVal = null;
    switch (type) {
      case "ingredient":
        items.map(item => {
          if (item[by] == value) itemVal = item;
        })
        break;
      case "packaging":
        packagingMaterials.map(item => {
          if (item.namePackaging == value) itemVal = item;
        })
        break;
    }
    return itemVal;
  }

  onComponentChange(id, value, subtype = false, position, prepopulate, itemSelected) {
    const { submission, components, lotConsecutive, palletComponentChanged, itemComponentChanged, resetInventorySearch, inventoryLocations } = this.state;
    const { isPallet, isReceivingLog, isOrder, isRecipe, isInvoice, isShipmentLog, defaultYield, isReconciliationLog, companyTimezone, isInventoryTransfer } = this.props;
    let newSubmission = JSON.parse(JSON.stringify(this.state.submission));
    let checkboxkey = this.state.checkboxkey;
    var c = this.getComponentById(id);
    if (typeof c != "undefined") {
      if (subtype) {
        if (typeof newSubmission[c.id] != "undefined") {
          // newSubmission[c.id][subtype] = value;
          if (newSubmission[c.id] == "") {
            newSubmission[c.id] = [];
          }
          if (position || position == 0) {
            if (newSubmission[c.id][position])
              newSubmission[c.id][position][subtype] = value;
            else {
              newSubmission[c.id][position] = {};
              newSubmission[c.id][position][subtype] = value;
            }
          } else {
            newSubmission[c.id] = {};
            newSubmission[c.id][subtype] = value;
          }
        } else {
          newSubmission[c.id] = {};
          if (position || position == 0) {
            if (newSubmission[c.id][position])
              newSubmission[c.id][position][subtype] = value;
            else {
              newSubmission[c.id][position] = {};
              newSubmission[c.id][position][subtype] = value;
            }
          } else {
            newSubmission[c.id][subtype] = value;
          }
          // newSubmission[c.id][subtype] = value;
        }
        if (subtype === "lotcode") {
          this.setState({ lotConsecutive: lotConsecutive + 1 })
        }
      } else {
        if (position || position == 0) {
          if(typeof newSubmission[c.id] != "object")newSubmission[c.id] = [];
          newSubmission[c.id][position] = value;
        } else {
          newSubmission[c.id] = value;
        }
      }
      if(c.type === "dropdown") {
        this.setState({ dropDownOpen: -1, sectionDropDown: -1, componentDropDown: -1, dropDownOptions: null, rerenderTable: !this.state.rerenderTable });
      }
      //Receiving Log Form logic
      if (((isReceivingLog && itemSelected) || isOrder || isReconciliationLog || isRecipe) && (c?.defaultLabel == "ingredient" || c?.defaultLabel == "rawMaterialProductCode")){
        var itemName = value;
        var productCode = "";
        if(itemSelected){
          itemName = itemSelected.itemName ? itemSelected.itemName : itemSelected.namePackaging ? itemSelected.namePackaging : "";
          productCode = itemSelected.productCode;
        }else{
          itemName = "";
        }
        if (itemSelected) {
          components.map(component => {
            if (component.defaultLabel != "quantity" && c.section_id == component.section_id) {
                var val = itemSelected[component.defaultLabel] ? itemSelected[component.defaultLabel] : "";
                if(component.defaultLabel == "price"){
                  val = itemSelected["costUnit"] ? itemSelected["costUnit"] : "";
                }else if(component.defaultLabel == "ingredient"){
                  if(itemName)val = itemName;
                }else if((component.defaultLabel == "rawMaterialProductCode")){
                  if(productCode){
                    val = productCode;
                  }else{
                    if (position || position == 0) {
                      if (newSubmission[component.id]) val = newSubmission[component.id][position];
                    } else {
                      if (newSubmission[component.id]) val = newSubmission[component.id][0];
                    }
                  }
                }else if(isReceivingLog && component.defaultLabel == "toLocation"){
                  var itemLocation = itemSelected?.location;
                  if(itemLocation){
                    val = this.filterLocations(itemLocation, inventoryLocations);
                    if(!val?.length) val = [""];
                  }else{
                    val = [""];
                  }
                }
                if(typeof val == "object" && val.length >= 0 && component.defaultLabel != "toLocation"){
                  var arr = val;
                  val = "";
                  arr.map((v, idx)=>{
                    if(idx == arr.length - 1){
                      val += v;
                    }else{
                      val += v + ", ";
                    }
                  })
                }
                if (position || position == 0) {
                  if (newSubmission[component.id]) newSubmission[component.id][position] = val;
                } else {
                  if (newSubmission[component.id]) newSubmission[component.id][0] = val;
                }
            }
            
            if(isReceivingLog && (component.defaultLabel == "quantity" || component.defaultLabel == "lotcode") ||
               isRecipe && (component.defaultLabel == "quantity" )){
              if (position || position == 0) {
                if (newSubmission[component.id]) newSubmission[component.id][position] = "";
              } else {
                if (newSubmission[component.id]) newSubmission[component.id][0] = "";
              }
            }
          })
        }
        this.setState({ submission: newSubmission, itemComponentChanged: !itemComponentChanged, rerenderTable: !this.state.rerenderTable });
        if (isReceivingLog && itemSelected) this.requestFocusQuantity(position, c.section_id);
      }
      if (((isReceivingLog && itemSelected) || isOrder || isReconciliationLog || isRecipe) && (c?.defaultLabel == "packagingMaterial" || c?.defaultLabel == "name" || c?.defaultLabel == "packagingProductCode")) {
        var itemName = value;
        var productCode = "";
        if(itemSelected){
          itemName = itemSelected.namePackaging ? itemSelected.namePackaging : "";
          productCode = itemSelected.productCode;
        }else{
          itemName = "";
        }
        if (itemSelected) {
          components.map(component => {
            if (component.defaultLabel != "quantity" && c.section_id == component.section_id) {
              var val = "";
              if(component.defaultLabel == "name" || component.defaultLabel == "packagingMaterial"){
                if(itemName)val = itemName;
              }else if(component.defaultLabel == "price"){
                val = itemSelected.cost ? itemSelected.cost : "";
              }else if((component.defaultLabel == "packagingProductCode")){
                if(productCode){
                  val = productCode;
                }else{
                  if (position || position == 0) {
                    if (newSubmission[component.id]) val = newSubmission[component.id][position];
                  } else {
                    if (newSubmission[component.id]) val = newSubmission[component.id][0];
                  }
                }
              }else if((component.defaultLabel == "supplier")){
                val = itemSelected?.supplier?.name ? itemSelected?.supplier?.name : itemSelected?.supplier2?.name ? itemSelected?.supplier2?.name : "";
              }else if(isReceivingLog && component.defaultLabel == "toLocation"){
                var packagingLocation = itemSelected?.location;
                if(packagingLocation){
                  val = this.filterLocations(packagingLocation, inventoryLocations);
                  if(!val?.length) val = [""];
                }else{
                  val = [""];
                }
              }else{
                val = itemSelected[component.defaultLabel] ? itemSelected[component.defaultLabel] : "";
              }
              if (position || position == 0) {
                if (newSubmission[component.id]) newSubmission[component.id][position] = val;
              } else {
                if (newSubmission[component.id]) newSubmission[component.id][0] = val;
              }
            }
            if(c.section_id == component.section_id && (isReceivingLog && (component.defaultLabel == "quantity" || component.defaultLabel == "lotcode") || isRecipe && (component.defaultLabel == "quantity" ))){
              if (position || position == 0) {
                if (newSubmission[component.id]) newSubmission[component.id][position] = "";
              } else {
                if (newSubmission[component.id]) newSubmission[component.id][0] = "";
              }
            }
          })
        }
        this.setState({ submission: newSubmission, itemComponentChanged: !itemComponentChanged, rerenderTable: !this.state.rerenderTable });
        if (isReceivingLog && itemSelected) this.requestFocusQuantity(position, c.section_id);
      }
      //Recipe Batch Size Logic
      if (isRecipe && c.defaultLabel == "yield") {
        //Change logic to make calculations until save, send, edit required or approve
        // this.setState({ batchSizeToCalculate: value, itemComponentChanged: !itemComponentChanged  });

        //Old logic for Batch Size Logic
        newSubmission = this.calculateBatchSize(value, defaultYield, newSubmission, components);
        const afterBatchFocus = this.getFocusTargetAfterBatchSizeConfirm();
        this.setState({ submission: newSubmission, itemComponentChanged: !itemComponentChanged, 
          batchSizeChanged: !this.state.batchSizeChanged, 
          rerenderTable: !this.state.rerenderTable, 
          quantityChanged: !this.state.quantityChanged,
          focusLotCode: afterBatchFocus.kind === "lot",
          focusComponent: afterBatchFocus.kind === "component" ? { id: afterBatchFocus.id } : null,
        }, () => {
          setTimeout(() => {
            if (this.state.focusLotCode || this.state.focusComponent) {
              this.setState({
                focusLotCode: false,
                focusComponent: null,
                rerenderTable: !this.state.rerenderTable,
              });
            }
          }, 1000);
        });
      }
      //Invoice form Size Logic
      if (isInvoice) {
        if(c.defaultLabel == "item"){
          var rate = 0;
          var valid = "";
          components.filter(section => (section.type == 'section' && !section.hide && section?.defaultLabel == "invoiceItems")).map((section, id) => {
            components.filter(component => component.section_id == section.section_id && component.type != 'section').map((component) => {
              // if(c.defaultLabel == "item"){
                switch (component?.defaultLabel) {
                  case "item":
                    if (position || position == 0) {
                      if (newSubmission[component.id]) newSubmission[component.id][position] = value?.item;
                    } else {
                      if (newSubmission[component.id]) newSubmission[component.id][0] = value?.item;
                    }
                    break;
                    case "productCode":
                    if (position || position == 0) {
                      if (newSubmission[component.id]) newSubmission[component.id][position] = "";
                    } else {
                      if (newSubmission[component.id]) newSubmission[component.id][0] = "";
                    }
                    break;
                  case "description":
                    if (position || position == 0) {
                      if (newSubmission[component.id]) newSubmission[component.id][position] = value?.description;
                    } else {
                      if (newSubmission[component.id]) newSubmission[component.id][0] = value?.description;
                    }
                    break;
                  case "quantity":
                    if (position || position == 0) {
                      if (newSubmission[component.id]) newSubmission[component.id][position] = value?.amount;
                    } else {
                      if (newSubmission[component.id]) newSubmission[component.id][0] = value?.amount;
                    }
                    break;
                  case "rate":
                    if (position || position == 0) {
                      if (newSubmission[component.id]) newSubmission[component.id][position] = value?.itemRate;
                    } else {
                      if (newSubmission[component.id]) newSubmission[component.id][0] = value?.itemRate;
                    }
                    break;
                  case "amount":
                    var amount = parseFloat(value?.amount) * parseFloat(value?.itemRate);
                    if (!amount || amount == "NaN") {
                      amount = 0;
                    }
                    if (position || position == 0) {
                      if (newSubmission[component.id]) newSubmission[component.id][position] = amount;
                    } else {
                      if (newSubmission[component.id]) newSubmission[component.id][0] = amount;
                    }
                    break;
                  case "units":
                    if (position || position == 0) {
                      if (newSubmission[component.id]) newSubmission[component.id][position] = value?.units;
                    } else {
                      if (newSubmission[component.id]) newSubmission[component.id][0] = value?.units;
                    }
                    break;
                  case "class":
                    if (position || position == 0) {
                      if (newSubmission[component.id]) newSubmission[component.id][position] = value?.class;
                    } else {
                      if (newSubmission[component.id]) newSubmission[component.id][0] = value?.class;
                    }
                    break;
                  case "item_invoice_id":
                    if (position || position == 0) {
                      if (newSubmission[component.id]) newSubmission[component.id][position] = value?._id;
                    } else {
                      if (newSubmission[component.id]) newSubmission[component.id][0] = value?._id;
                    }
                    break;
                }
            });
          });

          if(valid){
            switch(valid){
              case "all_stock":
                this.alertConfirm("It looks like all the stock for this item was already selected", "Accept");
                break;
              case "lot_selected":
                this.alertConfirm("Sorry, It looks like this lot was already selected", "Accept");
                break;
            }
            this.setState({ submission: newSubmission, itemComponentChanged: { changed: !resetInventorySearch.changed, position: position }});
            return;
          }
        }
        if(c.defaultLabel == "quantity"){
          var rate = "0";  
          components.filter(section => (section.type == 'section' && !section.hide && section?.defaultLabel == "invoiceItems")).map((section, id) => {
            components.filter(component => component.section_id == section.section_id && component.type != 'section').map((component) => {
              switch (component?.defaultLabel) {
                  case "rate":
                    if (position || position == 0) {
                      if (newSubmission[component.id]) rate = newSubmission[component.id][position];
                    } else {
                      if (newSubmission[component.id]) rate = newSubmission[component.id][0];
                    }
                    if(rate){
                      rate = rate.replace("$", "");
                      rate = parseFloat(rate);
                    }
                    break;
                  case "amount":
                    var quantity = parseFloat(value);
                    if(rate > 0 && quantity > 0){
                      var amount = rate * quantity;
                      amount = amount.toFixed(2);
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = "$" + amount.toString();
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = "$" + amount.toString();
                      }
                    }
                    
                    break;
                }
            });
          });
        }
        this.setState({ submission: newSubmission, itemComponentChanged: !itemComponentChanged });
      }

      //Shipment Log
      if(isShipmentLog){
        if (
          c.defaultLabel == "lotcode_finished" ||
          c.defaultLabel == "lotcode_wip" ||
          c.defaultLabel == "lotcode"
        ) {
          const allocatedLot = this.findAlreadyAllocatedShipmentLot(
            value,
            position,
            c,
            this.state.submission
          );
          if (allocatedLot) {
            this.blockAlreadyAllocatedShipmentSelection(allocatedLot, position);
            return;
          }
        }
        if (
          itemSelected &&
          (c.defaultLabel == "ingredient" ||
            c.defaultLabel == "rawMaterialProductCode" ||
            c.defaultLabel == "packagingMaterial" ||
            c.defaultLabel == "packagingProductCode") &&
          itemSelected?.lotSelected
        ) {
          const lotComp = components.find(
            (comp) =>
              comp.section_id == c.section_id &&
              comp.type != "section" &&
              comp.defaultLabel == "lotcode"
          );
          const itemName =
            itemSelected.itemName ||
            itemSelected.namePackaging ||
            itemSelected.item ||
            "";
          const allocatedLot = this.findAlreadyAllocatedShipmentLot(
            itemSelected.lotSelected,
            position,
            lotComp || c,
            this.state.submission,
            itemName
          );
          if (allocatedLot) {
            // Keep the item selection, but skip the allocated lot so preselection can pick another.
            itemSelected = { ...itemSelected, lotSelected: null };
          }
        }
        if(c.defaultLabel == "item" || c.defaultLabel == "fgProductCode" || c.defaultLabel == "wipProductCode" || c.defaultLabel == "lotcode_finished" || c.defaultLabel == "lotcode_wip"){
          var rate = 0;
          var valid = "";
          components.filter(section => (section.section_id == c.section_id && section.type == 'section' && !section.hide && (section?.defaultLabel == "finishedGoods" || section?.defaultLabel == "workInProgress"))).map((section, id) => {
            components.filter(component => component.section_id == section.section_id && component.type != 'section').map((component) => {
              if(!valid){
                if((c.defaultLabel == "item" || c.defaultLabel == "fgProductCode" || c.defaultLabel == "wipProductCode") && itemSelected){
                  var itemName = itemSelected;
                  var productCode = "";
                  if(itemSelected){
                    itemName = itemSelected.item ? itemSelected.item : "";
                    productCode = itemSelected.productCode;
                  }else{
                    itemName = "";
                  }
                  var ItemQuantities = this.getInventoryTypeQuantity(itemSelected, newSubmission, c, position, components, "inventoryType");
                  switch (component?.defaultLabel) {
                    case "fgProductCode":
                    case "wipProductCode":
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = productCode;
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = productCode;
                      }
                      break;
                    case "item":
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = itemName;
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = itemName;
                      }
                      break;
                    case "lotcode_finished":
                    case "lotcode_wip":
                      // Clear this row's lot only. Do not write itemSelected.lotSelected:
                      // preselection runs later when quantity is filled for the same row.
                      // Store options per row so selecting an item in another row cannot
                      // overwrite sibling rows' lot choice lists.
                      if (position || position === 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = [];
                      } else if (newSubmission[component.id]) {
                        newSubmission[component.id] = [];
                      }
                      if (itemSelected?.items) {
                        this.getItemLots(component?.object_type_id, itemSelected.items, position, component.id);
                      }
                    break;
                    case "description":
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.description;
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.description;
                      }
                      break;
                    case "quantityFinishedGoods":
                    case "quantityWIP":
                      var qty = ItemQuantities ? ItemQuantities?.quantity ? ItemQuantities.quantity : 0 : itemSelected?.amount ? itemSelected?.amount : 0;
                      if(qty % 1 > 0 && !validateDecimals(qty.toString())){
                        qty = qty.toFixed(3);
                      }
                      //For now put 0 instead all inventory available
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = "";
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = "";
                      }
                      break;
                    case "units":
                    case "unitsWIP":
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.units ? itemSelected?.units : "";
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.units ? itemSelected?.units : "";
                      }
                      break;
                    case "rate":
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.itemRate;
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.itemRate;
                      }
                      break;
                    case "amount":
                      var amount = ItemQuantities && itemSelected?.itemRate > 0 ? parseFloat(ItemQuantities?.quantity) * parseFloat(itemSelected?.itemRate) : itemSelected?.itemRate;
                      if (!amount || amount == "NaN") {
                        amount = 0;
                      } else if(amount % 1 > 0 && !validateDecimals(amount.toString())){
                        amount = amount.toFixed(3);
                      }
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = amount;
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = amount;
                      }
                      break;
                    case "tax":
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = "";
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = "";
                      }
                      break;
                    case "class":
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.class;
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.class;
                      }
                      break;
                    case "item_invoice_id":
                    case "item_invoice_id_wip":
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?._id;
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?._id;
                      }
                      break;
                  }
                }else if(c.defaultLabel == "lotcode_finished" || c.defaultLabel == "lotcode_wip"){
                  var lotQuantities = this.getLotsQuantity(value, position, c, submission, "inventoryType");
                  switch (component?.defaultLabel) {
                    case "lotcode_finished":
                    case "lotcode_wip":
                      if(lotQuantities){
                        if(lotQuantities?.valid){
                          valid = lotQuantities?.valid;
                          return;
                        }
                      }
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = value;
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = value;
                      }
                      break;
                    case "quantityFinishedGoods":
                    case "quantityWIP":
                      var qty = lotQuantities ? lotQuantities.quantity : null;
                      if(qty % 1 > 0 && !validateDecimals(qty.toString())){
                        qty = qty.toFixed(3);
                      }
                      if(qty && prepopulate)
                        if (position || position == 0) {
                          if (newSubmission[component.id]) newSubmission[component.id][position] = qty;
                        } else {
                          if (newSubmission[component.id]) newSubmission[component.id][0] = qty;
                        }
                      break;
                    case "rate":
                      if (position || position == 0) {
                        if (newSubmission[component.id]) rate = newSubmission[component.id][position] ? parseFloat(newSubmission[component.id][position]) : 0;
                      } else {
                        if (newSubmission[component.id]) rate = newSubmission[component.id] ? parseFloat(newSubmission[component.id]) : 0;
                      }
                      break;
                    case "amount":
                      var amount = lotQuantities ? parseFloat(lotQuantities?.quantity): 0;
                      var result = 0;
                      if (!amount || amount == "NaN") {
                        amount = 0;
                      }
                      result = rate > 0 && amount > 0 ? (rate * amount) : rate;
                      if(result % 1 > 0 && !validateDecimals(result.toString())){
                        result = result.toFixed(3);
                      }
                      if (position || position == 0) {
                        if (newSubmission[component.id]) newSubmission[component.id][position] = result;
                      } else {
                        if (newSubmission[component.id]) newSubmission[component.id][0] = result;
                      }
                      break;
                  }
                }
              }
            });
          });

          //if(valid){
          //  switch(valid){
          //    case "all_stock":
          //      this.alertConfirm("No inventory available for this item", "Ok");
          //      break;
          //    case "lot_selected":
          //      this.alertConfirm("No inventory available for this item", "Ok");
          //      break;
          //  }
          //  this.setState({ submission: newSubmission, itemComponentChanged: { changed: !resetInventorySearch.changed, position: position }});
          //  return;
          //}
        }
        valid = "";
        if(c?.defaultLabel == "ingredient" || c?.defaultLabel == "rawMaterialProductCode"){

          if (itemSelected && !valid) {
            var ItemQuantities = this.getInventoryTypeQuantity(itemSelected, newSubmission, c, position, components, "ingredient");
            if(ItemQuantities){
              //valid = ItemQuantities?.valid ? ItemQuantities.valid : "";
              //if(valid){
                if (position || position == 0) {
                  if (newSubmission[c.id]) newSubmission[c.id][position] = "";
                } else {
                  if (newSubmission[c.id]) newSubmission[c.id][0] = "";
                }
                // return;
              //}
            }
            components.map(component => {
              if (c.section_id == component.section_id) {
                if(component.defaultLabel == "lotcode"){
                  if (position || position == 0) {
                    var lotSelected = newSubmission[component.id][position];
                    if(typeof lotSelected == "object"){
                      lotSelected = itemSelected?.lotSelected;
                    }else{
                      lotSelected = [itemSelected?.lotSelected];
                    }
                    if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.lotSelected;
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.lotSelected;
                  }
                  this.getItemLots(component?.object_type_id, itemSelected?.items, position, component.id);
                }else if(component.defaultLabel == "ingredient"){
                  if (position || position == 0) {
                    if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.itemName;
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.itemName;
                  }
                }
                else if(component.defaultLabel == "rawMaterialProductCode"){
                  if (position || position == 0) {
                    if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.productCode;
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.productCode;
                  }
                }else if(component.defaultLabel == "quantityIngredient"){
                  var qty = ItemQuantities ? ItemQuantities?.quantity ? ItemQuantities.quantity : 0 : itemSelected?.amount ? itemSelected?.amount : 0;
                  if(qty % 1 > 0  && !validateDecimals(qty.toString())){
                    qty = qty.toFixed(3);
                  }
                  if (position || position == 0) {
                    if (newSubmission[component.id]) newSubmission[component.id][position] = "";
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = "";
                  }
                }else if(component.defaultLabel == "itemDescription"){
                  if (position || position == 0) {
                    if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.description ? itemSelected?.description : "";
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.description ? itemSelected?.description : "";
                  }
                }else{ 
                  if (position || position == 0) {
                    if (newSubmission[component.id]) newSubmission[component.id][position] = component.defaultLabel == "ingredient_id" ? itemSelected?._id : itemSelected[component.defaultLabel];
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = component.defaultLabel == "ingredient_id" ? itemSelected?._id : itemSelected[component.defaultLabel];
                  }
                }
              }
            })
          }
        }else if(c?.defaultLabel == "packagingMaterial" || c?.defaultLabel == "packagingProductCode"){

          if (itemSelected && !valid) {
            var ItemQuantities = this.getInventoryTypeQuantity(itemSelected, newSubmission, c, position, components, "ingredient");
            if(ItemQuantities){
              //valid = ItemQuantities?.valid ? ItemQuantities.valid : "";
              //if(valid){
                if (position || position == 0) {
                  if (newSubmission[c.id]) newSubmission[c.id][position] = "";
                } else {
                  if (newSubmission[c.id]) newSubmission[c.id][0] = "";
                }
                // return;
              //}
            }
            components.map(component => {
              if (c.section_id == component.section_id) {
                if(component.defaultLabel == "lotcode"){
                  if (position || position == 0) {
                    if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.lotSelected;
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.lotSelected;
                  }
                  this.getItemLots(component?.object_type_id, itemSelected?.items, position, component.id);
                }else if(component.defaultLabel == "packagingMaterial"){
                  if (position || position == 0) {
                    if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.namePackaging;
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.namePackaging;
                  }
                }
                else if(component.defaultLabel == "packagingProductCode"){
                  if (position || position == 0) {
                    if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.productCode;
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.productCode;
                  }
                }else if(component.defaultLabel == "units"){
                  if (position || position == 0) {
                    if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.units;
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.units;
                  }
                }
                else if(component.defaultLabel == "quantityPackaging"){
                  var qty = ItemQuantities ? ItemQuantities?.quantity ? ItemQuantities.quantity : 0 : itemSelected?.amount ? itemSelected?.amount : 0;
                  if(qty % 1 > 0  && !validateDecimals(qty.toString())){
                    qty = qty.toFixed(3);
                  }
                  if (position || position == 0) {
                    if (newSubmission[component.id]) newSubmission[component.id][position] = qty;
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = qty;
                  }
                }
                //else if(component.defaultLabel == "itemDescription"){
                //  if (position || position == 0) {
                //    if (newSubmission[component.id]) newSubmission[component.id][position] = itemSelected?.description ? itemSelected?.description : "";
                //  } else {
                //    if (newSubmission[component.id]) newSubmission[component.id][0] = itemSelected?.description ? itemSelected?.description : "";
                //  }
                //}
                else{ 
                  if (position || position == 0) {
                    if (newSubmission[component.id]) newSubmission[component.id][position] = component.defaultLabel == "packaging_id" ? itemSelected?._id : itemSelected[component.defaultLabel];
                  } else {
                    if (newSubmission[component.id]) newSubmission[component.id][0] = component.defaultLabel == "packaging_id" ? itemSelected?._id : itemSelected[component.defaultLabel];
                  }
                }
              }
            })
          }
        }else if(c?.defaultLabel == "lotcode"){
          components.map(component => {
            if ((component.defaultLabel == "quantityIngredient" || component.defaultLabel == "quantityPackaging") && c.section_id == component.section_id) {
              var lotQuantities = this.getLotsQuantity(value, position, c, submission,"ingredient");
              var qty = lotQuantities ? lotQuantities.quantity : null;
              if(qty % 1 > 0 && !validateDecimals(qty.toString())){
                qty = qty.toFixed(3);
              }
              if(lotQuantities){
                if(lotQuantities?.valid){
                  valid = lotQuantities?.valid;
                  return;
                }
              }
              if(qty && prepopulate) 
                if (position || position == 0) {
                  if (newSubmission[component.id]) newSubmission[component.id][position] = qty;
                } else {
                  if (newSubmission[component.id]) newSubmission[component.id][0] = qty;
                }
            }
            //else if(component.defaultLabel == "quantityPackaging" && c.section_id == component.section_id){
            //  var lotQuantities = this.getLotsQuantity(value, position, c, submission,"ingredient");
            //  var qty = lotQuantities ? lotQuantities.quantity : null;
            //  if(qty % 1 > 0 && !validateDecimals(qty.toString())){
            //    qty = qty.toFixed(3);
            //  }
            //  if(lotQuantities){
            //    if(lotQuantities?.valid){
            //      valid = lotQuantities?.valid;
            //      return;
            //    }
            //  }
            //  if(qty && prepopulate)
            //    if (position || position == 0) {
            //      if (newSubmission[component.id]) newSubmission[component.id][position] = qty;
            //    } else {
            //      if (newSubmission[component.id]) newSubmission[component.id][0] = qty;
            //    }
            //} 
          })
        }
        //if(valid){
        //  switch(valid){
        //    case "all_stock":
        //      this.alertConfirm("No inventory available for this item", "Ok");
        //      break;
        //    case "lot_selected":
        //      this.alertConfirm("No inventory available for this item", "Ok");
        //      break;
        //  }
        //  this.setState({ submission: newSubmission, itemComponentChanged: { changed: !resetInventorySearch.changed, position: position }});
        //  return;
        //}
        this.setState({ submission: newSubmission, itemComponentChanged: !itemComponentChanged });
      }
      //Shipment Log Quantity edit
      if(isShipmentLog){
        
        var section = components.find(sect=> sect.section_id == c.section_id && sect.type == "section" && (sect?.defaultLabel == "finishedGoods" || sect?.defaultLabel == "workInProgress"));
        var amountComp = components.find(comp => comp.section_id == c.section_id && comp.type != "section" && comp?.defaultLabel == "amount");
        const isShipmentQtyField =
          c.defaultLabel == "quantityFinishedGoods" ||
          c.defaultLabel == "quantityWIP" ||
          c.defaultLabel == "quantityIngredient" ||
          c.defaultLabel == "quantityPackaging";
        if (isShipmentQtyField) {
          const allocatedByQty = this.validateShipmentQuantityAgainstAllocation(c, position, newSubmission);
          if (allocatedByQty) {
            // Keep the typed quantity so editing it (e.g. 6 → 5) is a real change that
            // can re-trigger lot preselect. Clear lots for this row so sync is not stuck
            // on an already-selected allocated lot.
            const lotComp = this.getLotComponentForQuantityField(c, components);
            if (lotComp && newSubmission[lotComp.id] != null) {
              if (position || position === 0) {
                if (typeof newSubmission[lotComp.id] !== "object") newSubmission[lotComp.id] = [];
                newSubmission[lotComp.id][position] = [];
              } else {
                newSubmission[lotComp.id] = [];
              }
            }
            this.setState({
              submission: newSubmission,
              itemComponentChanged: !itemComponentChanged,
              rerenderTable: !this.state.rerenderTable,
            });
            this.blockAlreadyAllocatedShipmentSelection(allocatedByQty, position);
            return;
          }
        }
        if(section && amountComp){
          if(c.defaultLabel == "quantityFinishedGoods" || (c.defaultLabel == "rate" && section?.defaultLabel == "finishedGoods")){
            var qtyComp = components.find(comp => comp.section_id == c.section_id && comp.type != "section" && comp?.defaultLabel == "quantityFinishedGoods");
            var rateComp = components.find(comp => comp.section_id == c.section_id && comp.type != "section" && comp?.defaultLabel == "rate");
            if(qtyComp && rateComp){
              var qty = (position || position == 0) ? parseFloat(newSubmission[qtyComp.id][position]) : parseFloat(newSubmission[qtyComp.id]);
              var rate = (position || position == 0) ? parseFloat(newSubmission[rateComp.id][position]) : parseFloat(newSubmission[rateComp.id]);
              var amount = qty * rate;
              if(amount > 0){
                if(position || position == 0){
                  newSubmission[amountComp.id][position] = amount.toString();
                }else{
                  newSubmission[amountComp.id] = amount.toString();
                }
              }
            }
          }
          
          if(c.defaultLabel == "quantityWIP" || (c.defaultLabel == "rate" && section?.defaultLabel == "workInProgress")){
              var qtyComp = components.find(comp => comp.section_id == c.section_id && comp.type != "section" && comp?.defaultLabel == "quantityWIP");
              var rateComp = components.find(comp => comp.section_id == c.section_id && comp.type != "section" && comp?.defaultLabel == "rate");
              if(qtyComp && rateComp){
                var qty = (position || position == 0) ? parseFloat(newSubmission[qtyComp.id][position]) : parseFloat(newSubmission[qtyComp.id]);
                var rate = (position || position == 0) ? parseFloat(newSubmission[rateComp.id][position]) : parseFloat(newSubmission[rateComp.id]);
                var amount = qty * rate;
                if(amount > 0){
                  if(position || position == 0){
                    newSubmission[amountComp.id][position] = amount.toString();
                  }else{
                    newSubmission[amountComp.id] = amount.toString();
                  }
                }
              }
          }
        }
        if(prepopulate && isShipmentQtyField){
          this.setState({ submission: newSubmission, checkboxkey: checkboxkey, itemComponentChanged: !itemComponentChanged, quantityChanged: !this.state.quantityChanged, quantityChangedPosition: position, rerenderTable: !this.state.rerenderTable });
          return
        }
        this.setState({
          submission: newSubmission,
          checkboxkey: checkboxkey,
          itemComponentChanged: !itemComponentChanged,
          rerenderTable: !this.state.rerenderTable,
          ...(isShipmentQtyField
            ? { quantityChanged: !this.state.quantityChanged, quantityChangedPosition: position }
            : {}),
        });
        if (itemSelected && this.isItemSelectField(c?.defaultLabel)) this.requestFocusQuantity(position, c.section_id);
      }
      //Production Date Recipe
      if((c.defaultLabel == "production_date") && isRecipe){
        var shelfLifeComponent = components.find(component => component.defaultLabel == "shelfLife");
        if(shelfLifeComponent){
          var days = 0;
          var daysToMultiply = 1;
          var repeat_interval = shelfLifeComponent?.prefilledData?.repeat_interval ? parseFloat(shelfLifeComponent?.prefilledData?.repeat_interval) : "";
          var repeat_frequency = shelfLifeComponent?.prefilledData?.repeat_frequency ? shelfLifeComponent?.prefilledData?.repeat_frequency : "";
          if(repeat_frequency){
            switch(repeat_frequency){
              case "Weeks":
                daysToMultiply = 7;
                break;
              case "Months":
                daysToMultiply = 30;
                break;
              case "Years":
                daysToMultiply = 365;
                break;
            }
          }
          if(repeat_interval && repeat_interval != "NaN"){
            days = daysToMultiply * repeat_interval;
          }
          if(days > 0){
            var productionComponent = components.find(component => component.defaultLabel == "production_date");
            var expirationComponent = components.find(component => component.defaultLabel == "expiration_date");
            if(productionComponent && expirationComponent){
              var productionDate = newSubmission[productionComponent.id]
                ? moment(newSubmission[productionComponent.id]).tz(companyTimezone)
                : "";
              var expirationDate = newSubmission[expirationComponent.id]
                ? moment(newSubmission[expirationComponent.id]).tz(companyTimezone)
                : "";

              if(productionDate && c.defaultLabel == "production_date"){
                expirationDate = productionDate.clone().add(days, 'd');
                expirationDate = expirationDate.format("YYYY-MM-DDTHH:mm");
                newSubmission[expirationComponent.id] = expirationDate;
              }
              this.setState({ submission: newSubmission, itemComponentChanged: !itemComponentChanged });
            }
          }
        }
      }

      // YesNoAll logic
      if (c.type === "yesnoall") {
        var section = components[id].section_id;
        components.forEach((c) => {
          if (c.type === "yesno" && c.section_id === section) {
            if (position || position == 0) {
              if(typeof newSubmission[c.id] != "object")newSubmission[c.id] = [];
              newSubmission[c.id][position] = value;
            } else {
              newSubmission[c.id] = value;
            }
          }
        });
        // force yesno components to remount
        checkboxkey = checkboxkey + 1;
      }
      if (c.type === "lotcode" || c.type === "customlotcode") {
        this.setState({ lotConsecutive: lotConsecutive + 1 })
      }
      if(isInventoryTransfer){
        if((c?.defaultLabel == "item" || c?.defaultLabel == "itemName" || c?.defaultLabel == "rawMaterialProductCode" || c?.defaultLabel == "packagingProductCode" || c?.defaultLabel == "fgProductCode" || c?.defaultLabel == "wipProductCode") && itemSelected){
          var itemName = value;
          var productCode = "";
          if(itemSelected){
            itemName = itemSelected.itemName ? itemSelected.itemName : itemSelected.item ? itemSelected.item : itemSelected.namePackaging ? itemSelected.namePackaging : "";
            productCode = itemSelected.productCode;
          }else{
            itemName = "";
          }
          components.map(component => {
            if (c.section_id == component.section_id) {
              var clearValue = "";
              if(component.defaultLabel == "fromLocation"){
                // Preselect Current Location from oldest inventory (FIFO).
                var fifoLocation =
                  itemSelected?.location ||
                  this.getFifoLocationFromLots(itemSelected?.items);
                if (fifoLocation) {
                  clearValue = this.filterLocations(fifoLocation, inventoryLocations);
                  if (!clearValue?.length) clearValue = [""];
                } else {
                  clearValue = [""];
                }
              } else if(component.defaultLabel == "toLocation"){
                clearValue = [''];
              }else if((component.defaultLabel == "rawMaterialProductCode") ||
                (component.defaultLabel == "packagingProductCode") ||
                (component.defaultLabel == "fgProductCode") ||
                (component.defaultLabel == "wipProductCode")
              ){
                if(productCode){
                  clearValue = productCode;
                }else{
                  clearValue = "";
                }
              }else if(component.defaultLabel == "itemName" || component.defaultLabel == "item"){
                if(itemName){
                  clearValue = {
                    item: itemName,
                    itemName: itemName,
                    type: itemSelected?.type || "",
                    inventoryType: itemSelected?.inventoryCategory || itemSelected?.inventoryType || "",
                    inventoryCategory: itemSelected?.inventoryCategory || itemSelected?.inventoryType || "",
                    _id: itemSelected?._id,
                    productCode: itemSelected?.productCode || productCode || "",
                    units: itemSelected?.units || "",
                    items: itemSelected?.items || [],
                  };
                }
              }else if(
                component.defaultLabel == "type" ||
                component.defaultLabel == "inventoryType"
              ){
                if(component.defaultLabel == "type"){
                  clearValue = itemSelected?.type || "";
                }else{
                  clearValue = itemSelected?.inventoryCategory || itemSelected?.inventoryType || "";
                }
              }else if(
                component.defaultLabel == "ingredient_id" ||
                component.defaultLabel == "item_invoice_id" ||
                component.defaultLabel == "item_invoice_id_wip" ||
                component.defaultLabel == "packaging_id" ||
                component.defaultLabel == "item_id" ||
                component.defaultLabel == "_id"
              ){
                clearValue = itemSelected?._id || "";
              }else if(component.defaultLabel == "lotcode"){
                //Preselect the oldest lot code
                var section = components.find((section)=> section.type == "section" && section.section_id == c.section_id);
                var type = itemSelected?.type || "";
                if (!type) {
                  if(section?.defaultLabel == "rawMaterials"){
                    type = "ingredient";
                  }
                  if(section?.defaultLabel == "finishedGoods"){
                    type = "fg";
                  }
                  if(section?.defaultLabel == "packagingMaterials"){
                    type = "packagingMaterial";
                  }
                  if(section?.defaultLabel == "workInProgress"){
                    type = "wip";
                  }
                }
                clearValue = ["default_lot"];
                if(type){
                  this.getIngredientLotsByName(itemName, type, (lots) => {
                    var qtyComponent = components.find((component)=> c.section_id == component.section_id && component.type != "section" && component.defaultLabel == "quantity");
                    var qty = 0;
                    var fromLocationComponent = components.find(
                      (comp) =>
                        c.section_id == comp.section_id &&
                        comp.type != "section" &&
                        comp.defaultLabel == "fromLocation"
                    );
                    var fifoLocation = lots?.length ? this.getFifoLocationFromLots(lots) : null;
                    var fromLocationValue = [""];

                    if (fromLocationComponent && fifoLocation) {
                      fromLocationValue = this.filterLocations(fifoLocation, inventoryLocations);
                      if (!fromLocationValue?.length) fromLocationValue = [""];
                      if (position || position == 0) {
                        if (newSubmission[fromLocationComponent.id]) {
                          newSubmission[fromLocationComponent.id][position] = fromLocationValue;
                        }
                      } else if (newSubmission[fromLocationComponent.id]) {
                        newSubmission[fromLocationComponent.id] = fromLocationValue;
                      }
                    }

                    // Preselect every lot with stock at the FIFO Current Location (not only oldest).
                    var lotsAtLocation = this.getLotsAtLocation(
                      lots,
                      fifoLocation || (fromLocationValue && fromLocationValue[0]),
                      inventoryLocations
                    );
                    if (lotsAtLocation.length > 0) {
                      clearValue = lotsAtLocation;
                    } else if (lots?.length > 0) {
                      clearValue = [lots[0]];
                    }

                    lotsAtLocation.forEach((lot) => {
                      (lot.historial || []).forEach((h) => {
                        const amt = parseFloat(h?.amount);
                        if (!isNaN(amt)) qty += amt;
                      });
                    });
                    if (!qty && lots[0]?.historial?.length > 0) {
                      lots[0].historial.map((h)=>{
                        const amt = parseFloat(h?.amount);
                        if (!isNaN(amt)) qty += amt;
                      });
                    }
                    if (!qty || qty == "NaN") {
                      qty = 0;
                    } else if(qty % 1 > 0 && !validateDecimals(qty.toString())){
                      qty = qty.toFixed(3);
                    }
                    if (position || position == 0) {
                      if (newSubmission[component.id])newSubmission[component.id][position] = clearValue;
                      if (qtyComponent && newSubmission[qtyComponent?.id])newSubmission[qtyComponent.id][position] = qty;
                    } else {
                      if(newSubmission[component.id])newSubmission[component.id][0] = clearValue;
                      if(qtyComponent && newSubmission[qtyComponent?.id])newSubmission[qtyComponent.id] = qty;
                    }

                    this.setState({ submission: newSubmission, itemComponentChanged: !this.state.itemComponentChanged });
                  })
                }
              } 
              if (position || position == 0) {
                if (newSubmission[component.id]) newSubmission[component.id][position] = clearValue;
              } else {
                if (newSubmission[component.id]) newSubmission[component.id][0] = clearValue;
              }
            }
          });
        }else if(c?.defaultLabel == "lotcode"){
          var qtyComponent = components.find((component)=> c.section_id == component.section_id && component.type != "section" && component.defaultLabel == "quantity");
          var qty = 0;

          if(value[0]?.historial?.length > 0){
            var location = value[0]?.historial[0]?.location;
            var fromLocationComponent = components.find((component)=> c.section_id == component.section_id && component.type != "section" && component.defaultLabel == "fromLocation");
            var fromLocationValue = [];

            if(fromLocationComponent){
              fromLocationValue = this.filterLocations(location, inventoryLocations);
              
              value[0].historial.map((h)=>{
                var location = h?.location ? h.location : null;
                if(location){
                  var existLocation = this.findLocation(location, fromLocationValue);
                  if(existLocation){
                    qty += h.amount;
                  }
                }
              });
              if (!qty || qty == "NaN") {
                qty = 0;
              } else if(qty % 1 > 0 && !validateDecimals(qty.toString())){
                qty = qty.toFixed(3);
              }
              if(position || position == 0) {
                newSubmission[fromLocationComponent.id][position] = fromLocationValue;
                if (qtyComponent && newSubmission[qtyComponent?.id])newSubmission[qtyComponent.id][position] = qty;
              } else {
                newSubmission[fromLocationComponent.id] = fromLocationValue;
                if(qtyComponent && newSubmission[qtyComponent?.id])newSubmission[qtyComponent.id] = qty;
              }
              if(position || position == 0) {
                newSubmission[qtyComponent.id][position] = qty;
              } else {
                newSubmission[qtyComponent.id] = qty;
              }
            }
          }
        }
        this.setState({ submission: newSubmission, itemComponentChanged: !itemComponentChanged });
        if (itemSelected && this.isItemSelectField(c?.defaultLabel)) this.requestFocusQuantity(position, c.section_id);
      }
      if(prepopulate && isRecipe){
        if(value[0]?.historial?.length > 0){
          var location = value[0]?.historial[0]?.location;
          var locationComponent = components.find((component)=> c.section_id == component.section_id && component.type != "section" && component.defaultLabel == "location");
          var filteredInventoryLocations = [];

          if(locationComponent){
            if(value[0]?.historial){
              value[0].historial.map((h)=>{
                if(h?.location){
                  if(h?.location){
                    var location = h?.location;
                    var fromLocationValue = [];
                    this.state.inventoryLocations.map((l) => {
                      var found = true;
                      if(location == "default_location"){ 
                        if(!l?.site?.defaultLocation){
                          found = false;
                        }else{
                          fromLocationValue.push(l);
                          return found;
                        }
                      }
                      if(location?.site?._id){
                        if(l?.site?._id != location?.site?._id){
                          found = false;
                        }else{
                          if(l?.zone?._id && !location?.zone?._id)found = false;
                        }
                      }
                      if(location?.zone?._id){
                        if(l?.zone?._id != location?.zone?._id){
                          found = false;
                        }else{
                          if(l?.aisle?._id && !location?.aisle?._id)found = false;
                        }
                      }
                      if(location?.aisle?._id){
                        if(l?.aisle?._id != location?.aisle?._id){
                          found = false;
                        }else{
                          if(l?.rackBay?._id && !location?.rackBay?._id)found = false;
                        }
                      }
                      if(location?.rackBay?._id){
                        if(l?.rackBay?._id != location?.rackBay?._id){
                          found = false;
                        }else{
                          if(l?.shelfLevel?._id && !location?.shelfLevel?._id)found = false;
                        }
                      }
                      if(location?.shelfLevel?._id){
                        if(l?.shelfLevel?._id != location?.shelfLevel?._id){
                          found = false
                        }else{
                          if(l?.bin?._id && !location?.bin?._id)found = false;
                        }
                      }
                      if(location?.bin?._id){
                        if(l?.bin?._id != location?.bin?._id){
                          found = false
                        }
                      }
                      if(found){
                        fromLocationValue.push(location);
                      }
    
                      return found;
                    });
                    fromLocationValue.map((locationValue)=>{
                      var foundLocation = filteredInventoryLocations.find((l)=>{
                        var found = true;
                        if(locationValue?.site?.defaultLocation){
                          if(!l?.site?.defaultLocation){
                            found = false;
                          }
                        }
                        if(location?.site?._id){
                          if(l?.site?._id != location?.site?._id){
                            found = false;
                          }else{
                            if(l?.zone?._id && !location?.zone?._id)found = false;
                          }
                        }
                        if(location?.zone?._id){
                          if(l?.zone?._id != location?.zone?._id){
                            found = false;
                          }else{
                            if(l?.aisle?._id && !location?.aisle?._id)found = false;
                          }
                        }
                        if(location?.aisle?._id){
                          if(l?.aisle?._id != location?.aisle?._id){
                            found = false;
                          }else{
                            if(l?.rackBay?._id && !location?.rackBay?._id)found = false;
                          }
                        }
                        if(location?.rackBay?._id){
                          if(l?.rackBay?._id != location?.rackBay?._id){
                            found = false;
                          }else{
                            if(l?.shelfLevel?._id && !location?.shelfLevel?._id)found = false;
                          }
                        }
                        if(location?.shelfLevel?._id){
                          if(l?.shelfLevel?._id != location?.shelfLevel?._id){
                            found = false
                          }else{
                            if(l?.bin?._id && !location?.bin?._id)found = false;
                          }
                        }
                        if(location?.bin?._id){
                          if(l?.bin?._id != location?.bin?._id){
                            found = false
                          }
                        }
      
                        return found;
                      });
  
                      if(!foundLocation){
                        filteredInventoryLocations.push(locationValue);
                      }
                    });
                  }
                }
              })
            }
            if(position || position == 0) {
              if(newSubmission[locationComponent.id]){
                newSubmission[locationComponent.id][position] = filteredInventoryLocations[0] ? [filteredInventoryLocations[0]] : [];
              }else{
                newSubmission[locationComponent.id] = [];
                newSubmission[locationComponent.id][position] = filteredInventoryLocations[0] ? [filteredInventoryLocations[0]] : [];
              }
            } else {
              newSubmission[locationComponent.id] = filteredInventoryLocations[0] ? [filteredInventoryLocations[0]] : [];
            }
            this.setState({ submission: newSubmission, itemComponentChanged: !this.state.itemComponentChanged, rerenderTable: !this.state.rerenderTable });
          }
        }
      }
    } else {
      if (subtype) {
        newSubmission[id] = {};
        if (position || position == 0) {
          newSubmission[id][position][subtype] = value;
        } else {
          newSubmission[id][position] = value;
        }
      } else {
        if (position || position == 0) {
          newSubmission[id][position] = value;
        } else {
          newSubmission[id] = value;
        }
      }
      // newSubmission[id] = value;
    }
    const changedComponent = this.getComponentById(id);
    const inventoryQuantityLabels = [
      "quantity",
      "quantityIngredient",
      "quantityPackaging",
      "quantityFinishedGoods",
      "quantityWIP",
    ];
    const shipmentRowField =
      changedComponent?.defaultLabel === "location" ||
      changedComponent?.defaultLabel === "fromLocation" ||
      changedComponent?.defaultLabel === "toLocation" ||
      changedComponent?.type === "itemsbylocation" ||
      changedComponent?.defaultLabel === "quantity";
    const skipTableRerender =
      (this.props.isShipmentByLocation || this.props.isTransferByLocation) &&
      shipmentRowField &&
      !subtype;
    const isLocationField =
      (this.props.isShipmentByLocation || this.props.isTransferByLocation) &&
      changedComponent &&
      (changedComponent.defaultLabel === "location" ||
        changedComponent.defaultLabel === "fromLocation" ||
        changedComponent.defaultLabel === "toLocation");
    var locationItemsFetchUpdate = null;
    if (isLocationField && (position != null || position === 0)) {
      var rawLocation = newSubmission[id]?.[position];
      if (rawLocation != null && rawLocation !== "") {
        var locationValue = Array.isArray(rawLocation) ? rawLocation[0] : rawLocation;
        if (locationValue != null && locationValue !== "") {
          var resolvedLocation = resolveLocationForItemsFetch(locationValue, this.state.inventoryLocations);
          locationItemsFetchUpdate = {
            section_id: changedComponent.section_id,
            position,
            location: (resolvedLocation && typeof resolvedLocation === "object") ? resolvedLocation : locationValue,
            nonce: Date.now(),
          };
        }
      }
    }
    if (this.isInventoryReceivingForm() && inventoryQuantityLabels.includes(changedComponent?.defaultLabel)) {
      newSubmission = syncLotCodesFromQuantityChange(newSubmission, components, changedComponent, position, {
        isReceivingLog,
        isShipmentLog,
        isRecipe,
      });
    }
    this.setState({
      submission: newSubmission,
      checkboxkey: checkboxkey,
      itemComponentChanged: !this.state.itemComponentChanged,
      ...(skipTableRerender ? {} : { rerenderTable: !this.state.rerenderTable }),
      ...(locationItemsFetchUpdate ? { locationItemsFetch: locationItemsFetchUpdate } : {}),
      ...(this.isInventoryReceivingForm() && inventoryQuantityLabels.includes(changedComponent?.defaultLabel) ? {
        quantityChanged: !this.state.quantityChanged,
        quantityChangedPosition: position,
      } : {}),
    });
  }
  getInventoryTypeQuantity(item, submission, c, position, components, type){
    const { inventoryTypes } = this.props;

    var quantity = null;
    var res = null;
    var valid = "";
    var items = submission[c.id];
    const rawMaterials = this.props.items;
    if(item){
      if(item?.items){
        item.items.map((lotCode)=>{
          if(lotCode == item?.lotSelected){
            if(lotCode?.historial){
              lotCode.historial.map((historial)=>{
                if(historial?.amount > 0){
                  quantity += historial?.amount;
                }
              });
            }
          }else if(item?.lotSelected == "default_lot" || item?.lotSelected == ["default_lot"]){
            if(lotCode?.historial){
              lotCode.historial.map((historial)=>{
                if(historial?.amount > 0){
                  quantity += historial?.amount;
                }
              });
            }
          }
        });
        res = {
          quantity,
          valid
        };
      }
    }
    /* if(items){
      items.map((itm, idx)=>{
        if(item?.item == itm && position != idx){
          var itemsSubmissionId = null;
          var inventoryType = type == "inventoryType" ? inventoryTypes.find((inv, idx)=> inv?.item == item?.item) : rawMaterials.find((inv, idx)=> inv?.item == item?.item);

          components.filter(section => (section.section_id == c.section_id && section.type == 'section' && !section.hide && (section?.defaultLabel == "finishedGoods" || section?.defaultLabel == "workInProgress" || section?.label == "Raw Materials"))).map((section, id) => {
            components.filter(component => component.section_id == section.section_id && component.type != 'section').map((component) => {
              switch(component?.defaultLabel){
                case "lotcode_finished":
                case "lotcode_wip":
                case "lotcode":
                    if(submission[component.id][idx] == "default_lot" || submission[component.id][idx] == ["default_lot"]){
                      valid = "all_stock";          
                    }else{
                      var lots = [];
                      if(inventoryType){
                          if((inventoryTypes && type == "inventoryType") || (rawMaterials && type == "ingredient")){
                            lots = submission[component.id][idx];
                            if(lots?.length > 0 && typeof lots == "object"){
                              lots.map((lot)=>{
                                var foundLot = inventoryType?.items?.find((itm)=> itm?.lot == lot?.lot);
                                if(foundLot){
                                  foundLot?.historial.map((h)=>{
                                      if(h?.amount > 0){
                                        quantity = quantity - h.amount;
                                      }
                                  })
                                }
                              })
                            }
                          }
                      }
                    }
                break;
              }
            });
          });
        }
      });
      if(quantity <= 0){
        valid = "all_stock";
      }
      res = {
        quantity,
        valid
      };
    } */
    return res;
  }
  getLotsQuantity(lots, position, component, submission, type){
    const { inventoryTypes, items } = this.props;
    const { components } = this.state;

    var quantity = null;
    var res = null;
    var lotsSelecteds = submission[component.id];
    var valid = "";
    if(lots?.length > 0 && typeof lots == "object"){
        if(lots[0] == "default_lot"){
          var itemComponent =  components.find(c => (c.defaultLabel == "item" || c.defaultLabel == "ingredient") && c.section_id == component.section_id);
          if(itemComponent){
            var item = submission[itemComponent.id] ? submission[itemComponent.id][position] : "";
            var allLots = type == "inventoryType" ? inventoryTypes.find((inv)=> inv?.item == item) : items.find((inv)=> inv?.itemName == item) ;
            if(allLots){
              if(allLots?.items){
                allLots.items.map((lotCode)=>{
                  if(lotCode?.historial){
                    lotCode.historial.map((historial)=>{
                      if(historial?.amount > 0){
                        quantity += historial?.amount;
                      }
                    });
                  }
                })
              }
            }
          }
        }else{
          lots.map((lotCode)=>{
              if(lotsSelecteds){
                lotsSelecteds.map((lotselected, idx)=>{
                  if(idx != position && lotselected && typeof lotselected == "object"){
                    lotselected.map((lS)=>{
                      if(lS?.lot == lotCode?.lot){
                        valid = "lot_selected";
                      }
                    })
                  }else{
                    if(lotselected == lotCode?.lot){
                      valid = "lot_selected";
                    }
                  }
                })
              }
              if(lotCode?.historial){
                lotCode.historial.map((historial)=>{
                  if(historial?.amount > 0){
                    quantity += historial?.amount;
                  }
                });
              }
          });
        }
        
        res = {
          valid,
          quantity,
        };
    }
    return res;
  }
  looksLikeFlatLotOptions(list) {
    if (!Array.isArray(list) || !list.length) return false;
    return list.some((entry) => {
      if (!entry || typeof entry !== "object" || Array.isArray(entry)) return false;
      return (
        entry.lot != null ||
        entry.lotcode != null ||
        entry.historial != null ||
        entry.totalAmount != null ||
        entry.amount != null ||
        entry.batchId != null
      );
    });
  }
  getItemLots(object_type_id, items, position, componentId){
    const { choicelist, shipmentLotOptionsByRow } = this.state;
    const { isShipmentLog } = this.props;
    var newChoicelist = JSON.parse(JSON.stringify(choicelist || {}));
    const list = Array.isArray(items) ? items : [];
    const rowPosition = (position || position === 0) ? position : 0;

    // Shipment tables share one lot component across rows. Keep options keyed by
    // position so selecting Mango on row 1 cannot replace Dulce options on row 0.
    if (isShipmentLog && (position || position === 0)) {
      const choiceKey = componentId != null ? componentId : object_type_id;
      const existing = newChoicelist[choiceKey];
      if (!Array.isArray(existing) || this.looksLikeFlatLotOptions(existing)) {
        newChoicelist[choiceKey] = [];
      }
      newChoicelist[choiceKey][rowPosition] = list;
      if (object_type_id != null && object_type_id !== choiceKey) {
        const byType = newChoicelist[object_type_id];
        if (!Array.isArray(byType) || this.looksLikeFlatLotOptions(byType)) {
          newChoicelist[object_type_id] = [];
        }
        newChoicelist[object_type_id][rowPosition] = list;
      }
      const rowKey = `${choiceKey}:${rowPosition}`;
      this.setState({
        choicelist: newChoicelist,
        shipmentLotOptionsByRow: {
          ...(shipmentLotOptionsByRow || {}),
          [rowKey]: list,
        },
      });
      return;
    }

    newChoicelist[object_type_id] = items;
    this.setState({ choicelist: newChoicelist });
  }

  calculateBatchSize(v, d, submission, components) {
    var newSubmission = JSON.parse(JSON.stringify(submission));

    var yield_section = components.filter((c) => c.defaultLabel == "moreRecipeInformation");
    var ingredients_section = components.filter((c) => c.defaultLabel == "ingredients");
    var packaging_materials_section = components.filter((c) => c.defaultLabel == "packagingMaterials");
    var value = parseFloat(formatStringNumber(v));
    var defaultYield = d ? parseFloat(formatStringNumber(d)) : 1;
    defaultYield = defaultYield ? defaultYield : 1;
    //Check for yield section
    if(yield_section.length > 0){
      var yield_id = components.filter(c => c.section_id == yield_section[0].section_id && c?.defaultLabel == "amount");
      if(yield_id.length > 0){
        if(typeof newSubmission[yield_id[0].id] == "object" && newSubmission[yield_id[0].id]?.length >= 0){
          newSubmission[yield_id[0].id][0] = v;
        }else{
          newSubmission[yield_id[0].id] = v;
        }
      }
    }
    //Check for ingredients
    if (ingredients_section.length > 0) {
      var ingredients_id = components.filter(c => c.section_id == ingredients_section[0].section_id && c.label == "Quantity");
      if (ingredients_id.length > 0) {
        var id = ingredients_id[0].id;
        var qty_sub = submission[id];
        var defaultSubmission = ingredients_section[0]?.defaultSubmission ? ingredients_section[0]?.defaultSubmission : null;
        if(qty_sub && typeof qty_sub == "object" && qty_sub.length > 0)
          qty_sub.map((q, idx) => {
            var val = parseFloat(formatStringNumber(q));
            if (val && value) {
              if (defaultSubmission) {
                var sub = parseFloat(formatStringNumber(defaultSubmission[id][idx]));
                if (sub) {
                  var new_value = (sub / defaultYield) * value;
                  newSubmission[id][idx] = (new_value % 1 > 0 && !validateDecimals(new_value.toString())) ? new_value.toFixed(3) : new_value;
                }
              } else {
                var new_value = (val / defaultYield) * value;
                newSubmission[id][idx] = (new_value % 1 > 0 && !validateDecimals(new_value.toString())) ? new_value.toFixed(3) : new_value;
              }
            }
          });
      }
    }

    //Check for packaging materials
    if (packaging_materials_section.length > 0) {
      var packaging_id = components.filter(c => c.section_id == packaging_materials_section[0].section_id && c.label == "Quantity");
      if (packaging_id.length > 0) {
        var id = packaging_id[0].id;
        var qty_sub = submission[id];
        var defaultSubmission = packaging_materials_section[0]?.defaultSubmission ? packaging_materials_section[0]?.defaultSubmission : null;
        if(qty_sub && typeof qty_sub == "object" && qty_sub.length > 0)
          qty_sub.map((q, idx) => {
            var val = parseFloat(q);
            if (val && value) {
              if (defaultSubmission) {
                var sub = parseFloat(defaultSubmission[id][idx]);
                if (sub) {
                  var new_value = (sub / defaultYield) * value;
                  newSubmission[id][idx] = (new_value % 1 > 0 && !validateDecimals(new_value.toString())) ? new_value.toFixed(3) : new_value;
                }
              } else {
                var new_value = (val / defaultYield) * value;
                newSubmission[id][idx] = (new_value % 1 > 0 && !validateDecimals(new_value.toString())) ? new_value.toFixed(3) : new_value;
              }
            }
          });
      }
    }
    return newSubmission;
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { companyTimezone, isRecipe, newReport, isReceivingLog, isShipmentLog, isOrder } = this.props;
    var submission = {};
    var components = [];
    var choicelist = {};
    var uuid = "";
    var issues = newProps.submissionSelected?.issues
    if (issues) {
      issues = Object.values(issues)
      if (issues.length >= 0) {
        this.setState({ tmpIssues: issues }, this.forceUpdate.bind(this));
      }
    }
    // Initialize right after the form is loaded from network/memory
    if ((!newProps.isLoaded || !this.props.isLoading)) {
      if(!newProps.newReport){
        return;
      }

      var components = JSON.parse(JSON.stringify(newProps.components));
      if(isRecipe){
        var expirationDateComponentIdx = components.findIndex(component => component?.defaultLabel == "expiration_date");
        if(expirationDateComponentIdx > 2){
          components = this.changeArrPositions(components, 2, expirationDateComponentIdx)
        }
      }
      if(isReceivingLog){
        var changeSection = components.find(component => component?.defaultLabel == "ingredients" && component?.type == "section");
        if(changeSection){
          var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantity" && component?.section_id == changeSection?.section_id);
          var refComponentIdx = components.findIndex(component => component?.defaultLabel == "ingredient" && component?.section_id == changeSection?.section_id);
          components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
        }
        changeSection = components.find(component => component?.defaultLabel == "packagingMaterials" && component?.type == "section");
        if(changeSection){
          var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantity" && component?.section_id == changeSection?.section_id);
          var refComponentIdx = components.findIndex(component => component?.defaultLabel == "packagingMaterial" && component?.section_id == changeSection?.section_id);
          components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
        }
      }
      if(isShipmentLog){
        var changeSection = components.find(component => component?.defaultLabel == "finishedGoods" && component?.type == "section");
        if(changeSection){
          var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantityFinishedGoods" && component?.section_id == changeSection?.section_id);
          var refComponentIdx = components.findIndex(component => component?.defaultLabel == "item" && component?.section_id == changeSection?.section_id);
          components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
        }
        changeSection = components.find(component => component?.defaultLabel == "workInProgress" && component?.type == "section");
        if(changeSection){
          var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantityWIP" && component?.section_id == changeSection?.section_id);
          var refComponentIdx = components.findIndex(component => component?.defaultLabel == "item" && component?.section_id == changeSection?.section_id);
          components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
        }
        changeSection = components.find(component => component?.defaultLabel == "rawMaterials" && component?.type == "section");
        if(changeSection){
          var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantityIngredient" && component?.section_id == changeSection?.section_id);
          var refComponentIdx = components.findIndex(component => component?.defaultLabel == "ingredient" && component?.section_id == changeSection?.section_id);
          components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
        }
      }
      if(isOrder){
        var changeSection = components.find(component => component?.label == "Raw Materials" && component?.type == "section");
        if(changeSection){
          var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantity" && component?.section_id == changeSection?.section_id);
          var refComponentIdx = components.findIndex(component => component?.defaultLabel == "ingredient" && component?.section_id == changeSection?.section_id);
          components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
        }
        changeSection = components.find(component => component?.label == "Packaging Materials" && component?.type == "section");
        if(changeSection){
          var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantity" && component?.section_id == changeSection?.section_id);
          var refComponentIdx = components.findIndex(component => component?.defaultLabel == "packagingMaterial" && component?.section_id == changeSection?.section_id);
          components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
        }
      }
      this.setState({
        components: components,
        updatedWizard: !this.state.updatedWizard
      });
      return;
    }

    // Load old submission
    if (!this.props.newReport && !this.props.isSubmission) {
      uuid = this.props.previousSubmissions[this.props.task_id]["uuid"];
      submission = this.props.previousSubmissions[this.props.task_id][
        "submission"
      ];
      components = this.props.previousSubmissions[this.props.task_id][
        "components"
      ];
      choicelist = this.props.previousSubmissions[this.props.task_id][
        "choicelist"
      ];
    }

    if (!this.props.newReport && this.props.isSubmission) {
      uuid = this.props.submissionSelected.uuid;
      submission = this.props.submissionSelected.submission;
      const tmpComponents = this.props.submissionSelected.components;
      choicelist = this.props.submissionSelected.choicelist;
      let indextmpComponents = 0
      tmpComponents.forEach((comp, indx) => {
        let nComponent = { ...comp }
        if (comp.type === "section") {

          newProps.components.forEach(nComp => {
            if (nComp.label === comp.label) {
              if (nComp.attachmentId && typeof nComp.attachmentId !== 'undefined' && typeof nComp.attachmentId !== '' && typeof nComp.attachmentId !== null) {
                nComponent.attachment = nComp.attachment;
                nComponent.attachment_type = nComp.attachment_type
                nComponent.attachmentId = nComp.attachmentId

              }
            }

          });
        }
        components.push(nComponent)
      })
    }

    if ("components" in newProps && "choicelist" in newProps) {
      const date = moment().format("YYYY-MM-DD HH:mm");
      const initialDateTime = moment.tz(date, companyTimezone).tz('UTC').format("YYYY-MM-DD HH:mm");
      // New report
      if (this.props.newReport) {
        components = newProps.components;
        choicelist = newProps.choicelist;
        // components.filter(section => section.type == 'section').forEach((c) => {

        // })
        if(components)
        components.forEach((c) => {
          var tableSect = components.filter(sect => c.section_id == sect.section_id && sect.type == "section" && sect?.direction == "table" && c.type != "section");

          if (tableSect.length > 0) {
            var defaultData = 1;
            var dataType = tableSect[0]?.dataType ? tableSect[0]?.dataType : null;
            if (tableSect[0]?.defaultData > 0) {
              defaultData = tableSect[0]?.defaultData;
            } else {
              defaultData = 1;
            }
            defaultData = defaultData - 1;
            var defaultSubmission = tableSect[0]?.defaultSubmission ? tableSect[0]?.defaultSubmission : {};
            for (var comp = 0; comp <= defaultData; comp++) {
              if (comp == 0) {
                if (c.type === "datetime") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = [defaultSubmission[c.id][comp]];
                    } else if (c.prefilledData) {
                      submission[c.id] = [c.prefilledData];
                    } else {
                      submission[c.id] = [initialDateTime];
                    }
                  } else {
                    submission[c.id] = [initialDateTime];
                  }
                } else if (
                  c.type === "inputlabel" ||
                  c.type === "input" ||
                  c.type === "textarea" ||
                  c.type === "lotecode" ||
                  c.type === "customlotcode" ||
                  c.type === "picture"
                ) {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = [defaultSubmission[c.id][comp]];
                    } else if (c.prefilledData) {
                      submission[c.id] = [c.prefilledData];
                    } else {
                      submission[c.id] = [""];
                    }
                  } else {
                    submission[c.id] = [""];
                  }
                } else if (c.type === "dropdown") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = [defaultSubmission[c.id][comp]];
                    } else if (c.prefilledData) {
                      submission[c.id] = [c.prefilledData];
                    } else {
                      submission[c.id] = [choicelist[c.object_type_id][0]["id"]];
                    }
                  } else {
                    submission[c.id] = [choicelist[c.object_type_id][0]["id"]];
                  }
                } else if (c.type === "signature"
                  || c.type === "timer"
                  || c.type === "timerauto") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = [defaultSubmission[c.id][comp]];
                    } else if (c.prefilledData) {
                      submission[c.id] = [c.prefilledData];
                    } else {
                      submission[c.id] = [0];
                    }
                  } else {
                    submission[c.id] = [0];
                  }
                } else if (c.type == "yesno" || c.type == "yesnoall") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = [defaultSubmission[c.id][comp]];
                    } else if (c.prefilledData) {
                      submission[c.id] = [c.prefilledData];
                    } else {
                      submission[c.id] = [0];
                    }
                  } else {
                    submission[c.id] = [0];
                  }
                }
                else if (c.type == "document") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = [defaultSubmission[c.id][comp]];
                    } else if (c.prefilledData) {
                      submission[c.id] = [c.prefilledData];
                    } else {
                      submission[c.id] = [0];
                    }
                  } else {
                    submission[c.id] = [0];
                  }
                }
                else if (c.type == "chatAI") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = [defaultSubmission[c.id][comp]];
                    } else if (c.prefilledData) {
                      submission[c.id] = [c.prefilledData];
                    } else {
                      submission[c.id] = [{ response: "", question: "" }];
                    }
                  } else {
                    submission[c.id] = [{ response: "", question: "" }];
                  }
                }
                else if (c.type == "inventory") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = [defaultSubmission[c.id][comp]];
                    } else if (c.prefilledData) {
                      submission[c.id] = [c.prefilledData];
                    } else {
                      submission[c.id] = [{ lotcode: "", productname: "", quantity: "" }];
                    }
                  } else {
                    submission[c.id] = [{ lotcode: "", productname: "", quantity: "" }];
                  }
                }
              } else {
                var sub = submission[c.id];
                if (c.type === "datetime") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      // submission[c.id] = [defaultSubmission[c.id][comp]];
                      sub.push(defaultSubmission[c.id][comp]);
                    } else if (c.prefilledData) {
                      sub.push(c.prefilledData);
                    } else {
                      sub.push(initialDateTime);
                    }
                  } else {
                    sub.push(initialDateTime);

                  }
                }
                else if (
                  c.type === "inputlabel" ||
                  c.type === "input" ||
                  c.type === "textarea" ||
                  c.type === "lotecode" ||
                  c.type === "customlotcode" ||
                  c.type === "picture"
                ) {

                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = sub.push(defaultSubmission[c.id][comp]);
                    } else if (c.prefilledData) {
                      submission[c.id] = sub.push(c.prefilledData);
                    } else {
                      submission[c.id] = sub.push("");
                    }
                  } else {
                    submission[c.id] = sub.push("");
                  }
                } else if (c.type === "dropdown") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = sub.push(defaultSubmission[c.id][comp]);
                    } else if (c.prefilledData) {
                      submission[c.id] = sub.push(c.prefilledData);
                    } else {
                      submission[c.id] = sub.push(choicelist[c.object_type_id][0]["id"]);
                    }
                  } else {
                    submission[c.id] = sub.push(choicelist[c.object_type_id][0]["id"]);
                  }
                }
                else if (c.type === "signature"
                  || c.type === "timer"
                  || c.type === "timerauto") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = sub.push(defaultSubmission[c.id][comp]);
                    } else if (c.prefilledData) {
                      submission[c.id] = sub.push(c.prefilledData);
                    } else {
                      submission[c.id] = sub.push(0);
                    }
                  } else {
                    submission[c.id] = sub.push(0);
                  }
                }
                else if (c.type == "yesno" || c.type == "yesnoall") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = sub.push(defaultSubmission[c.id][comp]);
                    } else if (c.prefilledData) {
                      submission[c.id] = sub.push(c.prefilledData);
                    } else {
                      submission[c.id] = sub.push(0);
                    }
                  } else {
                    submission[c.id] = sub.push(0);
                  }
                } else if (c.type == "document") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = sub.push(defaultSubmission[c.id][comp]);
                    } else if (c.prefilledData) {
                      submission[c.id] = sub.push(c.prefilledData);
                    } else {
                      submission[c.id] = sub.push(0);
                    }
                  } else {
                    submission[c.id] = sub.push(0);
                  }
                }
                else if (c.type == "chatAI") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = sub.push(defaultSubmission[c.id][comp]);
                    } else if (c.prefilledData) {
                      submission[c.id] = sub.push(c.prefilledData);
                    } else {
                      submission[c.id] = sub.push({ response: "", question: "" });
                    }
                  } else {
                    submission[c.id] = sub.push({ response: "", question: "" });
                  }
                }
                else if (c.type == "inventory") {
                  if (defaultSubmission[c.id]) {
                    if (defaultSubmission[c.id][comp]) {
                      submission[c.id] = sub.push(defaultSubmission[c.id][comp]);
                    } else if (c.prefilledData) {
                      submission[c.id] = sub.push(c.prefilledData);
                    } else {
                      submission[c.id] = sub.push({ lotcode: "", productname: "", quantity: "" });
                    }
                  } else {
                    submission[c.id] = sub.push({ lotcode: "", productname: "", quantity: "" });
                  }
                }

                submission[c.id] = sub;
              }
            }
          } else {
            if (c.type === "datetime") submission[c.id] = initialDateTime;
            else if (
              c.type === "inputlabel" ||
              c.type === "input" ||
              c.type === "textarea" ||
              c.type === "lotecode" ||
              c.type === "customlotcode" ||
              c.type === "picture"
            ) {
              if (c.prefilledData) {
                submission[c.id] = c.prefilledData;
              } else {
                submission[c.id] = "";
              }
            } else if (c.type === "dropdown") {

              if (c.prefilledData) {
                submission[c.id] = c.prefilledData;
              } else {
                submission[c.id] = choicelist[c.object_type_id][0]["id"];
              }
            }
            else if (c.type === "signature"
              || c.type === "timer"
              || c.type === "timerauto") {
              if (c.prefilledData) {
                submission[c.id] = c.prefilledData;
              } else {
                submission[c.id] = 0;
              }
            } else if (c.type == "yesno" || c.type == "yesnoall") {
              if (c.prefilledData) {
                submission[c.id] = c.prefilledData;
              } else {
                submission[c.id] = 0;
              }
            } else if (c.type == "document") {
              if (c.prefilledData) {
                submission[c.id] = c.prefilledData;
              } else {
                submission[c.id] = 0;
              }
            }
            else if (c.type == "chatAI") {
              if (c.prefilledData) {
                submission[c.id] = c.prefilledData;
              } else {
                submission[c.id] = { response: "", question: "" };
              }
            }
            else if (c.type == "inventory") {
              if (c.prefilledData) {
                submission[c.id] = c.prefilledData;
              } else {
                submission[c.id] = { lotcode: "", productname: "", quantity: "" };
              }
            }
          }
        });
      }
    }
    var productionComponent = components ? components.find(component => component.defaultLabel == "production_date") : null;
    if(productionComponent && components && submission && isRecipe && newReport){
      var shelfLifeComponent = components.find(component => component.defaultLabel == "shelfLife");
        if(shelfLifeComponent){
          var days = 0;
          var daysToMultiply = 1;
          var repeat_interval = shelfLifeComponent?.prefilledData?.repeat_interval ? parseFloat(shelfLifeComponent?.prefilledData?.repeat_interval) : "";
          var repeat_frequency = shelfLifeComponent?.prefilledData?.repeat_frequency ? shelfLifeComponent?.prefilledData?.repeat_frequency : "";
          if(repeat_frequency){
            switch(repeat_frequency){
              case "Weeks":
                daysToMultiply = 7;
                break;
              case "Months":
                daysToMultiply = 30;
                break;
              case "Years":
                daysToMultiply = 365;
                break;
            }
          }
          if(repeat_interval && repeat_interval != "NaN"){
            days = daysToMultiply * repeat_interval;
          }
          if(days > 0){
            var expirationComponent = components.find(component => component.defaultLabel == "expiration_date");
            if(productionComponent && expirationComponent){
              var productionDate = submission[productionComponent.id]
                ? moment(submission[productionComponent.id]).tz(companyTimezone)
                : "";
              var expirationDate = submission[expirationComponent.id]
                ? moment(submission[expirationComponent.id]).tz(companyTimezone)
                : "";
              if(productionDate){
                expirationDate = productionDate.clone().add(days, 'd');
                expirationDate = expirationDate.format("YYYY-MM-DDTHH:mm");
                submission[expirationComponent.id] = expirationDate;
              }
            }
          }
        }
    }
    if(isRecipe && components){
      var expirationDateComponentIdx = components.findIndex(component => component?.defaultLabel == "expiration_date");
      if(expirationDateComponentIdx > 2){
        components = this.changeArrPositions(components, 2, expirationDateComponentIdx)
      }
    }
    if(isReceivingLog && components){
      var changeSection = components.find(component => component?.defaultLabel == "ingredients" && component?.type == "section");
      if(changeSection){
        var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantity" && component?.section_id == changeSection?.section_id);
        var refComponentIdx = components.findIndex(component => component?.defaultLabel == "ingredient" && component?.section_id == changeSection?.section_id);
        components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
      }
      changeSection = components.find(component => component?.defaultLabel == "packagingMaterials" && component?.type == "section");
      if(changeSection){
        var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantity" && component?.section_id == changeSection?.section_id);
        var refComponentIdx = components.findIndex(component => component?.defaultLabel == "packagingMaterial" && component?.section_id == changeSection?.section_id);
        components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
      }
    }
    if(isShipmentLog && components){
      var changeSection = components.find(component => component?.defaultLabel == "rawMaterials" && component?.type == "section");
      if(changeSection){
        var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantityIngredient" && component?.section_id == changeSection?.section_id);
        var refComponentIdx = components.findIndex(component => component?.defaultLabel == "ingredient" && component?.section_id == changeSection?.section_id);
        components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
      }
    }
    if(isShipmentLog && components){
      var changeSection = components.find(component => component?.defaultLabel == "finishedGoods" && component?.type == "section");
      if(changeSection){
        var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantityFinishedGoods" && component?.section_id == changeSection?.section_id);
        var refComponentIdx = components.findIndex(component => component?.defaultLabel == "item" && component?.section_id == changeSection?.section_id);
        components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
      }
      changeSection = components.find(component => component?.defaultLabel == "workInProgress" && component?.type == "section");
      if(changeSection){
        var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantityWIP" && component?.section_id == changeSection?.section_id);
        var refComponentIdx = components.findIndex(component => component?.defaultLabel == "item" && component?.section_id == changeSection?.section_id);
        components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
      }
      changeSection = components.find(component => component?.defaultLabel == "rawMaterials" && component?.type == "section");
      if(changeSection){
        var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantityIngredient" && component?.section_id == changeSection?.section_id);
        var refComponentIdx = components.findIndex(component => component?.defaultLabel == "ingredient" && component?.section_id == changeSection?.section_id);
        components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
      }
    }
    if(isOrder && components){
      var changeSection = components.find(component => component?.label == "Raw Materials" && component?.type == "section");
      if(changeSection){
        var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantity" && component?.section_id == changeSection?.section_id);
        var refComponentIdx = components.findIndex(component => component?.defaultLabel == "ingredient" && component?.section_id == changeSection?.section_id);
        components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
      }
      changeSection = components.find(component => component?.label == "Packaging Materials" && component?.type == "section");
      if(changeSection){
        var changeComponentIdx = components.findIndex(component => component?.defaultLabel == "quantity" && component?.section_id == changeSection?.section_id);
        var refComponentIdx = components.findIndex(component => component?.defaultLabel == "packagingMaterial" && component?.section_id == changeSection?.section_id);
        components = this.changeArrPositions(components, refComponentIdx + 1, changeComponentIdx)
      }
    }
    this.setState({
      submission,
      components: components ? components : [],
      choicelist,
      uuid,
      rerenderTable: !this.state.rerenderTable
    });
  }

  // Do not render when this.state.submissions is modified
  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.props.isLoading !== nextProps.isLoading ||
      this.props.isErrorSave !== nextProps.isErrorSave ||
      this.props.isErrorRetrieve !== nextProps.isErrorRetrieve ||
      this.props.isLoaded !== nextProps.isLoaded ||
      this.props.isSaving !== nextProps.isSaving ||
      this.props.updatedWizard !== nextProps.updatedWizard ||
      this.props.submissionSelected !== nextProps.submissionSelected ||
      this.state.updatedWizard !== nextState.updatedWizard ||
      this.state.lotConsecutive !== nextState.lotConsecutive ||
      this.state.checkboxkey !== nextState.checkboxkey ||
      this.state.rerenderTable != nextState.rerenderTable ||
      this.state.openTableIssue !== nextState.openTableIssue ||
      this.props.inventoryTypes !== nextProps.inventoryTypes ||
      this.props.items !== nextProps.items ||
      this.state.palletComponentChanged !== nextState.palletComponentChanged ||
      this.state.itemComponentChanged !== nextState.itemComponentChanged || 
      this.state.locationItemsFetch !== nextState.locationItemsFetch ||
      this.state.resetInventorySearch !== nextState.resetInventorySearch ||
      this.state.choicelist !== nextState.choicelist ||
      this.state.inventoryLocations !== nextState.inventoryLocations ||
      this.state.dropDownOpen !== nextState.dropDownOpen ||
      this.state.closeSearch !== nextState.closeSearch ||
      this.state.focusedInput_id !== nextState.focusedInput_id || 
      this.state.focusedInput_idx !== nextState.focusedInput_idx ||
      this.state.focusQuantity !== nextState.focusQuantity ||
      this.state.focusComponent !== nextState.focusComponent ||
      this.state.batchSizeChanged !== nextState.batchSizeChanged || 
      this.state.quantityChanged !== nextState.quantityChanged ||
      this.state.quantityChangedPosition !== nextState.quantityChangedPosition ||
      this.state.keyboardLoaded !== nextState.keyboardLoaded ||
      this.state.keyboarWithScandOpened !== nextState.keyboarWithScandOpened ||
      this.state.showLotsByLocation !== nextState.showLotsByLocation ||
      this.state.showTextBar !== nextState.showTextBar ||
      this.state.webKeyboardBottomInset !== nextState.webKeyboardBottomInset ||
      this.state.locationItemsLoading !== nextState.locationItemsLoading || 
      this.state.inventoryLocationsLoading !== nextState.inventoryLocationsLoading

    );
  }

  submitFormSave(status = "in_progress", sendAnyway) {
    const alertInventoryNoOpAfterComplete =
      (this.isInventoryReceivingForm() || this.props.isInventoryTransfer) &&
      this.props.submissionSelected?.status === "edit_required" &&
      !!(this.props.complete_date || this.props.submissionSelected?.complete_date);
    if (this.props.isShipmentLog) {
      const allocatedLot = this.findAlreadyAllocatedInShipmentSubmission(this.state.submission);
      if (allocatedLot) {
        this.showAlreadyAllocatedShipmentAlert(allocatedLot);
        this.setState({ disableButton: false });
        return;
      }
    }
    this.props.startSubmit(
      this.state.components,
      this.state.choicelist,
      this.state.submission,
      this.props.newReport ? uuid.randomUUID() : this.state.uuid,
      this.props.task_id ? this.props.task_id : this.props.submissionSelected?.task_id,
      this.props.isLogGroup ? this.props.logGroupSelected.id : '',
      status,
      this.props.isRecipe ? this.props.isRecipe : null,
      () =>{
        //Navigate te log group or mainview
        this.props.logGroupSelected.id && this.props.isLogGroup ? this.navigateToGroup() : this.props.navigation.navigate('MainView');
      },
      () =>{
        //Retry
        this.submitFormSave(status, true);
      },
      sendAnyway,
      this.props.isInventoryTransfer ? this.props.isInventoryTransfer : null,
      alertInventoryNoOpAfterComplete,
      this.props.isShipmentLog ? this.props.isShipmentLog : null,
    );
    //this.props.logGroupSelected.id && this.props.isLogGroup ? this.navigateToGroup() : this.props.navigation.navigate('MainView');
  }
  checkRecipeLot(components, submission){
    let showLotAlert = false;
    var lotComponent = components.find(component => component.defaultLabel == "lot");
    if(lotComponent){
      if(submission[lotComponent.id]){
        var lots = submission[lotComponent.id];
        var existLot = false;
        lots.map((lot)=>{
          if(lot.trim())existLot = true;
        });
        if(!existLot) showLotAlert = true; 
      }else{
        showLotAlert = true;
      }
    }

    return showLotAlert;
  }
  submitForm = async (status, sendAnyway, checkedRecipeLot) => {
    const { submission, lastStatus } = this.state;
    const { isOrder, formId, isInventoryTransfer, title, components, isRecipe, isShipmentLog} = this.props;
    let cont = 0;
    let labels = [];
    const result = this.state.components.filter(f => f.mandatory === true);
    if(isRecipe && status == "complete" && !checkedRecipeLot){
      if(this.checkRecipeLot(components, submission)){
        confirmationAlert(null, "Looks like this batch doesn't have a lot code. Lot codes help with traceability and tracking.", "Send Anyway", "Add Lot Code", "warning", 'red', null,() => this.submitForm(status, sendAnyway, true), ()=> this.setState({ focusLotCode: true, rerenderTable: !this.state.rerenderTable }, ()=> setTimeout(() => this.setState({ focusLotCode: false, rerenderTable: !this.state.rerenderTable }), 1000)));
        return;
      }
    }
    if (isShipmentLog && (status == "complete" || status == "in_progress" || !status)) {
      const allocatedLot = this.findAlreadyAllocatedInShipmentSubmission(submission);
      if (allocatedLot) {
        this.showAlreadyAllocatedShipmentAlert(allocatedLot);
        return;
      }
    }
    for (let i = 0; i < result.length; i++) {
      let index = result[i]?.id;
      let valueMandatory = this.state.submission[index];
      if (valueMandatory != undefined) {
        if (valueMandatory && (valueMandatory.length > 0 || valueMandatory != 0)) {
          if(typeof valueMandatory == "object" && valueMandatory?.length > 0){
            var addToCount = true;
            valueMandatory.map((valMandatory)=>{
              if (result[i].type === 'inventory') {
                if (valMandatory.lotcode && valMandatory.productname && valMandatory.quantity) {
                  if (valMandatory.lotcode.length > 0 && valMandatory.productname.length > 0 && valMandatory.quantity.length > 0) {
                    // cont++;
                  } else {
                    addToCount = false;
                  }
                } else {
                  addToCount = false;
                }
    
              } else {
                if (valMandatory == undefined) {
                  addToCount = false;
                }else{
                  if (valMandatory.length <= 0 || !valMandatory) {
                    addToCount = false;
                  }
                }
              }
            });
            if(addToCount){
              cont++;
            }else{
              labels.push(result[i].label);
            }
            
          }else{
            if (result[i].type === 'inventory') {
              if (valueMandatory.lotcode && valueMandatory.productname && valueMandatory.quantity) {
                if (valueMandatory.lotcode.length > 0 && valueMandatory.productname.length > 0 && valueMandatory.quantity.length > 0) {
                  cont++;
                } else {
                  labels.push(result[i].label);
                }
              } else {
                labels.push(result[i].label);
              }
  
            } else {
              cont++;
            }
          }
        } else {
          labels.push(result[i].label);
        }
      } else {
        labels.push(result[i].label);
      }
    }
    if (cont === result.length) {
      if(isInventoryTransfer){
        if(!this.checkToLocationOnTransfer(this.state.components, this.state.submission)){
          await this.props.setStatusChange();
          return;
        }
      }
      await this.props.unsetStatusChange();
      let validateIngredients = false
        let validatePackaging = false
        let validateIngredientMember = false
        let validatePackagingMember = false
      if(title == "Receiving Log" && status == "complete"){
        
        for (var i = 0; i < components.length; i++) {
            if(components[i].label == "Name" && components[i].defaultLabel=="ingredient"){
              var componentId = components[i].id
              for (var j = 0; j < submission[componentId].length; j++) {
                if(submission[componentId][j]==""){
                    if(submission[componentId].length == 1){
                        validateIngredients=true;
                    }else{
                        validateIngredientMember=true;
                    }
                  
                }
              }

            }

            if(components[i].label == "Name" && components[i].defaultLabel=="packagingMaterial"){
              var componentId = components[i].id
              for (var j = 0; j < submission[componentId].length; j++) {
                if(submission[componentId][j]==""){
                    if(submission[componentId].length == 1){
                        validatePackaging=true;
                    }else{
                         validatePackagingMember=true;
                    }
                  
                }
              }

            }


        }
        
      
            if(validateIngredientMember){
                Swal.fire({
                  text: "Please make sure you have selected ingredients properly",
                  confirmButtonText: "OK",
                  confirmButtonColor: colors.orange,
                  backdrop: false
                });
                
            }
            if(validatePackagingMember){
                Swal.fire({
                  text: "Please make sure you have selected packaging materials properly",
                  confirmButtonText: "OK",
                  confirmButtonColor: colors.orange,
                  backdrop: false
                });
                
            }
            if(validateIngredients && validatePackaging){
                Swal.fire({
                  text: "Please make sure you have selected ingredients and packaging materials properly",
                  confirmButtonText: "OK",
                  confirmButtonColor: colors.orange,
                  backdrop: false
                });
            }
      }
      if((!validateIngredients && !validatePackaging && !validateIngredientMember && !validatePackagingMember) || (!validateIngredients && validatePackaging && !validateIngredientMember && !validatePackagingMember) || (validateIngredients && !validatePackaging && !validateIngredientMember && !validatePackagingMember)){
          const alertInventoryNoOpAfterComplete =
            (this.isInventoryReceivingForm() || this.props.isInventoryTransfer) &&
            this.props.submissionSelected?.status === "edit_required" &&
            !!(this.props.complete_date || this.props.submissionSelected?.complete_date);
          this.props.startSubmit(
            this.state.components,
            this.state.choicelist,
            this.state.submission,
            this.props.newReport ? uuid.randomUUID() : this.state.uuid,
            this.props.task_id ? this.props.task_id : this.props.submissionSelected?.task_id,
            this.props.isLogGroup ? this.props.logGroupSelected.id : '',
            status,
            this.props.isRecipe ? this.props.isRecipe : null,
            () => {
              if(status == "approved"){
                this.props.approved();
                this.props.navigation.navigate('RecordsView')
              }else{
                this.props.logGroupSelected.id && this.props.isLogGroup ? this.navigateToGroup() : this.props.navigation.navigate('MainView');
              }
            },
            () =>{
              //Retry after insufficient-inventory confirm (skip lot-code alert)
              this.submitForm(status, true, true);
            },
            sendAnyway,
            this.props.isInventoryTransfer ? this.props.isInventoryTransfer : null,
            alertInventoryNoOpAfterComplete,
            this.props.isShipmentLog ? this.props.isShipmentLog : null,
          );
      }
      if (isOrder && status == "complete") {
        this.props.quitOrderForm(formId);
      }
      // this.props.logGroupSelected.id && this.props.isLogGroup ? this.navigateToGroup() : this.props.navigation.navigate('MainView');
    } else {
      await this.props.setStatusChange();
      submission.status = lastStatus;
      this.setState({ submission: submission })
      Swal.fire({
        title: "Please check your form",
        text: "Complete the required fields before submitting the report " + '(' + labels.toString().replaceAll(",", ", ") + ')',
        confirmButtonText: "Ok",
        confirmButtonColor: colors.orange,
        backdrop: false
      }).then((result) => {
        if (result.isConfirmed) {
        }
      })
    }
  }


  navigateToGroup() {
    this.props.setLogGroupsSubAction(),
      this.props.navigation.navigate('GroupView');
  }

  renderIssue(issues, component) {
    let issueComment = "";
    let found = false;
    let issueRender = []
    if (Array.isArray(issues)) {
      issues?.map((issue) => {
        if (issue.id == component.id) {
          issueComment = issue.comment;
          found = true;
          issueRender = issue;
        }
      });
    }
    return found ? issueRender : null;

  }

  printAllIssues(issues, component, pos, fromTable) {
    const { companyTimezone, submissionSelected } = this.props;
    const status = submissionSelected ? submissionSelected.status : "new";
    const locIssues = issues.filter(issue => issue?.id == component?.id);
    var position = pos;
    if (fromTable && pos == null) {
      position = 0;
    }
    return (
      <View style={{ flex: 1 }}>
        {locIssues.map(issue => {
          if (position || position == 0) {
            if (position == issue?.position) {
              return <View style={{ display: 'flex', flexDirection: 'row' }}>
                  <TouchableOpacity style={[styles.issueBox, { flex: 7 }]}>
                    {issue.solved ?
                      <Text style={[styles.issueText, { fontStyle: 'italic', textDecorationLine: 'line-through' }]}>{issue?.comment}</Text> :
                      <Text style={styles.issueText}>{issue?.comment}</Text>}
                  </TouchableOpacity>
                  {!issue.solved &&
                    <TouchableOpacity
                      disabled={status == "archived" || status == "approved"}
                      style={[styles.issueBox, { flex: 1, marginLeft: 5, backgroundColor: '#fff0a3' }]}
                      onPress={() => {
                        const { submissionSelected } = this.props;
                        const commentIndx = issues.findIndex(elem => elem?.comment == issue?.comment && elem?.solved == false)
                        const newIssues = [...issues];
                        newIssues[commentIndx] = {
                          ...issue,
                          solved: true
                        }
                        this.props.loadingIssue(component.id);
                        this.setState({ rerenderTable: !this.state.rerenderTable })
                        this.props.sendSubmit(submissionSelected?._id, newIssues, newIssues[commentIndx].comment, () => {
                          this.props.loadingIssue(null);
                          this.setState({ rerenderTable: !this.state.rerenderTable })
                        });
                      }}
                    >
                      <Text style={styles.issueText}>Solve</Text>
                    </TouchableOpacity>
                  }
                </View>
                {
                  issue.createdBy && issue.createdDate ?
                    <Text style={{ fontSize: 16, fontStyle: 'italic' }}>Created by {issue.createdBy} on {moment(issue.createdDate).tz(companyTimezone).format('YYYY-MM-DD')}</Text>
                    // <Text style={{ fontSize: 16, fontStyle: 'italic' }}>Created by {issue.createdBy} on {this.convertUTCDateToLocalDate(cDate).toLocaleString('en-US')}</Text>

                    : null
                }
                {
                  issue.solvedBy && issue.solvedDate ?
                    <Text style={{ fontSize: 16, fontStyle: 'italic' }}>Solved by {issue.solvedBy} on {moment(issue.solvedDate).tz(companyTimezone).format('YYYY-MM-DD')}</Text>
                    // <Text style={{ fontSize: 16, fontStyle: 'italic' }}>Solved by {issue.solvedBy} on {this.convertUTCDateToLocalDate(sDate).toLocaleString('en-US')}</Text>

                    : null
                }
                <View>

                </View>
            }
            else if (position == 0 && fromTable && !issue?.position) {
              return <View style={{ display: 'flex', flexDirection: 'row' }}>
                  <TouchableOpacity style={[styles.issueBox, { flex: 7 }]}>
                    {issue.solved ?
                      <Text style={[styles.issueText, { fontStyle: 'italic', textDecorationLine: 'line-through' }]}>{issue?.comment}</Text> :
                      <Text style={styles.issueText}>{issue?.comment}</Text>}
                  </TouchableOpacity>
                  {!issue.solved &&
                    <TouchableOpacity
                      disabled={status == "archived" || status == "approved"}
                      style={[styles.issueBox, { flex: 1, marginLeft: 5, backgroundColor: '#fff0a3' }]}
                      onPress={() => {
                        const { submissionSelected } = this.props;
                        const commentIndx = issues.findIndex(elem => elem?.comment == issue?.comment && elem?.solved == false)
                        const newIssues = [...issues];
                        newIssues[commentIndx] = {
                          ...issue,
                          solved: true
                        }
                        this.props.loadingIssue(component.id);
                        this.setState({ rerenderTable: !this.state.rerenderTable })
                        this.props.sendSubmit(submissionSelected?._id, newIssues, newIssues[commentIndx].comment, () => {
                          this.props.loadingIssue(null);
                          this.setState({ rerenderTable: !this.state.rerenderTable })
                        });
                      }}
                    >
                      <Text style={styles.issueText}>Solve</Text>
                    </TouchableOpacity>
                  }
                </View>
                {
                  issue.createdBy && issue.createdDate ?
                    <Text style={{ fontSize: 16, fontStyle: 'italic' }}>Created by {issue.createdBy} on {moment(issue.createdDate).tz(companyTimezone).format('YYYY-MM-DD')}</Text>
                    // <Text style={{ fontSize: 16, fontStyle: 'italic' }}>Created by {issue.createdBy} on {this.convertUTCDateToLocalDate(cDate).toLocaleString('en-US')}</Text>

                    : null
                }
                {
                  issue.solvedBy && issue.solvedDate ?
                    <Text style={{ fontSize: 16, fontStyle: 'italic' }}>Solved by {issue.solvedBy} on {moment(issue.solvedDate).tz(companyTimezone).format('YYYY-MM-DD')}</Text>
                    // <Text style={{ fontSize: 16, fontStyle: 'italic' }}>Solved by {issue.solvedBy} on {this.convertUTCDateToLocalDate(sDate).toLocaleString('en-US')}</Text>

                    : null
                }
                <View>

                </View>
            }
            return null;
          } else {
            return <View style={{ display: 'flex', flexDirection: 'row' }}>
                <TouchableOpacity style={[styles.issueBox, { flex: 7 }]}>
                  {issue.solved ?
                    <Text style={[styles.issueText, { fontStyle: 'italic', textDecorationLine: 'line-through' }]}>{issue?.comment}</Text> :
                    <Text style={styles.issueText}>{issue?.comment}</Text>}
                </TouchableOpacity>
                {!issue.solved &&
                  <TouchableOpacity
                    disabled={status == "archived" || status == "approved"}
                    style={[styles.issueBox, { flex: 1, marginLeft: 5, backgroundColor: '#fff0a3' }]}
                    onPress={() => {
                      const { submissionSelected } = this.props;
                      const commentIndx = issues.findIndex(elem => elem?.comment == issue?.comment && elem?.solved == false )
                      const newIssues = [...issues];
                      newIssues[commentIndx] = {
                        ...issue,
                        solved: true
                      }
                      this.props.loadingIssue(component.id);
                      this.setState({ rerenderTable: !this.state.rerenderTable })
                      this.props.sendSubmit(submissionSelected?._id, newIssues, newIssues[commentIndx].comment, () => {
                        this.props.loadingIssue(null)
                        this.setState({ rerenderTable: !this.state.rerenderTable })
                      });
                    }}
                  >
                    <Text style={styles.issueText}>Solve</Text>
                  </TouchableOpacity>
                }
              </View>
              {
                issue.createdBy && issue.createdDate ?
                  <Text style={{ fontSize: 16, fontStyle: 'italic' }}>Created by {issue.createdBy} on {moment(issue.createdDate).tz(companyTimezone).format('YYYY-MM-DD')}</Text>

                  : null
              }
              {
                issue.solvedBy && issue.solvedDate ?
                  <Text style={{ fontSize: 16, fontStyle: 'italic' }}>Solved by {issue.solvedBy} on {moment(issue.solvedDate).tz(companyTimezone).format('YYYY-MM-DD')}</Text>

                  : null
              }
              <View>

              </View>
          }

        }
        )
        }

      </View>
    )
  }

  callCalculateBatchSize(callback){
    const { defaultYield } = this.props;
    const { batchSizeToCalculate, submission, components, itemComponentChanged } = this.state;

    let newSubmission = JSON.parse(JSON.stringify(submission));
    newSubmission = this.calculateBatchSize(batchSizeToCalculate, defaultYield, newSubmission, components);
    this.setState({ submission: newSubmission, itemComponentChanged: !itemComponentChanged },()=>{
      if(callback)callback();
    });
  }

  batchSizeAlert(callback) {
    Swal.fire({
      text: "Are you sure you want to increase/decrease the ingredients and yield of this recipe?.",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showCancelButton: true,
      confirmButtonColor: colors.orange,
      backdrop: false
    }).then((result) => {
      if (result.isConfirmed) {
        this.callCalculateBatchSize(callback);
      } else {
        this.setState({ batchSizeToCalculate: null },()=>{
          if(callback)callback();
        });
      }
    });
  }

  makeSave(){
    const { submissionSelected, taskSelected, isLogGroup } = this.props;
    const { formLoaded } = this.state;
    const status = submissionSelected ? submissionSelected.status : "new";  

    //Validate Status
    var id = taskSelected ? taskSelected?._id : null;
    if (status == "new" && isLogGroup) {
      this.props.checkLogStatus(id, (statusBD) => {
        if (!statusBD || statusBD == "pending" || statusBD == "edit_required") {
          if (formLoaded && this.state.disableButton == false){   
            this.setState({ disableButton: true });
            setTimeout(()=>{this.submitFormSave('in_progress');
            });
          }
        } else {
          this.props.showLogStatusError(statusBD);
          this.props.navigation.navigate('MainView')
        }
      })
    
    } else {
      if (!id) {
        id = this.props.newReport ? uuid.randomUUID() : this.state.uuid;
      }
      this.props.checkRecordStatus(id, (statusBD) => {
        if (!statusBD || statusBD == "in_progress" || statusBD == "pending" || statusBD == "edit_required") {
          if (formLoaded && this.state.disableButton == false) {
            this.setState({ disableButton: true });
            this.submitFormSave('in_progress');
          }
        } else {
          this.props.showStatusError(statusBD);
          this.props.navigation.navigate('MainView')
        }
      })
    }
  }

  checkBatchForSubmitForm(status){
    const { isRecipe } = this.props;
    const { batchSizeToCalculate } = this.state;
    if(batchSizeToCalculate != null && isRecipe){
      this.batchSizeAlert(()=>{
        if(status)this.submitForm(status);else this.submitForm();
      });
    }else{
      if(status)this.submitForm(status);else this.submitForm();
    }
  }

  checkBatchForSubmitFormSave(status){
    const { isRecipe } = this.props;
    const { batchSizeToCalculate } = this.state;
    if(batchSizeToCalculate != null && isRecipe){
      this.batchSizeAlert(()=>{
        if(status)this.submitFormSave(status);else this.submitFormSave();
      });
    }else{
      if(status)this.submitFormSave(status);else this.submitFormSave();
    }
  }

  showSave() {

    const { submissionSelected, formId, taskSelected, isLogGroup, defaultYield, isRecipe } = this.props;
    const { formLoaded, batchSizeToCalculate, submission, components, itemComponentChanged } = this.state;
    const status = submissionSelected ? submissionSelected.status : "new";    
    if (status != 'archived' && status != 'approved' && status != 'complete')
      return (
        <View style={styles.submitContainer}>
          <TouchableOpacity
            style={styles.button}
            disabled={this.state.disableButton}
            onPress={() => {
              if (this.props.payment_completed) {
                // if(batchSizeToCalculate != null && isRecipe){
                //   this.batchSizeAlert(()=>{
                //     this.makeSave();
                //   });
                // }else{
                  this.updateTimeSubmissions(()=>{
                    this.makeSave();
                  });
                // }
              } else {
                this.setState({ showPaymentInfo: true, callOnSave: true }, () => { this.forceUpdate() });
              }
            }}
          >
            <Text style={styles.buttonText}>
              Save
            </Text>
          </TouchableOpacity>
        </View>
      );
    else if (status != 'complete')
      return (
        <TouchableOpacity style={styles.readOnlyContainer}>
          <Text style={{ alignSelf: "center" }}>This record is read only</Text>
        </TouchableOpacity>
      );


  }

  saveIssue(issue, issues, submissionId, callback) {
    const newIssues = Array.isArray(issues) ? [...issues, issue] : [issue];
    this.props.sendSubmit(submissionId, newIssues, issue.comment, callback);
  }

  convertUTCDateToLocalDate(date) {

    var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

    var offset = date.getTimezoneOffset() / 60;
    var hours = date.getHours();

    newDate.setHours(hours - offset);

    return newDate.toLocaleString('en-US');
  }
  getTableHeaders(components, section_id, defaultLabel, isInventoryReceivingForm) {
    const { isInvoice, isReceivingLog, isShipmentLog, isRecipe, isOrder, isShipmentByLocation, isTransferByLocation, isInventoryTransfer } = this.props;
    var labels = [];
    var sectionLabel = components.find(component => component.section_id == section_id && component.type == 'section') ? components.find(component => component.section_id == section_id && component.type == 'section').label : "";
    this.getSectionTableComponents(components, section_id).map((component) => {
      var label = component.mandatory && component.type != 'datetime' && component.type != 'datetime' ? component?.label + " *" : component?.label;
      if (isInventoryTransfer && defaultLabel == "rawMaterials") {
        if (component?.hide) return;
        if (!this.isInventoryTransferVisibleField(component?.defaultLabel)) return;
        labels.push(this.getInventoryTransferColumnHeader(component?.defaultLabel, label));
        return;
      }
      if(isInventoryReceivingForm && 
        (!isReceivingLog && !isShipmentLog && !isShipmentByLocation && !isTransferByLocation) &&
        (defaultLabel == "ingredients" || defaultLabel == "rawMaterials" || defaultLabel == "packagingMaterials" || defaultLabel == "moreRecipeInformation" || defaultLabel == "finishedGoods" || defaultLabel == "workInProgress" || defaultLabel == "invoiceItems" || defaultLabel == "itemsByLocation" || (isOrder && sectionLabel == "Raw Materials") || (isOrder && sectionLabel == "Packaging Materials"))){
          if(component?.defaultLabel == "ingredient" ||
             component?.defaultLabel == "name" ||
             component?.defaultLabel == "item" ||
             component?.defaultLabel == "packagingMaterial" ||
             component?.defaultLabel == "quantity" || 
             component?.defaultLabel == "quantityIngredient" || 
             component?.defaultLabel == "quantityFinishedGoods" || 
             component?.defaultLabel == "quantityWIP" || 
             component?.defaultLabel == "lotcode" ||
             component?.defaultLabel == "lotcode_finished" ||
             component?.defaultLabel == "lotcode_wip" ||
             (component?.defaultLabel == "amount" && !isInvoice) ||
             component?.defaultLabel == "lot" ||
             (defaultLabel == "moreRecipeInformation"
               ? component?.defaultLabel == "toLocation"
               : component?.defaultLabel == "location")
          ){
            if(!component?.hide){
              if(component?.defaultLabel == "units"){
                labels.push("");
              }else{
                labels.push(label);
              }
            }
          }
      }
      else if((isReceivingLog || isShipmentLog || isShipmentByLocation || isTransferByLocation) && (defaultLabel == "ingredients" || defaultLabel == "packagingMaterials" || defaultLabel == "rawMaterials" || defaultLabel == "finishedGoods" || defaultLabel == "workInProgress" || defaultLabel == "itemsByLocation")){
        if(component?.defaultLabel != "ingredient" && 
           component?.defaultLabel != "item" && 
           component?.type != "itemsbylocation" &&
           component?.defaultLabel != "quantity" && 
           component?.defaultLabel != "quantityIngredient" && 
           component?.defaultLabel != "quantityFinishedGoods" &&
           component?.defaultLabel != "quantityWIP" &&
           component?.defaultLabel != "lotcode" && 
           component?.defaultLabel != "lotcode_finished" && 
           component?.defaultLabel != "lotcode_wip" && 
           component?.defaultLabel != "packagingMaterial" &&
           component?.defaultLabel != "location" &&
           component?.defaultLabel != "fromLocation" &&
           component?.defaultLabel != "toLocation"){
          if(component.hasOwnProperty('hide')){
            if(!component?.hide){
              if(component?.defaultLabel != "units" && component?.defaultLabel != "unitsWIP")labels.push(label);
            }
          }else{
            if(component?.defaultLabel != "units" && component?.defaultLabel != "unitsWIP")labels.push(label);
          }
        }else{
          if (
            (component?.defaultLabel === "toLocation" ||
              component?.defaultLabel === "fromLocation" ||
              component?.defaultLabel === "location") &&
            component?.hide
          ) {
            // Skip hidden location columns
          } else {
            labels.push(label);
          }
        }
      }
      else if (!isInvoice && !isShipmentLog){
        if(!component?.hide){
          labels.push(label);
        }
      }else{
        if (component?.defaultLabel != "item_invoice_id" && component?.defaultLabel != "ingredient_id" && component?.defaultLabel != "item_invoice_id_wip" && component?.defaultLabel != "packaging_id"){
          if(!component?.hide){
            labels.push(label);
          }
        }
      }
    });
    return labels;
  }
  getRowComponents(components, section_id, position, widthArr, backgroundColor, rows, isInventoryReceivingForm) {
    var filteredComponents = [];
    const { isLoadingIssue, submissionSelected, companyTimezone, formSubmission, isPallet, userRole, isRecipe, isInvoice, isShipmentLog, inventoryTypes, isReceivingLog, isInventoryTransfer, items, packagingMaterials, newReport, isOrder, complete_date, isShipmentByLocation, isTransferByLocation } = this.props;
    const { choicelist, checkboxkey, lotConsecutive, submission, resetInventorySearch, dropDownOpen, componentDropDown, closeSearch, focusedInput_id, focusedInput_idx, lotcodeFirstPreselection, focusLotCode, focusQuantity, focusComponent, batchSizeChanged, openBarCodeScanner, rerenderTable, minorAmountAndroid, shipmentLotOptionsByRow } = this.state;
    const submissionId = submissionSelected ? submissionSelected._id : null;
    const status = submissionSelected ? submissionSelected.status : "new";
    let issues = submissionSelected ? submissionSelected.issues : null;
    var tableSect = components.filter(sect => section_id == sect.section_id && sect.type == "section" && sect?.direction == "table");
    var defaultSubmission = {};
    var defaultData = null;
    var wipPositions = [];
    var sectionDefaulLabel = "";
    var section_id = "";

    if (tableSect.length > 0) {
      defaultSubmission = tableSect[0]?.defaultSubmission ? tableSect[0]?.defaultSubmission : {};
      wipPositions = tableSect[0]?.wipPositions ? tableSect[0]?.wipPositions : [];
      if (tableSect[0]?.defaultData) {
        defaultData = tableSect[0]?.defaultData - 1;
      } else {
        defaultData = 0;
      }
      if(tableSect[0]?.defaultLabel){
        sectionDefaulLabel = tableSect[0]?.defaultLabel;
      }
      if(tableSect[0]?.section_id){
        section_id = tableSect[0]?.section_id;
      }
    }
    var componentIdx = 0;
    const mobileScan = Platform.OS !== "web" || isMobileWeb();
    const scannerInput = mobileScan && this.resolveScannerInput();
    this.getSectionTableComponents(components, section_id).map((component, idx) => {
      var initial;
      var disabled = false;
      let new_label;
      var showComponent = true;
      var itemInvoice_id = null;
      var showWipSearch = "";
      var options = [];
      var inventoryLocations = this.state.inventoryLocations;
      switch (component.type) {
        case "customlotcode":
          new_label = `${component.label} - ${component.lotcodetypename}`;
          break;
        case "inventory":
          new_label = `${component.label} - ${component.inventorytypename} Code`;
          break;
        default:
          new_label = `${component.label}`;
      }
      if (component?.dataType) {
        switch (component?.dataType) {
          case "default_data":
            if(isInvoice && (component?.defaultLabel == "quantity")){
              disabled = false;
            }else if (position <= defaultData) {
              disabled = true;
            }else if (position >= defaultData) {
              if ((isInvoice || isShipmentLog) && (component?.defaultLabel == "description" ||
                component?.defaultLabel == "quantity" ||
                component?.defaultLabel == "rate" ||
                component?.defaultLabel == "amount" ||
                component?.defaultLabel == "tax" ||
                component?.defaultLabel == "class")) {
                disabled = true;
              }
            }
            break;
          default:
            if (isPallet && component?.defaultLabel == "status") {
              if (userRole == "HACCP Coordinator" || userRole == "QA Manager" || userRole == "Person In Charge") {
                disabled = false;
              } else {
                disabled = true;
              }
            } else {
              disabled = false;
            }
            break;
        }
      } else {
        if (isPallet && component?.defaultLabel == "status") {
          if (userRole == "HACCP Coordinator" || userRole == "QA Manager" || userRole == "Person In Charge") {
            disabled = false;
          } else {
            disabled = true;
          }
        } else {
          disabled = false;
        }
      }
      if(isRecipe && 
        (sectionDefaulLabel == "ingredients" || sectionDefaulLabel == "packagingMaterials" || sectionDefaulLabel == "preparationInstructions") && 
        (component?.defaultLabel == "units" || component?.defaultLabel == "quantity" || component?.defaultLabel == "ingredient" || component?.defaultLabel == "name" || component?.defaultLabel == "preparationInstructions")){
        disabled = true;
      }
      if (position || position == 0) {
        if (submission[component.id]) {
          if (typeof submission[component.id] == "object" && submission[component.id].length > 0) {
            if (submission[component.id][position] !== undefined) {
              initial = submission[component.id][position]
            } else {
              initial = "";
            }
          } else {
            initial = submission[component.id]
          }
        } else {
          initial = "";
        }
      } else {
        initial = "";
      }
      if (isInvoice || isShipmentLog) {
        itemInvoice_id = components.filter(component => component.section_id == section_id && component.type != 'section').filter((c, idx) => c?.defaultLabel == "lotcode" || c?.defaultLabel == "item_invoice_id_wip");
        
        if (itemInvoice_id.length > 0) {
          itemInvoice_id = itemInvoice_id[0].id;
        }
      }
      if(component?.hide){
        showComponent = false;
      }
      if ((isInvoice || isShipmentLog) && (component?.defaultLabel == "item_invoice_id" || component?.defaultLabel == "ingredient_id" || component?.defaultLabel == "item_invoice_id_wip" || component?.defaultLabel == "packaging_id")) {
        showComponent = false;
      }
      if ((isShipmentLog) && (component?.defaultLabel == "ingredient_id" || component?.defaultLabel == "packaging_id")) {
        showComponent = false;
      }
      if(isRecipe && component?.type == "customlotcode" && wipPositions?.length > 0){
        wipPositions.map((wipPos)=>{
          if(wipPos == position){
            var ingredientComponent = components.filter(component => component.section_id == section_id && component.type != 'section').filter((c, idx) => c?.defaultLabel == "ingredient");
            if(ingredientComponent?.length > 0){
              var ingredientComponentId = ingredientComponent[0].id;
              if(submission[ingredientComponentId]){
                if(submission[ingredientComponentId][position]){
                  showWipSearch = submission[ingredientComponentId][position];
                }
              }
            }
          }
        })
      }
      if (isInventoryTransfer && sectionDefaulLabel == "rawMaterials") {
        showComponent = this.isInventoryTransferVisibleField(component?.defaultLabel) && !component?.hide;
      }
      if(//(isRecipe || isReceivingLog ) 
          isInventoryReceivingForm &&
          (!isReceivingLog && !isShipmentLog && !isShipmentByLocation && !isTransferByLocation) && 
          (sectionDefaulLabel == "ingredients" || sectionDefaulLabel == "rawMaterials" || sectionDefaulLabel == "packagingMaterials" || sectionDefaulLabel == "moreRecipeInformation" || sectionDefaulLabel == "finishedGoods" || sectionDefaulLabel == "workInProgress" || sectionDefaulLabel == "invoiceItems" || sectionDefaulLabel == "itemsByLocation" || (isOrder && tableSect[0]?.label == "Raw Materials") || (isOrder && tableSect[0]?.label == "Packaging Materials"))){
          if(component?.defaultLabel != "ingredient" &&
             component?.defaultLabel != "packagingMaterial" &&
             component?.defaultLabel != "name" &&
             component?.defaultLabel != "item" &&
             component?.defaultLabel != "quantity" &&
             component?.defaultLabel != "quantityIngredient" &&
             component?.defaultLabel != "quantityFinishedGoods" &&
             component?.defaultLabel != "quantityWIP" &&
             component?.defaultLabel != "lotcode" &&
             component?.defaultLabel != "lotcode_finished" &&
             component?.defaultLabel != "lotcode_wip" &&
             (component?.defaultLabel != "amount" || (isInvoice && component?.defaultLabel == "amount")) &&
             component?.defaultLabel != "lot" &&
             !(sectionDefaulLabel == "moreRecipeInformation"
               ? component?.defaultLabel == "toLocation"
               : component?.defaultLabel == "location")
          ){
            showComponent = false;
          }
      }
      if((isReceivingLog || isShipmentLog || isShipmentByLocation || isTransferByLocation) && (sectionDefaulLabel == "ingredients" || sectionDefaulLabel == "packagingMaterials" || sectionDefaulLabel == "rawMaterials" || sectionDefaulLabel == "finishedGoods" || sectionDefaulLabel == "workInProgress" || sectionDefaulLabel == "itemsByLocation")){
        if(
          component?.defaultLabel != "ingredient" && 
           component?.defaultLabel != "item" && 
           component?.type != "itemsbylocation" &&
           component?.defaultLabel != "quantity" && 
           component?.defaultLabel != "quantityIngredient" && 
           component?.defaultLabel != "quantityFinishedGoods" &&
           component?.defaultLabel != "quantityWIP" &&
           component?.defaultLabel != "lotcode" && 
           component?.defaultLabel != "lotcode_finished" && 
           component?.defaultLabel != "lotcode_wip" && 
           component?.defaultLabel != "packagingMaterial" &&
           component?.defaultLabel != "location" &&
           component?.defaultLabel != "fromLocation" &&
           component?.defaultLabel != "toLocation"){
          if(component?.hide){
            showComponent = false;
          }else{
            if(component?.defaultLabel != "units" && component?.defaultLabel != "unitsWIP")
              showComponent = true;
            else 
              showComponent = false;
          }
        }else{
          if (
            (component?.defaultLabel === "toLocation" ||
              component?.defaultLabel === "fromLocation" ||
              component?.defaultLabel === "location") &&
            component?.hide
          ) {
            showComponent = false;
          } else {
            showComponent = true;
          }
        }
      }
      /* if(isReceivingLog &&
        (sectionDefaulLabel == "ingredients" || sectionDefaulLabel == "packagingMaterials") &&
        (component?.defaultLabel == "rawMaterialProductCode" || component?.defaultLabel == "units" || component?.defaultLabel == "price" || component?.defaultLabel == "packagingProductCode" || component?.defaultLabel == "preparationInstructions")
      ){
        disabled = true;
      } */
      if (showComponent) {
        // Inventory Transfer Current Location modal must always receive the full
        // location catalog (same as empty row). Do not filter by item/lot historial.
        // Yield (moreRecipeInformation) toLocation uses the full catalog like receiving toLocation.
        if(isRecipe && component?.defaultLabel == "location" && sectionDefaulLabel != "moreRecipeInformation"){
          var lotComponent = components.find(component => component.section_id == section_id && component.type != 'section' && component?.defaultLabel == "lotcode");
          if(lotComponent){
            var lotSelected = [];
            if(position || position == 0) {
              if(submission[lotComponent.id]){
                lotSelected = submission[lotComponent.id][position];
              }
            } else {
              lotSelected = submission[lotComponent.id];
            }
            if(lotSelected?.length > 0 && typeof lotSelected == "object"){
              var filteredInventoryLocations = [];
              lotSelected.map((lot)=>{
                var gotTransfers = false;
                if(lot != "default_lot"){
                  if(lot?.historial){
                    lot.historial.map((h)=>{
                      if(h?.location){
                        var location = h?.location;
                        if(location != "default_location")gotTransfers = true;
                        var fromLocationValue = [];
                        this.state.inventoryLocations.map((l) => {
                          var found = true;
                          if(location == "default_location"){
                            if(!l?.site?.defaultLocation){
                              found = false;
                            }else{
                              fromLocationValue.push(l);
                              return found;
                            }
                          }
                          if(location?.site?._id){
                            if(l?.site?._id != location?.site?._id){
                              found = false;
                            }else{
                              if(l?.zone?._id && !location?.zone?._id)found = false;
                            }
                          }
                          if(location?.zone?._id){
                            if(l?.zone?._id != location?.zone?._id){
                              found = false;
                            }else{
                              if(l?.aisle?._id && !location?.aisle?._id)found = false;
                            }
                          }
                          if(location?.aisle?._id){
                            if(l?.aisle?._id != location?.aisle?._id){
                              found = false;
                            }else{
                              if(l?.rackBay?._id && !location?.rackBay?._id)found = false;
                            }
                          }
                          if(location?.rackBay?._id){
                            if(l?.rackBay?._id != location?.rackBay?._id){
                              found = false;
                            }else{
                              if(l?.shelfLevel?._id && !location?.shelfLevel?._id)found = false;
                            }
                          }
                          if(location?.shelfLevel?._id){
                            if(l?.shelfLevel?._id != location?.shelfLevel?._id){
                              found = false
                            }else{
                              if(l?.bin?._id && !location?.bin?._id)found = false;
                            }
                          }
                          if(location?.bin?._id){
                            if(l?.bin?._id != location?.bin?._id){
                              found = false
                            }
                          }
                          if(found){
                            fromLocationValue.push(location);
                          }
        
                          return found;
                        });
                        fromLocationValue.map((locationValue)=>{
                          var foundLocation = filteredInventoryLocations.find((l)=>{
                            var found = true;
                            if(locationValue?.site?.defaultLocation){
                              if(!l?.site?.defaultLocation){
                                found = false;
                              }
                            }
                            if(location?.site?._id){
                              if(l?.site?._id != location?.site?._id){
                                found = false;
                              }else{
                                if(l?.zone?._id && !location?.zone?._id)found = false;
                              }
                            }
                            if(location?.zone?._id){
                              if(l?.zone?._id != location?.zone?._id){
                                found = false;
                              }else{
                                if(l?.aisle?._id && !location?.aisle?._id)found = false;
                              }
                            }
                            if(location?.aisle?._id){
                              if(l?.aisle?._id != location?.aisle?._id){
                                found = false;
                              }else{
                                if(l?.rackBay?._id && !location?.rackBay?._id)found = false;
                              }
                            }
                            if(location?.rackBay?._id){
                              if(l?.rackBay?._id != location?.rackBay?._id){
                                found = false;
                              }else{
                                if(l?.shelfLevel?._id && !location?.shelfLevel?._id)found = false;
                              }
                            }
                            if(location?.shelfLevel?._id){
                              if(l?.shelfLevel?._id != location?.shelfLevel?._id){
                                found = false
                              }else{
                                if(l?.bin?._id && !location?.bin?._id)found = false;
                              }
                            }
                            if(location?.bin?._id){
                              if(l?.bin?._id != location?.bin?._id){
                                found = false
                              }
                            }
          
                            return found;
                          });
    
                          if(!foundLocation){
                            filteredInventoryLocations.push(locationValue);
                            inventoryLocations = filteredInventoryLocations;
                          }
                        });
                      }
                    })
                    if(!gotTransfers){
                      var defaultLocation = this.state.inventoryLocations.filter((l) => {
                        var found = false;
                        if(l?.site?.defaultLocation){
                          found = true;
                        }
      
                        return found;
                      });
    
                      inventoryLocations = defaultLocation;
                    }
                  }
                }else{
                  var itemComponent = components.find(component => component.section_id == section_id && component.type != 'section' && (component?.defaultLabel == "itemName" || component?.defaultLabel == "item" || (isRecipe && component?.defaultLabel == "ingredient") || (isRecipe && component?.defaultLabel == "name")));
                  if(itemComponent){
                    var name = submission[itemComponent.id][position] ? submission[itemComponent.id][position] : "";
                    var item = null;
                    var lots = [];
                    if(sectionDefaulLabel == "rawMaterials"){
                      item = items.find((i)=> i?.itemName == name);
                    }else if(sectionDefaulLabel == "finishedGoods"){
                      item = inventoryTypes.find((i)=> i?.item == name);
                    }else if(sectionDefaulLabel == "packagingMaterials"){
                      item = packagingMaterials.find((i)=> i?.namePackaging == name);
                    }else if(sectionDefaulLabel == "workInProgress"){
                      item = inventoryTypes.find((i)=> i?.item == name);
                    }else if(isRecipe && sectionDefaulLabel == "ingredients"){
                      item = items.find((i)=> i?.itemName == name);
                    }

                    if(item){
                      if(item?.items){
                        lots = item.items;
                      }
                      if(lots?.length > 0){
                        lots.map((lot)=>{
                          if(lot?.historial?.length > 0){
                            lot.historial.map((h)=>{
                              if(h?.location){
                                var location = h?.location;
                                if(location != "default_location")gotTransfers = true;
                                var fromLocationValue = [];
                                this.state.inventoryLocations.map((l) => {
                                  var found = true;
                                  if(location == "default_location"){
                                    if(!l?.site?.defaultLocation){
                                      found = false;
                                    }else{
                                      fromLocationValue.push(l);
                                      return found;
                                    }
                                  }
                                  
                                  if(location?.site?._id){
                                    if(l?.site?._id != location?.site?._id){
                                      found = false;
                                    }else{
                                      if(l?.zone?._id && !location?.zone?._id)found = false;
                                    }
                                  }
                                  if(location?.zone?._id){
                                    if(l?.zone?._id != location?.zone?._id){
                                      found = false;
                                    }else{
                                      if(l?.aisle?._id && !location?.aisle?._id)found = false;
                                    }
                                  }
                                  if(location?.aisle?._id){
                                    if(l?.aisle?._id != location?.aisle?._id){
                                      found = false;
                                    }else{
                                      if(l?.rackBay?._id && !location?.rackBay?._id)found = false;
                                    }
                                  }
                                  if(location?.rackBay?._id){
                                    if(l?.rackBay?._id != location?.rackBay?._id){
                                      found = false;
                                    }else{
                                      if(l?.shelfLevel?._id && !location?.shelfLevel?._id)found = false;
                                    }
                                  }
                                  if(location?.shelfLevel?._id){
                                    if(l?.shelfLevel?._id != location?.shelfLevel?._id){
                                      found = false
                                    }else{
                                      if(l?.bin?._id && !location?.bin?._id)found = false;
                                    }
                                  }
                                  if(location?.bin?._id){
                                    if(l?.bin?._id != location?.bin?._id){
                                      found = false
                                    }
                                  }
                
                                  if(found){
                                    fromLocationValue.push(location);
                                  }

                                  return found;
                                });
                                fromLocationValue.map((locationValue)=>{
                                  var foundLocation = filteredInventoryLocations.find((l)=>{
                                    var found = true;
                                    if(locationValue?.site?.defaultLocation){
                                      if(!l?.site?.defaultLocation){
                                        found = false;
                                      }
                                    }

                                    if(location?.site?._id){
                                      if(l?.site?._id != location?.site?._id){
                                        found = false;
                                      }else{
                                        if(l?.zone?._id && !location?.zone?._id)found = false;
                                      }
                                    }
                                    if(location?.zone?._id){
                                      if(l?.zone?._id != location?.zone?._id){
                                        found = false;
                                      }else{
                                        if(l?.aisle?._id && !location?.aisle?._id)found = false;
                                      }
                                    }
                                    if(location?.aisle?._id){
                                      if(l?.aisle?._id != location?.aisle?._id){
                                        found = false;
                                      }else{
                                        if(l?.rackBay?._id && !location?.rackBay?._id)found = false;
                                      }
                                    }
                                    if(location?.rackBay?._id){
                                      if(l?.rackBay?._id != location?.rackBay?._id){
                                        found = false;
                                      }else{
                                        if(l?.shelfLevel?._id && !location?.shelfLevel?._id)found = false;
                                      }
                                    }
                                    if(location?.shelfLevel?._id){
                                      if(l?.shelfLevel?._id != location?.shelfLevel?._id){
                                        found = false
                                      }else{
                                        if(l?.bin?._id && !location?.bin?._id)found = false;
                                      }
                                    }
                                    if(location?.bin?._id){
                                      if(l?.bin?._id != location?.bin?._id){
                                        found = false
                                      }
                                    }
                  
                                    return found;
                                  });
            
                                  if(!foundLocation){
                                    filteredInventoryLocations.push(locationValue);
                                    inventoryLocations = filteredInventoryLocations;
                                  }
                                });
                              }
                            })
                          }
                        });
                        if(!gotTransfers){
                          var defaultLocation = this.state.inventoryLocations.filter((l) => {
                            var found = false;
                            if(l?.site?.defaultLocation){
                              found = true;
                            }
          
                            return found;
                          });
        
                          inventoryLocations = defaultLocation;
                        }
                      }
                    }
                  }
                }
                
              })
            }
            var defaultLocationIdx = inventoryLocations.findIndex((loc)=> loc?.site?.defaultLocation == true);
            if(defaultLocationIdx > 0){
              var dL = inventoryLocations.splice(defaultLocationIdx, 1);
              if(dL){
                inventoryLocations.splice(0, 0, dL[0]);
              }
            }

            // if(inventoryLocations?.length > 0){
            //   inventoryLocations = this.sortLocations(inventoryLocations);
            // }
          }
        }
        var lotCodeList = []
        if(component?.defaultLabel == "lotcode" && component.type == "customlotcode" && isRecipe && component?.object_type_id){
          var choiceListForComponent = choicelist[component.object_type_id];
          if(choiceListForComponent && choiceListForComponent[position]){
            lotCodeList = choiceListForComponent[position];
          }
        }
        if (
          isShipmentLog &&
          (component?.defaultLabel == "lotcode" ||
            component?.defaultLabel == "lotcode_finished" ||
            component?.defaultLabel == "lotcode_wip")
        ) {
          const rowKey = `${component.id}:${position || position === 0 ? position : 0}`;
          if (shipmentLotOptionsByRow && Array.isArray(shipmentLotOptionsByRow[rowKey])) {
            lotCodeList = shipmentLotOptionsByRow[rowKey];
          } else {
            const choiceListForComponent = choicelist[component.object_type_id] || choicelist[component.id];
            if (
              choiceListForComponent &&
              (position || position === 0) &&
              Array.isArray(choiceListForComponent[position]) &&
              !this.looksLikeFlatLotOptions(choiceListForComponent)
            ) {
              lotCodeList = choiceListForComponent[position];
            }
          }
        }
        filteredComponents.push(
          <View key={component.id} style={component.type == "dropdown" ? { zIndex: componentDropDown == component.id ? 20 : 1, padding: 3, width: widthArr[componentIdx], backgroundColor, overflow: "visible", position: "relative" } : this.getShipmentMobileTableCellStyle(backgroundColor, widthArr[componentIdx])} onStartShouldSetResponder={()=> {
            this.resetDropDown();
          }}>
            {
              isLoadingIssue != null && component.id == isLoadingIssue ?
                <ActivityIndicator key={idx} size={150} color="rgb(0, 47, 108)"></ActivityIndicator>
                :
                <>
                  <View style={{ zIndex: componentDropDown == component.id ? 2 : 1 }}>
                  <FormComponent
                    id={component.id}
                    type={component.type}
                    key={`${component.id}-${position}`}
                    label={component.type == "inventory" ? new_label : ''}
                    placeholder={component.placeholder ? component.placeholder : ""}
                    componentLink={component.componentLink ? component.componentLink : ""}
                    enabledLink={component.enabledLink ? component.enabledLink : ""}
                    initial={initial}
                    onChange={(id, value, subtype, position, prepopulate, item) => {
                      if(component.type == "time" || component.type == "timer"){
                        this.onTimeComponentChange(id, value, position);
                      }else{
                        this.onComponentChange(id, value, subtype, position, prepopulate, item)
                      }
                    }}
                    options={(lotCodeList.length > 0 && (isRecipe || isShipmentLog)) ? lotCodeList : choicelist[component.object_type_id]}
                    checkboxkey={checkboxkey}
                    status={submissionSelected ? submissionSelected.status : false}
                    submissionSelected={submissionSelected ? submissionSelected : null}
                    showLotGenerator={component.showLotGenerator ? component.showLotGenerator : null}
                    lotConsecutive={lotConsecutive}
                    customlot={false}
                    isIssuable={submissionId != null}
                    onSubmitIssue={(issue) => {
                      this.props.loadingIssue(component.id);
                      this.saveIssue({ ...issue, position: position }, issues, submissionId)
                      setTimeout(() => {
                        this.props.loadingIssue(null);
                      }, 1000)
                    }}
                    openIssue={() => {
                      this.setState({
                        openTableIssue: true,
                        compIssueId: component.id,
                        issueLabel: '',
                        issuePosition: position,
                        issueWidth: component?.width ? component?.width : "small",
                        rerenderTable: !this.state.rerenderTable
                      });
                    }}
                    companyTimezone={companyTimezone}
                    position={position}
                    width={component?.width ? component?.width : "small"}
                    defaultComponent={(status == 'archived' || status == 'approved') || formSubmission || this.isFormLockedCompleted() ? true : disabled}
                    closeIssue={() => {
                      this.setState({ rerenderTable: !this.state.rerenderTable });
                    }}
                    showInventorySearch={component?.showInventorySearch || (isRecipe && component?.defaultLabel == "lotcode" && (sectionDefaulLabel == "ingredients" || sectionDefaulLabel == "packagingMaterials" )) || (isInvoice && component?.defaultLabel == "lotcode")}
                    showFinishedGoodsSearch={component?.showFinishedGoodsSearch}
                    showWorkInProgressSearch={component?.showWorkInProgressSearch}
                    showItemsSearch={component?.showItemsSearch || (isRecipe && (component?.defaultLabel == "ingredient") && (sectionDefaulLabel == "ingredients"))}
                    showPackagingSearch={component?.showPackagingSearch || (isRecipe && (component?.defaultLabel == "name") && (sectionDefaulLabel == "packagingMaterials" ))}
                    defaultLabel={component?.defaultLabel}
                    isRecipe={isRecipe}
                    isInvoice={isInvoice}
                    submission={submission}
                    itemInvoice_id={itemInvoice_id}
                    isShipmentLog={isShipmentLog}
                    resetInventorySearch={resetInventorySearch}
                    showWipSearch={showWipSearch}
                    components={components}
                    inventoryTypes={inventoryTypes}
                    searchClients={component?.searchClients}
                    searchSuppliers={isReceivingLog && component?.defaultLabel == "approvedSupplier"}
                    section_id={section_id}
                    isInventoryTransfer={isInventoryTransfer}
                    inventoryLocations={inventoryLocations}
                    newReport={newReport}
                    openDropDown={(pos, options)=>{
                      this.openDropDown(pos, component.section_id, component.id, options);
                    }}
                    backgroundColor={backgroundColor}
                    isLast={position == rows}
                    isDropDownOpened={position == dropDownOpen && componentDropDown == component.id}
                    showProductCodeSearch={component.showProductCodeSearch}
                    resetDropDown={()=> {
                      this.resetDropDown();
                    }}
                    closeSearch={closeSearch}
                    setFocusedInput={()=> this.setFocusedInput(component.id, position)}
                    setTableSearchOpen={(isOpen)=> this.setTableSearchOpen(component.id, position, isOpen)}
                    focused={(focusedInput_id == component.id && focusedInput_idx == position)}
                    addRmLine={(newQty, newLineLotcode)=> this.addRmLine(newQty, newLineLotcode, position)}
                    lotcodeFirstPreselection={lotcodeFirstPreselection}
                    isInventoryReceivingForm={isInventoryReceivingForm}
                    inventoryTableDesign={!!(isInventoryReceivingForm || (isInventoryTransfer && tableSect[0] && this.isDefaultSection(tableSect[0])))}
                    handleFocusOnElement={this.moveScrollToElement}
                    focusLotCode={focusLotCode}
                    focusQuantity={focusQuantity}
                    focusComponent={focusComponent}
                    isReceivingLog={isReceivingLog}
                    batchSizeChanged={batchSizeChanged}
                    quantityChanged={this.state.quantityChanged}
                    defaultYield={this.props.defaultYield}
                    updateComponentLotCodeschoiceList={(id, list, position) => this.updateComponentLotCodeschoiceList(id, list, position)}
                    complete_date={complete_date}
                    quantityChangedPosition={this.state.quantityChangedPosition}
                    showScanner={this.getLocationScanShowScanner(mobileScan, component, isInventoryTransfer)}
                    scannerInput={scannerInput}
                    setShowTextBar={(id, pos, options, ingredientName, value, units, amount, openLotsView, hideLotsView) =>
                      this.setShowTextBar(id, pos, options, ingredientName, value, units, amount, openLotsView, hideLotsView)
                    }
                    openBarCodeScanner={openBarCodeScanner != null && component.id == openBarCodeScanner?.id && openBarCodeScanner.position == position}
                    setOpenBarcode={(val) => this.setOpenBarcode(val)}
                    setFormScroll={(value) => this.setFormScroll(value)}
                    minorAmountAndroid={minorAmountAndroid?.find((item) => item.id == component.id && item.position == position)}
                    rerenderTable={rerenderTable}
                    showLocationsSearch={this.shouldUseLocationScanForComponent(component)}
                    isShipmentByLocation={isShipmentByLocation}
                    isTransferByLocation={isTransferByLocation}
                    onLocationItemsLoadingChange={this.usesLocationShipmentLoading() ? this.setLocationItemsLoading : undefined}
                    onLocationResolved={(location) => this.requestLocationItemsFetch(section_id, position, location)}
                    locationItemsFetch={this.state.locationItemsFetch}
                    onInventoryTransferLocationSave={(rows, pos) => this.applyInventoryTransferLocationSave(rows, pos)}
                    alreadyAllocatedShipmentLots={this.props.alreadyAllocatedShipmentLots}
                    currentSubmissionId={submissionSelected?._id}
                    shouldSuppressLotQtySync={() =>
                      !!(this._suppressLotQtySyncUntil && Date.now() < this._suppressLotQtySyncUntil)
                    }
                  />
                  </View>
                  {issues && this.renderIssue(issues, component) != null ? <View style={{
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: 10,
                    marginBottom: 10,
                    zIndex: 1
                  }}>
                    {this.printAllIssues(issues, component, position, true)}
                  </View> : null}
                </>
            }

          </View>
        )
        componentIdx++;
      }
    })

    return filteredComponents;
  }

  renderRows(rows, components, section_id, section, isInventoryReceivingForm) {
    const { dropDownOpen } = this.state;
    const { isRecipe, isShipmentByLocation, isTransferByLocation } = this.props;
    var renderedRows = [];
    var widthArr = this.getCellArrayWidth(components, section_id, isInventoryReceivingForm);
    const shipmentMobileTable = this.usesMobileInventoryTableLayout();
    const useInventoryTableDesign = this.usesInventoryFormTableDesign(section);
    const formLocked = this.isFormLockedCompleted();
    for (let i = 0; i <= rows; i++) {
      renderedRows.push(<View key={i} style={{ backgroundColor: 'white', display: "flex", flexDirection: "row", flexWrap: shipmentMobileTable ? "nowrap" : undefined, alignItems: shipmentMobileTable ? "flex-start" : undefined, zIndex: i == dropDownOpen ? 100 : 0, overflow: "visible" }}>
          {(!(isRecipe && this.isDefaultSection(section)) || (isRecipe && section?.defaultLabel == "moreRecipeInformation")) && <TouchableOpacity style={{...styles.btnAdd, backgroundColor: i % 2 == 0 && !useInventoryTableDesign ? '#EDEEEE' : 'white', ...(shipmentMobileTable ? { width: 32, flexShrink: 0 } : {})}}
            disabled={formLocked || ((i + 1) <= section?.defaultData && section?.defaultData > 1)}
            onPress={() => {  
              var rows = this.checkForRows(components, section_id);
              this.restTableRow(section.section_id, rows ? false : true, i);
              this.resetDropDown();
            }}
          >
            {!formLocked && ((i + 1) > section?.defaultData || section?.defaultData <= 1) && <View style={styles.iconContainer}>
              <MaterialCommunityIcons
                name={"plus-circle-outline"}
                style={{
                  fontSize: 30,
                  color: colors.quit,
                  transform: [{ rotate: '45deg' }],
                  ...(useInventoryTableDesign ? {} : { marginLeft: -10 }),
                }}
              />
            </View>}
          </TouchableOpacity>
          }
          {this.getRowComponents(components, section_id, i, widthArr, i % 2 == 0 && !useInventoryTableDesign ? '#EDEEEE' : 'white', rows, isInventoryReceivingForm)}
      </View>);
    }

    return renderedRows; 
  }

  getCellArrayWidth(components, section_id, isInventoryReceivingForm) {
    const { isInvoice, isShipmentLog, isRecipe, isReceivingLog, isShipmentByLocation, isTransferByLocation, isInventoryTransfer } = this.props;
    var widthArray = [];
    var w = 150;
    var section = components.find((section) => section.type == "section" && section.section_id == section_id);
    this.getSectionTableComponents(components, section_id).map((component, idx) => {
      var showComponent = true;
      if ((isInvoice || isShipmentLog) && (component?.defaultLabel == "item_invoice_id" || component?.defaultLabel == "ingredient_id" || component?.defaultLabel == "item_invoice_id_wip" || component?.defaultLabel == "packaging_id")) {
        showComponent = false;
      }
      if(component?.hide){
        showComponent = false;
      }

      if (isInventoryTransfer && section?.defaultLabel == "rawMaterials") {
        if (this.isInventoryTransferVisibleField(component?.defaultLabel) && !component?.hide) {
          widthArray.push(this.getInventoryTableFitColumnWidth(components, section_id, section?.defaultLabel));
        }
        return;
      }

      if(isInventoryReceivingForm && 
        section?.direction == 'table' 
        && section?.defaultLabel != "preparationInstructions"
        //(section?.defaultLabel == "ingredients" || section?.defaultLabel == "packagingMaterials" || section?.defaultLabel == "moreRecipeInformation")
      ){
        // Yield section: only API toLocation (not legacy location).
        if (section?.defaultLabel == "moreRecipeInformation" && component?.defaultLabel == "location") {
          showComponent = false;
        }
        if((component?.defaultLabel != "ingredient" &&
           component?.defaultLabel != "packagingMaterial" &&
           component?.defaultLabel != "name" &&
           component?.defaultLabel != "item" &&
           component?.defaultLabel != "quantity" &&
           component?.defaultLabel != "quantityIngredient" &&
           component?.defaultLabel != "quantityFinishedGoods" &&
           component?.defaultLabel != "quantityIngredient" &&
           component?.defaultLabel != "quantityWIP" &&
           component?.defaultLabel != "lotcode" &&
           component?.defaultLabel != "lotcode_finished" &&
           component?.defaultLabel != "lotcode_wip" &&
           component?.defaultLabel != "location" &&
           component?.defaultLabel != "fromLocation" &&
           component?.defaultLabel != "toLocation" &&
           component?.type != "itemsbylocation") && (!isReceivingLog && !isShipmentLog)
        ){
          if(
            component?.defaultLabel != "amount" &&
            component?.defaultLabel != "lot"
          ){
            showComponent = false;
          }else{
            if (section?.defaultLabel == "moreRecipeInformation") {
              widthArray.push(this.getInventoryTableFitColumnWidth(components, section_id, section?.defaultLabel));
            } else {
              widthArray.push(this.getLocationByFormColumnWidth(components, section_id));
            }
            return;
          }
        }else if(isShipmentByLocation || isTransferByLocation){
          widthArray.push(this.getLocationByFormColumnWidth(components, section_id));
          return;
        }else{
          if (!showComponent) {
            return;
          }
          if(isReceivingLog || isShipmentLog){
            widthArray.push(this.getInventoryTableFitColumnWidth(components, section_id, section?.defaultLabel));
          }else if(isRecipe && section?.defaultLabel == "moreRecipeInformation"){
            widthArray.push(this.getInventoryTableFitColumnWidth(components, section_id, section?.defaultLabel));
          }else if(!isRecipe){
            widthArray.push("30%");
          }else{
            widthArray.push("33.333%");
          }
          return;
        }
      }else if(isRecipe && component?.defaultLabel == "preparationInstructions")widthArray.push("100%");

      if (showComponent) {
        switch (component?.width) {
          case 'mini':
            w = 134;
            break;
          case 'small':
            w = 200;
            break;
          case 'medium':
            w = 300;
            break;
          case 'large':
            w = 480;
            break;
          default:
            w = 200;
            break;
        }
        widthArray.push(w);
      }
    });
    return widthArray;
  }

  checkForRows(components, section_id) {
    const { submission } = this.state;
    var rowNumber = null;
    components.filter(component => component.section_id == section_id && component.type != 'section').map((component) => {
      if(component?.defaultLabel != "item_invoice_id_wip"){
        var sub = submission[component.id];
        if (typeof sub === 'object' && sub?.length) {
          rowNumber = sub.length;
        }
      }
    })
    if (!rowNumber) {
      rowNumber = 1;
    }
    return rowNumber - 1;
  }
  restTableRow(section_id, firstRow, idx) {
    if (this.isFormLockedCompleted()) return;
    const { companyTimezone } = this.props;
    const { submission, components, resetInventorySearch } = this.state;
    var newSubmission = JSON.parse(JSON.stringify(submission));
    const date = moment().format("YYYY-MM-DD HH:mm");
    const initialDateTime = moment.tz(date, companyTimezone).tz('UTC').format("YYYY-MM-DD HH:mm");

    components.filter(component => component.type != 'section' && component.section_id == section_id).map((component) => {
      if (submission[component.id]) {
        if (typeof submission[component.id] == "object" && submission[component.id].length > 0) {
          if(firstRow){
            switch (component.type) {
              case "datetime":
                if (newSubmission[component.id][0]) {
                  if (component.prefilledData) {
                    newSub[component.id][0] = component.prefilledData;
                  } else {
                    newSubmission[component.id][0] = initialDateTime;
                  }
                }
                break;
              case "dropdown":
                if (newSubmission[component.id][0]) {
                  if (component.prefilledData) {
                    newSubmission[component.id][0] = component.prefilledData;
                  } else {
                    newSubmission[component.id][0] = "";
                  }
                }
                break;
              case
                "signature",
                "timer",
                "timerauto",
                "document":
                if (newSubmission[component.id][0]) {
                  if (component.prefilledData) {
                    newSubmission[component.id][0] = component.prefilledData;
                  } else {
                    newSubmission[component.id][0] = 0;
                  }
                }
                break;
              case "yesno",
                "yesnoall":
                if (newSubmission[component.id][0]){
                  if (component.prefilledData) {
                    newSubmission[component.id][0] = component.prefilledData;
                  } else {
                    newSubmission[component.id][0] = 0;
                  }
                }
                break;
              default:
                if (newSubmission[component.id][0]){
                  if (component.prefilledData) {
                    newSubmission[component.id][0] = component.prefilledData;
                  } else {
                    newSubmission[component.id][0] = "";
                  }
                }
              break;
            }
          }else{
            if(idx == null){
              newSubmission[component.id].splice(submission[component.id].length - 1, 1);
            }else{
              newSubmission[component.id].splice(idx, 1);
            }
          }
        }
      }
    });
    if (firstRow) {
      const resetPosition = idx != null ? idx : 0;
      this.setState({
        submission: newSubmission,
        rerenderTable: !this.state.rerenderTable,
        resetInventorySearch: {
          changed: !resetInventorySearch.changed,
          position: resetPosition,
        },
        showTextBar: null,
        keyboarWithScandOpened: false,
      });
      return;
    }
    this.setState({ submission: newSubmission, rerenderTable: !this.state.rerenderTable });

  }

  addTableRow(section_id, choicelist) {
    if (this.isFormLockedCompleted()) return;
    const { companyTimezone } = this.props;
    const { submission, components } = this.state;
    const date = moment().format("YYYY-MM-DD HH:mm");
    const initialDateTime = moment.tz(date, companyTimezone).tz('UTC').format("YYYY-MM-DD HH:mm");
    var newSubmission = JSON.parse(JSON.stringify(submission));
    var reachLimit = false;
    var limit = 30;
    components.filter(component => component.type != 'section' && component.section_id == section_id).map((component) => {
      var sub = submission[component.id];
      if(reachLimit)return;
      if (typeof sub === 'object' && sub.length > 0) {
        if(sub.length >= limit){
          reachLimit = true;
          return;
        }
        switch (component.type) {
          case "datetime":
            if (component.prefilledData) {
              newSubmission[component.id].push(component.prefilledData);
            } else {
              newSubmission[component.id].push(initialDateTime);
            }
            break;
          case "dropdown":
            if (component.prefilledData) {
              newSubmission[component.id].push(component.prefilledData);
            } else {
              newSubmission[component.id].push(choicelist[component.object_type_id][0]["id"]);
            }
            break;
          case
            "signature",
            "timer",
            "timerauto",
            "document":
            if (component.prefilledData) {
              newSubmission[component.id].push(component.prefilledData);
            } else {
              newSubmission[component.id].push(0);
            }
            break;
          case "yesno",
            "yesnoall":
            if (component.prefilledData) {
              newSubmission[component.id].push(component.prefilledData);
            } else {
              newSubmission[component.id].push(0);
            }
            break;
          default:
            if (component.prefilledData) {
              newSubmission[component.id].push(component.prefilledData);
            } else if (component.type === "itemsbylocation") {
              newSubmission[component.id].push([]);
            } else {
              newSubmission[component.id].push("");
            }
            break;
        }
      } else {
        var rowEmptyValue = component.type === "itemsbylocation" ? [] : "";
        var newSub;
        if (Array.isArray(sub)) {
          newSub = sub.length > 0 ? [...sub] : [rowEmptyValue];
        } else {
          newSub = [sub != null && sub !== "" ? sub : rowEmptyValue];
        }
        switch (component.type) {
          case "datetime":
            if (component.prefilledData) {
              newSub.push(component.prefilledData);
            } else {
              newSub.push(initialDateTime);
            }
            break;
          case "dropdown":
            if (component.prefilledData) {
              newSub.push(component.prefilledData);
            } else {
              newSub.push(choicelist[component.object_type_id][0]["id"]);
            }
            break;
          case
            "signature",
            "timer",
            "timerauto",
            "document":
            if (component.prefilledData) {
              newSub.push(component.prefilledData);
            } else {
              newSub.push(0);
            }
            break;
          case "yesno",
            "yesnoall":
            if (component.prefilledData) {
              newSub.push(component.prefilledData);
            } else {
              newSub.push(0);
            }
            break;
          default:
            if (component.prefilledData) {
              newSub.push(component.prefilledData);
            } else if (component.type === "itemsbylocation") {
              newSub.push([]);
            } else {
              newSub.push("");
            }
            break;
        }
        newSubmission[component.id] = newSub;
      }
    })
    if(reachLimit){
      this.alertConfirm("Sorry, the maximum limit of lines is 30", "Accept");
      return;
    }
    this.setState({ submission: newSubmission, rerenderTable: !this.state.rerenderTable, lotcodeFirstPreselection: true })
  }

  /**
   * Inventory Transfer Current Location modal Save:
   * write one table row per lot (each lot may have its own toLocation).
   */
  applyInventoryTransferLocationSave(rows, startPosition) {
    const { components, submission, itemComponentChanged } = this.state;
    const { inventoryLocations } = this.props;
    if (!rows?.length) return;
    const start = startPosition || startPosition === 0 ? startPosition : 0;
    const section = components.find(
      (c) => c.type === "section" && c.defaultLabel === "rawMaterials" && c.direction === "table"
    );
    if (!section) return;
    const section_id = section.section_id;
    let newSubmission = JSON.parse(JSON.stringify(submission));
    const sectionComponents = components.filter(
      (c) => c.type !== "section" && c.section_id == section_id
    );
    const neededLength = start + rows.length;

    sectionComponents.forEach((component) => {
      if (!Array.isArray(newSubmission[component.id])) {
        const current = newSubmission[component.id];
        newSubmission[component.id] =
          current != null && current !== "" ? [current] : [component.type === "itemsbylocation" ? [] : ""];
      }
      while (newSubmission[component.id].length < neededLength) {
        if (component.defaultLabel === "fromLocation" || component.defaultLabel === "toLocation") {
          newSubmission[component.id].push([""]);
        } else if (component.defaultLabel === "lotcode") {
          newSubmission[component.id].push([""]);
        } else if (component.type === "itemsbylocation") {
          newSubmission[component.id].push([]);
        } else {
          newSubmission[component.id].push("");
        }
      }
    });

    rows.forEach((row, idx) => {
      const position = start + idx;
      sectionComponents.forEach((component) => {
        const label = component.defaultLabel;
        let value = newSubmission[component.id][position];
        if (label === "itemName" || label === "item" || label === "ingredient" || label === "name") {
          value = row.item || "";
        } else if (label === "fromLocation") {
          const raw = Array.isArray(row.fromLocation) ? row.fromLocation[0] : row.fromLocation;
          if (raw) {
            const filtered = this.filterLocations(raw, inventoryLocations || []);
            value = filtered?.length ? filtered : typeof raw === "object" ? [raw] : [""];
          } else {
            value = [""];
          }
        } else if (label === "toLocation") {
          value = row.toLocation || [""];
        } else if (label === "lotcode") {
          value = row.lotcode || [""];
        } else if (label === "quantity") {
          value = row.quantity != null ? row.quantity : "";
        } else if (label === "type") {
          value = row.item?.type || "";
        } else if (label === "inventoryType") {
          value = row.item?.inventoryType || "";
        } else if (
          label === "ingredient_id" ||
          label === "item_invoice_id" ||
          label === "item_invoice_id_wip" ||
          label === "packaging_id" ||
          label === "item_id" ||
          label === "_id"
        ) {
          value = row.item?._id || "";
        } else if (
          label === "rawMaterialProductCode" ||
          label === "packagingProductCode" ||
          label === "fgProductCode" ||
          label === "wipProductCode"
        ) {
          value = row.item?.productCode || "";
        }
        newSubmission[component.id][position] = value;
      });
    });

    this.setState({
      submission: newSubmission,
      rerenderTable: !this.state.rerenderTable,
      itemComponentChanged: !itemComponentChanged,
    });
  }

  editTableRows(defaultData, section_id, defaultSubmission, dataType) {
    const { components, submission, choicelist } = this.state;
    const { companyTimezone } = this.props;
    var actualRows = this.checkForRows(components, section_id) + 1;
    var newSub = JSON.parse(JSON.stringify(submission));
    var newComponents = JSON.parse(JSON.stringify(components));
    const date = moment().format("YYYY-MM-DD HH:mm");
    const initialDateTime = moment.tz(date, companyTimezone).tz('UTC').format("YYYY-MM-DD HH:mm");
    newComponents.map((component) => {
      if (component.type == 'section' && component.section_id == section_id) {
        component.dataType = dataType;
      }
    })
    components.filter(section => section.type != 'section' && section.section_id == section_id).map((component) => {
      var sub = newSub[component.id];

      if (Object.entries(defaultSubmission).length > 0) {
        if (defaultSubmission[component.id]) {
          defaultSubmission[component.id].map((defaultSub, defaultIndex) => {
            if (defaultSub.changed) {
              if(component.type == "dropdown"){
                if(choicelist[component.object_type_id] && typeof choicelist[component.object_type_id] == "object"){
                  choicelist[component.object_type_id].map((opt)=>{
                    if(opt.value == defaultSub.value){
                      sub[defaultIndex] = opt.id;
                    }
                  })
                }
              }else{
                sub[defaultIndex] = defaultSub.value;
              }
            }
          })
        }
      }

      if (actualRows > defaultData) {
        var dif = actualRows - defaultData;
        for (let i = 0; i <= (dif - 1); i++) {
          sub.splice(sub.length - 1, 1)
        }
      } else if (defaultData > actualRows) {
        var dif = defaultData - actualRows;
        for (let i = 0; i <= (dif - 1); i++) {

          switch (component.type) {
            case "datetime":
              sub.push(initialDateTime);
              break;
            case "dropdown":
              sub.push(choicelist[component.object_type_id][0]["id"]);
              break;
            case
              "signature",
              "timer",
              "timerauto",
              "document":
              sub.push(0);
              break;
            case "yesno",
              "yesnoall":
              sub.push(0);
              break;
            default:
              sub.push("");
              break;
          }
        }
      }
      newSub[component.id] = sub;
    });
    this.setState({ submission: newSub, components: newComponents, rerenderTable: !this.state.rerenderTable });
  }
  alertConfirm(msg, conf) {
      Swal.fire({
          text: msg,
          confirmButtonText: conf,
          confirmButtonColor: '#0B4DA0',
          backdrop: false
      });
  }
  extractShipmentLotEntries(value) {
    if (value == null || value === "") return [];
    if (typeof value === "string") {
      const lot = value.trim();
      if (!lot || lot === "default_lot") return [];
      return [{ lot, available: 0, selectedQty: 0 }];
    }
    if (Array.isArray(value)) {
      return value.reduce((acc, entry) => acc.concat(this.extractShipmentLotEntries(entry)), []);
    }
    if (typeof value === "object") {
      const lot = (value.lot || value.lotcode || "").toString().trim();
      let available = 0;
      let selectedQty = 0;
      if (Array.isArray(value.historial) && value.historial.length) {
        value.historial.forEach((batch) => {
          if (batch?.hide) return;
          const stock = parseFloat(batch.amount);
          if (stock > 0) available += stock;
          // Empty amount while editing is 0 — do not fall back to full stock
          // (that incorrectly flagged clearing the input as exceeding remaining).
          let edited = 0;
          if (batch.editedAmount != null && batch.editedAmount !== "") {
            edited = parseFloat(batch.editedAmount);
          } else if (batch.editedAmount === undefined) {
            edited = stock;
          }
          if (edited > 0) selectedQty += edited;
        });
      } else {
        available = parseFloat(value.totalAmount != null ? value.totalAmount : value.amount) || 0;
        if (!(available > 0)) available = 0;
        if (value.editedAmount != null && value.editedAmount !== "") {
          selectedQty = parseFloat(value.editedAmount) || 0;
        } else if (value.editedAmount === "") {
          selectedQty = 0;
        } else if (value.quantity != null && value.quantity !== "") {
          selectedQty = parseFloat(value.quantity) || 0;
        } else {
          selectedQty = available;
        }
      }
      if (!(available > 0)) {
        const stock = getLotStockAmount(value);
        if (stock > 0) available = stock;
      }
      // Skip pure FIFO placeholders with no stock; keep inventory rows even when lot is "".
      if ((!lot || lot === "default_lot") && !(available > 0) && !(selectedQty > 0)) return [];
      return [{
        lot: lot === "default_lot" ? "" : lot,
        batchId: value.batchId || value._id || value.id || null,
        quantity: selectedQty,
        available,
        selectedQty,
        isNew: !!value.isNew,
        raw: value,
      }];
    }
    return [];
  }
  resolveShipmentLotAvailable(selected, lotComponent, position) {
    if (selected?.available > 0) return selected.available;
    if (selected?.raw) {
      const fromRaw = getLotStockAmount(selected.raw);
      if (fromRaw > 0) return fromRaw;
    }
    const lotNorm = (selected?.lot || "").toString().trim().toLowerCase();
    const options = this.getShipmentLotOptions(lotComponent, position);
    if (!options.length) return 0;
    const match = options.find((opt) => {
      if (!opt) return false;
      if (selected?.batchId) {
        const optId = opt.batchId || opt._id || opt.id || null;
        if (optId && optId === selected.batchId) return true;
      }
      if (!lotNorm) return false;
      return (opt.lot || "").toString().trim().toLowerCase() === lotNorm;
    });
    return match ? getLotStockAmount(match) : 0;
  }
  /**
   * Resolve flat lot options for a shipment row.
   * choicelist may be flat [...lots] or position-indexed [row0Lots, row1Lots].
   */
  getShipmentLotOptions(lotComponent, position) {
    if (!lotComponent) return [];
    const { choicelist, shipmentLotOptionsByRow } = this.state;
    const looksLikeLotOption = (entry) => {
      if (!entry || typeof entry !== "object" || Array.isArray(entry)) return false;
      return (
        entry.lot != null ||
        entry.lotcode != null ||
        entry.historial != null ||
        entry.totalAmount != null ||
        entry.amount != null ||
        entry.isNew === true
      );
    };
    const mergeLots = (lists) => {
      const merged = [];
      const seen = {};
      (lists || []).forEach((list) => {
        if (!Array.isArray(list)) return;
        list.forEach((entry) => {
          if (!looksLikeLotOption(entry)) return;
          const key = [
            (entry.lot || entry.lotcode || "").toString().trim().toLowerCase(),
            entry.batchId || entry._id || entry.id || "",
            entry.totalAmount != null ? entry.totalAmount : entry.amount != null ? entry.amount : "",
          ].join("|");
          if (seen[key]) return;
          seen[key] = true;
          merged.push(entry);
        });
      });
      return merged;
    };

    const candidates = [];
    const rowKey = `${lotComponent.id}:${position || position === 0 ? position : 0}`;
    if (shipmentLotOptionsByRow && Array.isArray(shipmentLotOptionsByRow[rowKey])) {
      candidates.push(shipmentLotOptionsByRow[rowKey]);
    }

    [lotComponent.object_type_id, lotComponent.id].filter(Boolean).forEach((key) => {
      const raw = choicelist?.[key];
      if (!Array.isArray(raw) || !raw.length) return;
      if ((position || position === 0) && Array.isArray(raw[position]) && raw[position].some(looksLikeLotOption)) {
        candidates.push(raw[position]);
      }
      if (raw.some(looksLikeLotOption)) candidates.push(raw);
      raw.forEach((entry) => {
        if (Array.isArray(entry) && entry.some(looksLikeLotOption)) candidates.push(entry);
      });
    });

    return mergeLots(candidates);
  }
  getShipmentRowItemName(lotComponent, position, submission) {
    if (!lotComponent) return "";
    const { components } = this.state;
    let nameLabels = ["ingredient", "packagingMaterial", "item", "itemName"];
    if (lotComponent.defaultLabel === "lotcode_finished" || lotComponent.defaultLabel === "lotcode_wip") {
      nameLabels = ["item", "itemName"];
    }
    const nameComp = components.find(
      (c) => c.section_id === lotComponent.section_id && nameLabels.indexOf(c.defaultLabel) >= 0
    );
    if (!nameComp || !submission) return "";
    const val = submission[nameComp.id];
    if (position || position === 0) {
      return val && val[position] != null ? val[position] : "";
    }
    if (Array.isArray(val)) return val[0] || "";
    return val || "";
  }
  getShipmentRowQuantity(lotComponent, position, submission) {
    const { components } = this.state;
    if (!lotComponent || !submission || !components) return null;
    const qtyComp = this.getQuantityComponentForLot(lotComponent, components);
    if (!qtyComp) return null;
    const val = submission[qtyComp.id];
    const raw = (position || position === 0)
      ? (val && val[position] != null ? val[position] : "")
      : (Array.isArray(val) ? val[0] : val);
    if (raw === "" || raw == null) return null;
    const qty = parseFloat(raw);
    return Number.isNaN(qty) ? null : qty;
  }
  getLotComponentForQuantityField(quantityComponent, components) {
    if (!quantityComponent || !components) return null;
    let lotLabel = "lotcode";
    if (quantityComponent.defaultLabel === "quantityFinishedGoods") lotLabel = "lotcode_finished";
    else if (quantityComponent.defaultLabel === "quantityWIP") lotLabel = "lotcode_wip";
    return components.find(
      (c) =>
        c.section_id === quantityComponent.section_id &&
        c.type !== "section" &&
        c.defaultLabel === lotLabel
    ) || null;
  }
  findAlreadyAllocatedShipmentLot(lotValue, position, lotComponent, submission, itemNameOverride) {
    const { isShipmentLog, alreadyAllocatedShipmentLots, submissionSelected } = this.props;
    if (!isShipmentLog || !alreadyAllocatedShipmentLots || !alreadyAllocatedShipmentLots.length) return null;

    const currentSubmissionId = submissionSelected?._id;
    const sub = submission || this.state.submission;
    const itemName = (itemNameOverride != null
      ? itemNameOverride
      : this.getShipmentRowItemName(lotComponent, position, sub) || ""
    ).toString().trim().toLowerCase();
    const lots = this.extractShipmentLotEntries(lotValue);
    if (!lots.length) return null;

    // Prefer the row Quantity field over lot editedAmount/stock fallbacks.
    const rowQty = this.getShipmentRowQuantity(lotComponent, position, sub);

    for (let i = 0; i < lots.length; i++) {
      const selected = lots[i];
      const lotNorm = (selected.lot || "").toString().trim().toLowerCase();
      const available = this.resolveShipmentLotAvailable(selected, lotComponent, position);
      // Empty/new placeholder rows need option stock or a batch before we can check.
      if (!lotNorm && !(available > 0) && !selected.batchId) continue;

      // Use this lot's selected amount — not the full row qty (other lots can cover the rest).
      const qtyToCheck = selected.selectedQty > 0
        ? selected.selectedQty
        : ((rowQty != null && rowQty >= 0) ? rowQty : 0);
      // Zero/empty quantity must never trigger the allocated alert.
      if (!(qtyToCheck > 0)) continue;

      const allocOpts = {
        lot: lotNorm,
        batchId: selected.batchId,
        itemName,
        currentSubmissionId,
      };
      // Includes empty-lot + batchId matches (e.g. beans/333 allocated against lot:"" inventory).
      let match = findBlockingAllocation(alreadyAllocatedShipmentLots, allocOpts);
      if (!match && itemName && !lotNorm) {
        match = alreadyAllocatedShipmentLots.find((allocated) => {
          if (!allocated) return false;
          if (currentSubmissionId && allocated.submission_id === currentSubmissionId) return false;
          const aItem = (allocated.item || "").toString().trim().toLowerCase();
          if (aItem !== itemName) return false;
          if (selected.batchId && allocated.batchId && selected.batchId === allocated.batchId) return true;
          const aLot = (allocated.lot || "").toString().trim().toLowerCase();
          return !aLot || aLot === "default_lot";
        }) || null;
      }
      if (!match) continue;

      if (!(available > 0)) continue;
      const remainOpts = {
        lot: lotNorm || (match.lot || "").toString().trim().toLowerCase(),
        batchId: selected.batchId || match.batchId || null,
        itemName,
        currentSubmissionId,
      };
      if (isLotFullyAllocated(available, alreadyAllocatedShipmentLots, remainOpts)) {
        return match;
      }
      if (exceedsRemainingLotAmount(qtyToCheck, available, alreadyAllocatedShipmentLots, remainOpts)) {
        // Still allow when free stock across ALL lots/batches covers the row quantity.
        const options = this.getShipmentLotOptions(lotComponent, position);
        if (options.length && rowQty > 0) {
          const totalRemaining = getTotalRemainingAcrossLots(options, alreadyAllocatedShipmentLots, {
            itemName,
            currentSubmissionId,
          });
          const requested = Math.round((parseFloat(rowQty) + Number.EPSILON) * 1000) / 1000;
          const free = Math.round((totalRemaining + Number.EPSILON) * 1000) / 1000;
          if (!(requested > free)) continue;
        }
        return match;
      }
    }
    return null;
  }
  /**
   * Quantity-field check: alert only when requested qty exceeds free stock summed
   * across every lot and every historial batch for the item.
   * Returns all blocking allocations for that item (not just the first).
   */
  findAlreadyAllocatedShipmentLotForQuantity(lotComponent, position, submission, rowQty) {
    const { isShipmentLog, alreadyAllocatedShipmentLots, submissionSelected } = this.props;
    if (!isShipmentLog || !alreadyAllocatedShipmentLots?.length || !lotComponent) return null;
    if (!(rowQty > 0)) return null;

    const currentSubmissionId = submissionSelected?._id;
    const itemName = (this.getShipmentRowItemName(lotComponent, position, submission) || "")
      .toString().trim().toLowerCase();
    if (!itemName) return null;

    const options = this.getShipmentLotOptions(lotComponent, position);
    if (!options.length) return null;

    const totalRemaining = getTotalRemainingAcrossLots(options, alreadyAllocatedShipmentLots, {
      itemName,
      currentSubmissionId,
    });

    const requested = Math.round((parseFloat(rowQty) + Number.EPSILON) * 1000) / 1000;
    const free = Math.round((totalRemaining + Number.EPSILON) * 1000) / 1000;
    // Equality is allowed (qty 5 with 5 free must NOT alert).
    if (!(requested > free)) return null;

    const matches = alreadyAllocatedShipmentLots.filter((allocated) => {
      if (!allocated) return false;
      if (currentSubmissionId && allocated.submission_id === currentSubmissionId) return false;
      return (allocated.item || "").toString().trim().toLowerCase() === itemName;
    });
    return matches.length ? matches : null;
  }
  validateShipmentQuantityAgainstAllocation(quantityComponent, position, submission) {
    const { components } = this.state;
    if (!quantityComponent || !submission || !components) return null;
    const lotComp = this.getLotComponentForQuantityField(quantityComponent, components);
    if (!lotComp) return null;
    const rowQty = this.getShipmentRowQuantity(lotComp, position, submission);
    if (!(rowQty > 0)) return null;

    // Always use total free stock across all lots/batches for quantity edits.
    // Do not short-circuit through findAlreadyAllocatedShipmentLot with the full row qty.
    return this.findAlreadyAllocatedShipmentLotForQuantity(lotComp, position, submission, rowQty);
  }
  showAlreadyAllocatedShipmentAlert(allocated, onClose) {
    const list = normalizeAllocatedShipmentList(allocated);
    if (!list.length) return;
    if (this._allocationAlertOpen) {
      if (onClose) onClose();
      return;
    }
    this._allocationAlertOpen = true;
    const message = formatAlreadyAllocatedShipmentAlertMessage(list);
    const htmlMessage = message
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\n/g, "<br>");
    Swal.fire({
      title: "Inventory Already Allocated",
      html: htmlMessage,
      confirmButtonText: "OK",
      confirmButtonColor: colors.orange,
      backdrop: false,
    }).then(() => {
      this._allocationAlertOpen = false;
      if (onClose) onClose();
    });
  }
  findAlreadyAllocatedInShipmentSubmission(submission) {
    const { isShipmentLog, alreadyAllocatedShipmentLots } = this.props;
    const { components } = this.state;
    if (!isShipmentLog || !alreadyAllocatedShipmentLots?.length || !submission || !components) return null;
    const lotComponents = components.filter(
      (c) =>
        c.type !== "section" &&
        (c.defaultLabel === "lotcode_finished" ||
          c.defaultLabel === "lotcode_wip" ||
          c.defaultLabel === "lotcode")
    );
    for (let i = 0; i < lotComponents.length; i++) {
      const lotComponent = lotComponents[i];
      const fieldValue = submission[lotComponent.id];
      if (fieldValue == null || fieldValue === "") continue;
      if (Array.isArray(fieldValue)) {
        for (let position = 0; position < fieldValue.length; position++) {
          const match = this.findAlreadyAllocatedShipmentLot(
            fieldValue[position],
            position,
            lotComponent,
            submission
          );
          if (match) return match;
        }
      } else {
        const match = this.findAlreadyAllocatedShipmentLot(fieldValue, null, lotComponent, submission);
        if (match) return match;
      }
    }
    return null;
  }
  blockAlreadyAllocatedShipmentSelection(allocated, position) {
    const { resetInventorySearch, itemComponentChanged, showLotsByLocation, showTextBar } = this.state;
    const reopenLotsModal = !!showLotsByLocation && !!showTextBar;
    if (reopenLotsModal) {
      this.setState({ showLotsByLocation: false });
    }
    this.showAlreadyAllocatedShipmentAlert(allocated, () => {
      if (reopenLotsModal) {
        this.setState({ showLotsByLocation: true });
      }
    });
    this.setState({
      resetInventorySearch: {
        changed: !resetInventorySearch.changed,
        position: position != null ? position : 0,
      },
      itemComponentChanged: !itemComponentChanged,
      rerenderTable: !this.state.rerenderTable,
    });
  }
  resendRecipe(status){
    Swal.fire({
      title: "Attention: Recipe Form Editing",
      text: "This recipe already deducted ingredients. Changes won't affect inventory levels.", 
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
      showCancelButton: true,
      confirmButtonColor: colors.orange,
      backdrop: false
    }).then((result) => {
      if(result.isConfirmed)
        this.submitForm(status);
    })
  }
  // sortLocations(locations){
  //   var sortedLocations = [];
  //   locations.map((location, idx)=>{
  //     if(location?.site?.parentLocation == ""){
  //       //Site Level
  //       if(!location?.zone)sortedLocations.push(location);
  //       var zones = locations.filter((loc)=> loc?.zone?.parentLocation == location?.site?._id && !loc?.aisle);
  //       if(zones.length > 0){
  //         zones.map((zone)=>{
  //           //Zone Level
  //           sortedLocations.push(zone);
  //           var aisles = locations.filter((loc)=> loc?.aisle?.parentLocation == zone?.zone?._id && !loc?.rackBay);
  //           if(aisles.length > 0){
  //             aisles.map((aisle)=>{
  //               //Aisle Level
  //               sortedLocations.push(aisle);
  //             });
  //           }
  //         })
  //       }
  //     }
  //   });

  //   return sortedLocations;
  // }
  getIngredientLotsByName(name, type, callback){
    var data = {
      name, 
      type
    }
    this.props.getIngredientLotsByName(data, (res)=>{
      if(res?.lots?.length){
        if(callback)callback(res.lots);
      }
    });
  }

  /** Oldest inventory location across lots (FIFO: older stock → newer). */
  getFifoLocationFromLots(lots) {
    if (!Array.isArray(lots) || !lots.length) return null;
    for (var i = 0; i < lots.length; i++) {
      var lot = lots[i];
      var batches = this.getFifoHistorialBatches(lot?.historial);
      for (var j = 0; j < batches.length; j++) {
        var h = batches[j];
        if (h?.hide) continue;
        var amt = parseFloat(h?.amount != null ? h.amount : h?.editedAmount);
        if (isNaN(amt) || amt <= 0) continue;
        var loc = h?.location || h?.completeLocation;
        if (loc) return loc;
      }
    }
    return null;
  }

  getFifoHistorialBatches(historial) {
    if (!Array.isArray(historial) || !historial.length) return [];
    var self = this;
    var withDates = historial.every(function (h) {
      return self.getHistorialTimestamp(h) != null;
    });
    if (withDates) {
      return historial.slice().sort(function (a, b) {
        return self.getHistorialTimestamp(a) - self.getHistorialTimestamp(b);
      });
    }
    // Historial is typically newest→oldest; reverse for FIFO.
    return historial.slice().reverse();
  }

  getHistorialTimestamp(h) {
    var raw = h?.production_date || h?.date || h?.createdAt || h?.created_at || h?.minDate || "";
    if (!raw) return null;
    var t = Date.parse(raw);
    return isNaN(t) ? null : t;
  }

  /** Lots/historial batches that still have stock at the given location. */
  getLotsAtLocation(lots, location, inventoryLocations) {
    if (!Array.isArray(lots) || !lots.length || !location) return [];
    var catalog = this.filterLocations(location, inventoryLocations || []);
    var matchAgainst = catalog?.length ? catalog : [location];
    var result = [];
    lots.forEach((lot) => {
      var matchingHistorial = (lot?.historial || []).filter((h) => {
        if (h?.hide) return false;
        var amt = parseFloat(h?.amount != null ? h.amount : h?.editedAmount);
        if (isNaN(amt) || amt <= 0) return false;
        var loc = h?.location || h?.completeLocation;
        if (!loc) return false;
        return !!this.findLocation(loc, matchAgainst);
      });
      if (matchingHistorial.length) {
        result.push({
          ...lot,
          historial: matchingHistorial,
        });
      }
    });
    return result;
  }

  findLocation(location, locations){
    var foundLocation = locations.find((l)=>{
      var found = true;
                              
      if(location == "default_location"){
        if(!l?.site?.defaultLocation){
          found = false;
        }
      }
      if(location?.site?._id){
        if(l?.site?._id != location?.site?._id){
          found = false;
        }else{
          if(l?.zone?._id && !location?.zone?._id)found = false;
        }
      }
      if(location?.zone?._id){
        if(l?.zone?._id != location?.zone?._id){
          found = false;
        }else{
          if(l?.aisle?._id && !location?.aisle?._id)found = false;
        }
      }
      if(location?.aisle?._id){
        if(l?.aisle?._id != location?.aisle?._id){
          found = false;
        }else{
          if(l?.rackBay?._id && !location?.rackBay?._id)found = false;
        }
      }
      if(location?.rackBay?._id){
        if(l?.rackBay?._id != location?.rackBay?._id){
          found = false;
        }else{
          if(l?.shelfLevel?._id && !location?.shelfLevel?._id)found = false;
        }
      }
      if(location?.shelfLevel?._id){
        if(l?.shelfLevel?._id != location?.shelfLevel?._id){
          found = false
        }else{
          if(l?.bin?._id && !location?.bin?._id)found = false;
        }
      }
      if(location?.bin?._id){
        if(l?.bin?._id != location?.bin?._id){
          found = false
        }
      }
    
      return found;
    });

    return foundLocation;
  }
  filterLocations(location, locations){
    var foundLocation = locations.filter((l)=>{
      var found = true;
                              
      if(location == "default_location"){
        if(!l?.site?.defaultLocation){
          found = false;
        }
      }
      if(location?.site?._id){
        if(l?.site?._id != location?.site?._id){
          found = false;
        }else{
          if(l?.zone?._id && !location?.zone?._id)found = false;
        }
      }
      if(location?.zone?._id){
        if(l?.zone?._id != location?.zone?._id){
          found = false;
        }else{
          if(l?.aisle?._id && !location?.aisle?._id)found = false;
        }
      }
      if(location?.aisle?._id){
        if(l?.aisle?._id != location?.aisle?._id){
          found = false;
        }else{
          if(l?.rackBay?._id && !location?.rackBay?._id)found = false;
        }
      }
      if(location?.rackBay?._id){
        if(l?.rackBay?._id != location?.rackBay?._id){
          found = false;
        }else{
          if(l?.shelfLevel?._id && !location?.shelfLevel?._id)found = false;
        }
      }
      if(location?.shelfLevel?._id){
        if(l?.shelfLevel?._id != location?.shelfLevel?._id){
          found = false
        }else{
          if(l?.bin?._id && !location?.bin?._id)found = false;
        }
      }
      if(location?.bin?._id){
        if(l?.bin?._id != location?.bin?._id){
          found = false
        }
      }
    
      return found;
    });

    return foundLocation;
  }
  checkToLocationOnTransfer(components, submission){
    var valid = true;
    var sections = "";
    var section = components.find(component => component?.defaultLabel == "rawMaterials" && component.type == "section");
    if(section){
      var itemComponent = components.find(component => component?.defaultLabel == "itemName" && component?.type != "section" && component?.section_id == section?.section_id);
      var toLocationComponent = components.find(component => component?.defaultLabel == "toLocation" && component.type != "section" && component?.section_id == section?.section_id);
      if(itemComponent && toLocationComponent){
        var itemSubmission = submission[itemComponent.id];
        var toLocationSubmission = submission[toLocationComponent.id];
        if(typeof itemSubmission == "object" && itemSubmission?.length > 0){
          itemSubmission.map((sub, id) =>{
            if(sub){
              if(toLocationSubmission[id]){
                if(typeof toLocationSubmission[id] == "object" && toLocationSubmission[id]?.length > 0){
                  toLocationSubmission[id].map((location)=>{
                    if(!location){
                      valid = false;
                      sections += sections ? `, ${section.label}` : `${section.label}`;
                    }
                  })
                }else if(typeof toLocationSubmission[id] == "string"){
                  if(toLocationSubmission[id] == ""){
                    valid = false;
                    sections += sections ? `, ${section.label}` : `${section.label}`;
                  }
                }else {
                  valid = false;
                }
              }else {
                valid = false;
              }
            }
          });
        }
      }
    }
    var section = components.find(component => component?.defaultLabel == "finishedGoods" && component.type == "section");
    if(section){
      var itemComponent = components.find(component => component?.defaultLabel == "item" && component?.type != "section" && component?.section_id == section?.section_id);
      var toLocationComponent = components.find(component => component?.defaultLabel == "toLocation" && component.type != "section" && component?.section_id == section?.section_id);
      if(itemComponent && toLocationComponent){
        var itemSubmission = submission[itemComponent.id];
        var toLocationSubmission = submission[toLocationComponent.id];
        if(typeof itemSubmission == "object" && itemSubmission?.length > 0){
          itemSubmission.map((sub, id) =>{
            if(sub){
              if(toLocationSubmission[id]){
                if(typeof toLocationSubmission[id] == "object" && toLocationSubmission[id]?.length > 0){
                  toLocationSubmission[id].map((location)=>{
                    if(!location){
                      valid = false;
                      sections += sections ? `, ${section.label}` : `${section.label}`;
                    }
                  })
                }else if(typeof toLocationSubmission[id] == "string"){
                  if(toLocationSubmission[id] == ""){
                    valid = false;
                    sections += sections ? `, ${section.label}` : `${section.label}`;
                  }
                }else valid = false;
              }else valid = false;

            }
          });
        }
      }
    }
    var section = components.find(component => component?.defaultLabel == "packagingMaterials" && component.type == "section");
    if(section){
      var itemComponent = components.find(component => component?.defaultLabel == "item" && component?.type != "section" && component?.section_id == section?.section_id);
      var toLocationComponent = components.find(component => component?.defaultLabel == "toLocation" && component.type != "section" && component?.section_id == section?.section_id);
      if(itemComponent && toLocationComponent){
        var itemSubmission = submission[itemComponent.id];
        var toLocationSubmission = submission[toLocationComponent.id];
        if(typeof itemSubmission == "object" && itemSubmission?.length > 0){
          itemSubmission.map((sub, id) =>{
            if(sub){
              if(toLocationSubmission[id]){
                if(typeof toLocationSubmission[id] == "object" && toLocationSubmission[id]?.length > 0){
                  toLocationSubmission[id].map((location)=>{
                    if(!location){
                      valid = false;
                      sections += sections ? `, ${section.label}` : `${section.label}`;
                    }
                  })
                }else if(typeof toLocationSubmission[id] == "string"){
                  if(toLocationSubmission[id] == ""){
                    valid = false;
                    sections += sections ? `, ${section.label}` : `${section.label}`;
                  }
                }else valid = false;
              }else valid = false;

            }
          });
        }
      }
    }
    var section = components.find(component => component?.defaultLabel == "workInProgress" && component.type == "section");
    if(section){
      var itemComponent = components.find(component => component?.defaultLabel == "item" && component?.type != "section" && component?.section_id == section?.section_id);
      var toLocationComponent = components.find(component => component?.defaultLabel == "toLocation" && component.type != "section" && component?.section_id == section?.section_id);
      if(itemComponent && toLocationComponent){
        var itemSubmission = submission[itemComponent.id];
        var toLocationSubmission = submission[toLocationComponent.id];
        if(typeof itemSubmission == "object" && itemSubmission?.length > 0){
          itemSubmission.map((sub, id) =>{
            if(sub){
              if(toLocationSubmission[id]){
                if(typeof toLocationSubmission[id] == "object" && toLocationSubmission[id]?.length > 0){
                  toLocationSubmission[id].map((location)=>{
                    if(!location){
                      valid = false;
                      sections += sections ? `, ${section.label}` : `${section.label}`;
                    }
                  })
                }else if(typeof toLocationSubmission[id] == "string"){
                  if(toLocationSubmission[id] == ""){
                    valid = false;
                    sections += sections ? `, ${section.label}` : `${section.label}`;
                  }
                }else valid = false;
              }else valid = false;

            }
          });
        }
      }
    }
    if(!valid){
      this.alertConfirm("Please complete to location fields in " + sections + ".", "Ok");
    }
    return valid;
  }
  openDropDown(position, section_id, component_id, options){
    const { dropDownOpen, sectionDropDown, rerenderTable, componentDropDown } = this.state;
    if(position == dropDownOpen && component_id == componentDropDown){
      this.setState({ dropDownOpen: -1, sectionDropDown: -1, componentDropDown: -1, dropDownOptions: null, rerenderTable: !rerenderTable });
    }else{
      this.setState({ dropDownOpen: position, sectionDropDown: section_id, componentDropDown: component_id, dropDownOptions: options, rerenderTable: !rerenderTable });
    }
  }
  resetDropDown(){
    const { rerenderTable, closeSearch } = this.state;
    this.setState({ dropDownOpen: -1, sectionDropDown: -1, componentDropDown: -1, dropDownOptions: null, rerenderTable: !rerenderTable, closeSearch: !closeSearch });
  }
  isIdInSection(section_id){
    const { componentDropDown} = this.state;
    var components = this.state.components.filter((component) => component.section_id == section_id && component.type != "section");
    var c = components.find((component)=>{ 
      return component.id == componentDropDown 
    });

    return c;
  }
  onTimeComponentChange(id, value, position){
    if(position || position == 0){
      if(this.timeSubmissions[id]){
        this.timeSubmissions[id][position] = value;
      }else{
        this.timeSubmissions[id] = [];
        this.timeSubmissions[id][position] = value;
      }
    }else{
      this.timeSubmissions[id] = value;
    }
  }
  updateTimeSubmissions(callback){
    var newSubmission = JSON.parse(JSON.stringify(this.state.submission));
    Object.keys(this.timeSubmissions).map((key, idx)=>{
      newSubmission[key] = this.timeSubmissions[key];
    });
    this.setState({ submission: newSubmission }, ()=>{
      if(callback)callback();
    })
  }
  setFocusedInput(id, idx){
    const { components } = this.state;
    var section = components.find(component => component.type == "section" && component.defaultLabel == "ingredients");
    if(section){
      var component = components.find(component => component.id == id && component.section_id == section.section_id && component.defaultLabel == "quantity");
      if(component){
        this.setState({focusedInput_id: id, focusedInput_idx: idx, rerenderTable: !this.state.rerenderTable});
      }else{
        this.setState({focusedInput_id: -1, focusedInput_idx: -1, rerenderTable: !this.state.rerenderTable});
      }
    }else{
      this.setState({focusedInput_id: -1, focusedInput_idx: -1, rerenderTable: !this.state.rerenderTable});
    }
  }
  isItemSelectField(defaultLabel) {
    return [
      "ingredient",
      "packagingMaterial",
      "name",
      "item",
      "itemName",
      "rawMaterialProductCode",
      "packagingProductCode",
      "fgProductCode",
      "wipProductCode",
    ].includes(defaultLabel);
  }
  /**
   * After batch-size confirm: prefer the first input in the nearest custom section
   * before Yield; otherwise focus the yield lot code field.
   */
  getFocusTargetAfterBatchSizeConfirm() {
    const { components } = this.state;
    if (!components?.length) return { kind: "lot" };

    const sections = components.filter((c) => c.type === "section" && !c.hide);
    const yieldIdx = sections.findIndex((s) => s.defaultLabel === "moreRecipeInformation");
    if (yieldIdx < 0) return { kind: "lot" };

    for (let i = yieldIdx - 1; i >= 0; i--) {
      const section = sections[i];
      // Skip the section that holds Production Date / Batch Size
      if (section.defaultLabel === "recipeInformation") continue;

      const fields = components.filter(
        (c) =>
          c.type !== "section" &&
          c.section_id === section.section_id &&
          !c.hide &&
          (c.type === "input" || c.type === "textarea" || c.type === "dropdown")
      );
      if (fields.length > 0) {
        return { kind: "component", id: fields[0].id };
      }
    }
    return { kind: "lot" };
  }
  /** After an item is selected on receiving / shipment / transfer, focus that row's quantity field. */
  requestFocusQuantity(position, section_id) {
    const { isReceivingLog, isShipmentLog, isInventoryTransfer } = this.props;
    if (!isReceivingLog && !isShipmentLog && !isInventoryTransfer) return;
    const pos = position || position === 0 ? position : 0;
    const target = { position: pos, section_id };
    if (this._focusQuantityTimer) clearTimeout(this._focusQuantityTimer);
    this._focusQuantityTimer = setTimeout(() => {
      this.setState({ focusQuantity: target, rerenderTable: !this.state.rerenderTable }, () => {
        setTimeout(() => {
          if (this.state.focusQuantity === target) {
            this.setState({ focusQuantity: null, rerenderTable: !this.state.rerenderTable });
          }
        }, 400);
      });
    }, 100);
  }
  setTableSearchOpen(componentId, position, isOpen){
    const key = `${componentId}-${position}`;
    this.setState((prevState) => {
      const nextMap = { ...prevState.tableSearchOpenMap };
      if (isOpen) {
        nextMap[key] = true;
      } else {
        delete nextMap[key];
      }
      return { tableSearchOpenMap: nextMap };
    });
  }
  addRmLine(newQty, newLineLotcode, position){
    const { submission, components } = this.state;
    let newSubmission = Object.assign({}, submission);
    var ingredientsSection = components.find(component => component.type == "section" && component.defaultLabel == "ingredients");
    var name = "";
    if(ingredientsSection){
      components.map((component)=>{
        if(component.section_id == ingredientsSection.section_id){
          if(typeof newSubmission[component.id] == "object"){
            var sub = newSubmission[component.id];         
            if(component.defaultLabel == "ingredient"){
              name = newSubmission[component.id][position];
              sub.splice(position + 1, 0, newSubmission[component.id][position]);
            }else if(component.defaultLabel == "quantity"){
              sub.splice(position + 1, 0, newQty);
            }
            else if(component.defaultLabel == "lotcode"){
              sub.splice(position + 1, 0, newLineLotcode);
              newSubmission[component.id] = sub;
              this.setState({ submission: newSubmission, itemComponentChanged: !this.state.itemComponentChanged, rerenderTable: this.state.rerenderTable, lotcodeFirstPreselection: false });
            }
            else{
              sub.splice(position + 1, 0, newSubmission[component.id][position])  
            }
            newSubmission[component.id] = sub;
          }
        }
      })
    }
    this.setState({ submission: newSubmission, itemComponentChanged: !this.state.itemComponentChanged, rerenderTable: this.state.rerenderTable, lotcodeFirstPreselection: false });
  }
  changeArrPositions(arr, index1, index2) {
    if(index2 < 0)return [...arr];    
    
    const editedArr = [...arr];
    var itemToMove = editedArr[index2]
    editedArr.splice(index2, 1);
    editedArr.splice(index1, 0, itemToMove);
    return editedArr;
  }
  isDefaultRecipeSection(section){
    return(
      section == "moreRecipeInformation" 
      //|| 
      //section == "ingredients" || 
      //section == "packagingMaterials" || 
      //section == "preparationInstructions" || 
      //section == "majorEquipment"
    )
  }
  isDefaultSection(section){
    const { isOrder } = this.props;
    return (section?.defaultLabel == "ingredients" || section?.defaultLabel == "rawMaterials" || section?.defaultLabel == "packagingMaterials" || section?.defaultLabel == "recipeInformation" || section?.defaultLabel == "moreRecipeInformation" ||  section?.defaultLabel == "preparationInstructions" || section?.defaultLabel == "finishedGoods" || section?.defaultLabel == "workInProgress" || section?.defaultLabel == "invoiceItems" || section?.defaultLabel == "itemsByLocation" || (isOrder && section?.label == "Raw Materials") || (isOrder && section?.label == "Packaging Materials"));
  }
  isInventoryReceivingForm() {
    const { isRequisitionForm, isShipmentLog, isReceivingLog, isInvoice, isRecipe, isOrder, isShipmentByLocation, isTransferByLocation } = this.props;
    return (
      isRequisitionForm || 
      isShipmentLog || 
      isReceivingLog || 
      isInvoice || 
      isRecipe || 
      isOrder ||
      isShipmentByLocation ||
      isTransferByLocation
    );
  }
  /** Completed forms stay read-only unless reopened as edit_required. */
  isFormLockedCompleted() {
    const completeDate = this.props.complete_date || this.props.submissionSelected?.complete_date;
    const status = this.props.submissionSelected?.status;
    return !!(completeDate && status !== "edit_required" && this.props.isInventoryTransfer);
  }
  /** Visual-only: same table chrome as Receiving/Shipment logs, including Inventory Transfer. Does not change form behavior. */
  usesInventoryFormTableDesign(section) {
    if (this.isInventoryReceivingForm() && this.isDefaultSection(section)) return true;
    return !!(this.props.isInventoryTransfer && this.isDefaultSection(section));
  }
  /** Inventory Transfer simplified table: Item + Current Location + Transfer to only. */
  isInventoryTransferVisibleField(defaultLabel) {
    return (
      defaultLabel === "itemName" ||
      defaultLabel === "ingredient" ||
      defaultLabel === "item" ||
      defaultLabel === "name" ||
      defaultLabel === "fromLocation" ||
      defaultLabel === "toLocation"
    );
  }
  getInventoryTransferColumnHeader(defaultLabel, fallbackLabel) {
    if (
      defaultLabel === "itemName" ||
      defaultLabel === "ingredient" ||
      defaultLabel === "item" ||
      defaultLabel === "name"
    ) {
      return "Item";
    }
    if (defaultLabel === "fromLocation") return "Current Location";
    if (defaultLabel === "toLocation") return "Transfer to";
    return fallbackLabel;
  }
  shouldRenderInventoryTransferSection(section) {
    if (!this.props.isInventoryTransfer) return true;
    // Hide inventory type table sections; keep In Process Transfers (rawMaterials) and all other sections.
    const hiddenTableSections = ["finishedGoods", "workInProgress", "packagingMaterials"];
    if (
      section?.direction === "table" &&
      hiddenTableSections.includes(section?.defaultLabel)
    ) {
      return false;
    }
    return true;
  }
  usesMobileInventoryTableLayout() {
    const { isShipmentByLocation, isTransferByLocation } = this.props;
    if (isTransferByLocation) return true;
    if (!isMobileWeb() && Platform.OS !== "android") return false;
    return !!isShipmentByLocation;
  }
  /** Transfer-by-location table: From Location → Items → To Location. */
  getTransferByLocationColumnOrder(component) {
    if (component?.defaultLabel === "fromLocation") return 0;
    if (component?.type === "itemsbylocation") return 1;
    if (component?.defaultLabel === "toLocation") return 2;
    return 3;
  }
  getSectionTableComponents(components, section_id) {
    const sectionComponents = components.filter(
      (component) => component.section_id == section_id && component.type != "section"
    );
    if (!this.props.isTransferByLocation) return sectionComponents;
    return [...sectionComponents].sort(
      (a, b) => this.getTransferByLocationColumnOrder(a) - this.getTransferByLocationColumnOrder(b)
    );
  }
  countLocationByFormTableColumns(components, section_id) {
    const { isShipmentByLocation, isTransferByLocation } = this.props;
    if (!isShipmentByLocation && !isTransferByLocation) return 0;
    var count = 0;
    components.filter((c) => c.section_id == section_id && c.type != "section").forEach((component) => {
      if (component?.hide) return;
      const label = component?.defaultLabel;
      if (
        label === "location" ||
        label === "fromLocation" ||
        label === "toLocation" ||
        component?.type === "itemsbylocation" ||
        label === "quantity" ||
        label === "quantityIngredient" ||
        label === "quantityFinishedGoods" ||
        label === "quantityWIP"
      ) {
        count++;
      }
    });
    return count;
  }
  /**
   * Uniform column width so inventory tables (Receiving/Shipment/Transfer) fit the
   * available space without horizontal scroll. Leaves ~4% for the add/remove column.
   */
  getInventoryTableFitColumnWidth(components, section_id, sectionDefaultLabel) {
    const headers = this.getTableHeaders(components, section_id, sectionDefaultLabel, true);
    const columnCount = headers?.length || 0;
    if (columnCount <= 0) return "30%";
    const pct = Math.floor(96 / columnCount);
    // Below ~18% inputs become unusable; allow scroll instead in that edge case.
    return `${Math.max(pct, 18)}%`;
  }
  getLocationByFormColumnWidth(components, section_id) {
    const columnCount = this.countLocationByFormTableColumns(components, section_id);
    if (columnCount <= 0) return isMobileWeb() ? "43%" : "45%";
    const pct = Math.floor(96 / columnCount);
    return isMobileWeb() ? `${Math.max(pct - 1, 22)}%` : `${pct}%`;
  }
  getShipmentMobileTableCellStyle(backgroundColor, widthValue, extra = {}) {
    if (this.usesMobileInventoryTableLayout()) {
      return {
        flex: 1,
        minWidth: 0,
        padding: 3,
        backgroundColor,
        overflow: "hidden",
        ...extra,
      };
    }
    return {
      padding: 3,
      width: widthValue,
      backgroundColor,
      ...extra,
    };
  }
  isInventoryForm() {
    const { isRequisitionForm, isShipmentLog, isReceivingLog, isInvoice, isInventoryTransfer, isRecipe } = this.props;
    return !!(isRequisitionForm || isShipmentLog || isReceivingLog || isInvoice || isInventoryTransfer || isRecipe);
  }
  getQuantityComponentForLot(lotComponent, components) {
    if (!lotComponent) return null;
    if (lotComponent.defaultLabel === "lotcode_finished") {
      return components.find((c) => c.section_id === lotComponent.section_id && c.defaultLabel === "quantityFinishedGoods");
    }
    if (lotComponent.defaultLabel === "lotcode_wip") {
      return components.find((c) => c.section_id === lotComponent.section_id && c.defaultLabel === "quantityWIP");
    }
    const ingredientQty = components.find((c) => c.section_id === lotComponent.section_id && c.defaultLabel === "quantityIngredient");
    if (ingredientQty) return ingredientQty;
    const packagingQty = components.find((c) => c.section_id === lotComponent.section_id && c.defaultLabel === "quantityPackaging");
    if (packagingQty) return packagingQty;
    return components.find((c) => c.section_id === lotComponent.section_id && c.defaultLabel === "quantity");
  }
  getLotsByLocationPickerProps(showTextBar) {
    if (!showTextBar) {
      return { lotsSelected: null, amount: null, units: null };
    }
    const { submission, components } = this.state;
    const { id, position } = showTextBar;
    let lotsSelected = showTextBar.value;
    let amount = showTextBar.amount;
    let units = showTextBar.units;

    if (submission && id != null && submission[id]) {
      const fromSubmission = (position || position === 0)
        ? submission[id][position]
        : submission[id];
      if (Array.isArray(fromSubmission) && fromSubmission.length > 0) {
        lotsSelected = fromSubmission;
      }
    }

    const lotComponent = components.find((c) => c.id === id);
    const qtyComponent = this.getQuantityComponentForLot(lotComponent, components);
    if (qtyComponent && submission[qtyComponent.id]) {
      const qtyRaw = (position || position === 0)
        ? submission[qtyComponent.id][position]
        : submission[qtyComponent.id];
      if (qtyRaw != null && qtyRaw !== "") {
        const parsed = parseFloat(qtyRaw);
        if (!Number.isNaN(parsed) && parsed > 0) amount = parsed;
      }
    }

    return { lotsSelected, amount, units };
  }
  setShowTextBar(id, position, options, ingredientName, value, units, amount, openLotsView, hideLotsView) {
    if (this._showTextBarTimer) {
      clearTimeout(this._showTextBarTimer);
      this._showTextBarTimer = null;
    }
    const applyShowTextBar = () => {
      if (id != null) {
        const top = 100 + (position + 1) * 140;
        let openLots = !!openLotsView;
        if (
          openLots &&
          Platform.OS === "web" &&
          Date.now() < this._suppressLotsReopenUntil
        ) {
          openLots = false;
        }
        this.setState(
          {
            showTextBar: { id, position, options, top, ingredientName, value, units, amount, hideLotsView },
            showLotsByLocation: openLots,
            keyboarWithScandOpened: openLots ? false : true,
            ...(hideLotsView ? {} : { rerenderTable: !this.state.rerenderTable }),
          },
          () => {
            if (Platform.OS === "web" && isMobileWeb() && !hideLotsView) {
              this._scheduleWebKeyboardInsetSync();
              this.showTextbarAnimation(1, 300);
            }
          }
        );
      } else {
        this.setState(
          {
            showTextBar: null,
            keyboarWithScandOpened: false,
            showLotsByLocation: false,
            rerenderTable: !this.state.rerenderTable,
          },
          () => {
            if (Platform.OS === "web" && isMobileWeb()) {
              this.showTextbarAnimation(0, 100);
            }
          }
        );
      }
    };
    if (hideLotsView && Platform.OS === "web" && isMobileWeb()) {
      applyShowTextBar();
      return;
    }
    this._showTextBarTimer = setTimeout(() => {
      this._showTextBarTimer = null;
      applyShowTextBar();
    }, 200);
  }
  setOpenBarcode(showTextBar) {
    if (showTextBar != null) {
      this.setState(
        { openBarCodeScanner: { id: showTextBar.id, position: showTextBar.position } },
        () =>
          setTimeout(() => {
            this.setState({ openBarCodeScanner: null });
          }, 800)
      );
    } else {
      this.setState({ openBarCodeScanner: null });
    }
  }
  setFormScroll(value) {
    this.setState({ formScroll: value });
  }

  showTextbarAnimation(toValue, duration) {
    Animated.timing(this.animationTextBar, {
      toValue,
      duration,
      useNativeDriver: true,
    }).start();
  }

  getFormHeight = (event) => {
    const { layout } = event.nativeEvent;
    const height = Dimensions.get("screen").height;
    const topBar = parseFloat((height - layout.height).toFixed(3));
    this.setState({
      navBarHeight: topBar,
      formWidth: layout.width,
      rerenderTable: !this.state.rerenderTable,
    });
  };

  filllocationFromLotsView(componentId, location, position) {
    const { components } = this.state;
    const locationComponent = getComponentByanotherComponentId(
      componentId,
      "location",
      components
    );
    if (locationComponent) {
      this.onComponentChange(
        locationComponent.id,
        location,
        "",
        position,
        false,
        false
      );
    }
  }

  addMinorAmountAndroidId(minorAmount, id, position) {
    const { minorAmountAndroid } = this.state;
    const pos = position == null ? 0 : position;
    const newMinorAmountAndroid = JSON.parse(JSON.stringify(minorAmountAndroid));
    const index = newMinorAmountAndroid.findIndex(
      (item) => item.id == id && item.position == pos
    );
    if (index < 0 && minorAmount) {
      newMinorAmountAndroid.push({ id, position: pos });
    } else if (index >= 0 && !minorAmount) {
      newMinorAmountAndroid.splice(index, 1);
    }
    return newMinorAmountAndroid;
  }

  renderTextBar() {
    const { showTextBar, KeyBoardTop, keyboardLoaded, width, formWidth, webKeyboardBottomInset } =
      this.state;
    const screenHeight = Dimensions.get("screen").height;
    const windowWidth = Dimensions.get("window").width;
    const textBarWidth =
      formWidth > 0 ? formWidth : width > 0 ? width : windowWidth;
    const textBarHeight = styles.animatedTextBar.height || 60;
    const webMobile = Platform.OS === "web" && isMobileWeb();
    const vvInset = webMobile ? webKeyboardBottomInset || 0 : 0;
    let bottomPosition;
    if (webMobile) {
      let fromRn = 0;
      if (keyboardLoaded && KeyBoardTop > 0) {
        fromRn = Math.round(screenHeight - KeyBoardTop - textBarHeight);
      }
      /* visualViewport matches iOS Safari keyboard; RN Keyboard coords on web are often wrong */
      bottomPosition = vvInset > 0 ? vvInset : fromRn;
    } else if (keyboardLoaded && KeyBoardTop > 0) {
      bottomPosition = screenHeight - KeyBoardTop - textBarHeight;
    } else {
      bottomPosition = 110;
    }
    return (
      <Animated.View
        style={{
          ...styles.animatedTextBar,
          ...(webMobile
            ? {
                position: "fixed",
                left: 0,
                right: 0,
                width: windowWidth,
                maxWidth: "100%",
                bottom: bottomPosition,
                zIndex: 20000,
              }
            : {
                width: textBarWidth,
                left: 0,
                bottom: bottomPosition,
              }),
          opacity: this.animationTextBar,
        }}
      >
        <KeyboardBar
          containerStyle={{ width: webMobile ? windowWidth : textBarWidth }}
          abcOptionPress={
            showTextBar?.hideLotsView
              ? () => {
                  if (typeof window !== "undefined") {
                    window.dispatchEvent(
                      new CustomEvent("gohaccp-wedge-manual-keyboard", {
                        detail: { id: showTextBar.id, position: showTextBar.position },
                      })
                    );
                  }
                }
              : !showTextBar?.hideLotsView
              ? () => {
                  /* Block the visualViewport auto-hide for the duration of the keyboard close + picker open transition */
                  this._suppressAutoHideUntil = Date.now() + 1500;
                  if (this._webKeyboardCloseTimer) {
                    clearTimeout(this._webKeyboardCloseTimer);
                    this._webKeyboardCloseTimer = null;
                  }
                  Keyboard.dismiss();
                  /* Set both flags now: showLotsByLocation true (picker on), keyboarWithScandOpened false (bar off) — keep showTextBar */
                  this.setState({
                    showLotsByLocation: true,
                    keyboarWithScandOpened: false,
                    rerenderTable: !this.state.rerenderTable,
                  });
                }
              : null
          }
          scanOptionPress={() => {
            this._suppressAutoHideUntil = Date.now() + 1500;
            this.setOpenBarcode(showTextBar);
          }}
        />
      </Animated.View>
    );
  }
  updateComponentLotCodeschoiceList(id, list, position){
    const { complete_date } = this.props;
    var newChoicelist = JSON.parse(JSON.stringify(this.state.choicelist));
    var newComponents = JSON.parse(JSON.stringify(this.state.components));
    var index = newComponents.findIndex(component => component.id == id);
    if(index >= 0 && !complete_date){
      var object_type_id = id;
      newComponents[index].object_type_id = object_type_id;
      if(!newChoicelist[object_type_id]){
        newChoicelist[object_type_id] = [];
      }
      newChoicelist[object_type_id][position] = list;
      const rowKey = `${id}:${position || position === 0 ? position : 0}`;
      const shipmentLotOptionsByRow = {
        ...(this.state.shipmentLotOptionsByRow || {}),
        [rowKey]: Array.isArray(list) ? list : [],
      };
      this.setState({ components: newComponents, choicelist: newChoicelist, shipmentLotOptionsByRow });
    }
  }
  _renderErrorFallback(error) {
    const debug = this._lastRenderErrorDebug || this._buildRenderErrorDebugInfo(error, null);
    const { ctx, stateSnapshot, errorName, errorMessage, componentStack } = debug;
    const title = "Something went wrong" + (this.props.isRecipe ? " (Recipe form)" : "");
    const renderKV = (obj) =>
      Object.keys(obj).map((k) => (
        <Text key={k} style={{ fontSize: 12, color: "#333" }}>
          <Text style={{ fontWeight: "bold" }}>{k}: </Text>
          {String(obj[k])}
        </Text>
      ));
    return (
      <View style={{ flexDirection: "row" }}>
        <View style={{ flex: 2 }} />
        <View className={"viewContainer"} style={viewContainer(this.state.width, styles)}>
          <ScrollView contentContainerStyle={{ padding: 16 }}>
            <View style={styles.fixedContainerHT}>
              <MaterialCommunityIcons
                name="alert-circle"
                size={32}
                color="#d00"
                style={styles.icon}
              />
              <Text style={[styles.errorText, { fontWeight: "bold", flexShrink: 1 }]}>
                {title}
              </Text>
            </View>
            <Text style={{ marginTop: 8, color: "#444" }}>
              {errorName}: {errorMessage}
            </Text>
            {/* <Text style={{ marginTop: 12, fontWeight: "bold", color: "#222" }}>Form</Text>
            {renderKV(ctx)}
            <Text style={{ marginTop: 12, fontWeight: "bold", color: "#222" }}>State</Text>
            {renderKV(stateSnapshot)} */}
            <Text style={{ marginTop: 12, fontWeight: "bold", color: "#222" }}>Where (component tree)</Text>
            <Text style={{ fontSize: 11, color: "#555" }}>{componentStack}</Text>
            <TouchableOpacity
              style={{ marginTop: 16, alignSelf: "flex-start", padding: 10, backgroundColor: colors.orange, borderRadius: 5 }}
              onPress={() => {
                this._renderErrorAlertShown = false;
                this._showRenderErrorAlert(error, { componentStack });
              }}
            >
              <Text style={{ color: "#fff" }}>Show details again</Text>
            </TouchableOpacity>
          </ScrollView>
        </View>
        <View style={{ flex: 2 }} />
      </View>
    );
  }

  render() {
    if (this.state.renderError) {
      return this._renderErrorFallback(this.state.renderError);
    }
    try {
      return this._renderForm();
    } catch (error) {
      setTimeout(() => this._showRenderErrorAlert(error, null), 0);
      try {
        this.setState({ renderError: error });
      } catch (_) {}
      return this._renderErrorFallback(error);
    }
  }

  _renderForm() {
    const { submission, choicelist, checkboxkey, showPaymentInfo, callOnSave, components, lotConsecutive, formLoaded, rerenderTable, palletComponentChanged, itemComponentChanged, resetInventorySearch, inventoryLocations, inventoryLocationsLoading, locationItemsLoading, dropDownOpen, componentDropDown, closeSearch, lotcodeFirstPreselection, focusLotCode, focusQuantity, focusComponent, batchSizeChanged, tableSearchOpenMap, openBarCodeScanner, showTextBar, keyboardLoaded, keyboarWithScandOpened, showLotsByLocation } = this.state;
    const { submissionSelected, formSubmission, isLoadingIssue, companyTimezone, promptMessages, inventoryTypes, isOrder, formId, isRecipe, updatedWizard, isInvoice, isShipmentLog, isReceivingLog, isInventoryTransfer, newReport, userRole, complete_date, defaultYield, isShipmentByLocation, isTransferByLocation } = this.props;
    const status = submissionSelected ? submissionSelected.status : "new";
    var isInventoryReceivingForm = false;
    let issues = submissionSelected ? submissionSelected.issues : null;
    if (this.state.tmpIssues.length > 0)
      issues = this.state.tmpIssues;
    const submissionId = submissionSelected ? submissionSelected._id : null;

    const hasTableSearchOpen = Object.keys(tableSearchOpenMap).length > 0;
    const mobileWebScanner = Platform.OS !== "web" || isMobileWeb();
    const scannerInputFlat = mobileWebScanner && this.resolveScannerInput();
    const defaultLabel = showTextBar?.id
      ? components.find((component) => component.id == showTextBar?.id)?.defaultLabel
      : "";
    // Mobile web: RN Keyboard events are unreliable; show ABC/scan bar whenever the
    // lotcode accessory is active (same actions as iqops2-app). Desktop web: isMobileWeb() is false.
    // Native Android: keep iqops2 behavior (bar only while software keyboard is open).
    const showMobileWebKeyboardBar =
      Platform.OS === "web" && isMobileWeb() && showTextBar && keyboarWithScandOpened;
    const showNonIosKeyboardAccessory = showMobileWebKeyboardBar;
    const isLocationShipmentForm = this.usesLocationShipmentLoading();
    const showShipmentLoadingOverlay = isLocationShipmentForm && locationItemsLoading;
    const shipmentLoadingMessage = locationItemsLoading
      ? "Loading items at location..."
      : "Loading locations...";
    const locationItemsLoadingChange = isLocationShipmentForm ? this.setLocationItemsLoading : undefined;
    console.log(submission);
    return (
      <View style={{ flexDirection: "row", }} onStartShouldSetResponder={()=> {if(this.isInventoryReceivingForm())setTimeout(() => {
        if(!isShipmentByLocation && !isTransferByLocation)this.resetDropDown();
      }, 200); else this.resetDropDown();}}>
        <PaymentInfo visible={showPaymentInfo} onSave={this.submitFormSave.bind(this)} callOnSave={callOnSave} />
        <View style={{ flex: 2, }} />
        <View className={"viewContainer"} style={viewContainer(this.state.width, styles)} >
          {
            this.props.isLoaded || (this.props.isSaving && this.state.autosave) ? (
              <>
                {showNonIosKeyboardAccessory ? this.renderTextBar() : null}
                {showLotsByLocation && isMobileWeb() ? (
                  <View>
                    {(() => {
                      const pickerProps = this.getLotsByLocationPickerProps(showTextBar);
                      return (
                    <LotsByLocation
                      units={pickerProps.units ?? showTextBar?.units}
                      amount={pickerProps.amount ?? showTextBar?.amount}
                      lotsSelected={pickerProps.lotsSelected ?? showTextBar?.value}
                      options={showTextBar?.options ? showTextBar.options : []}
                      id={showTextBar?.id ? showTextBar.id : ""}
                      position={
                        showTextBar?.position || showTextBar?.position == 0
                          ? showTextBar.position
                          : -1
                      }
                      name={
                        showTextBar?.ingredientName
                          ? showTextBar.ingredientName
                          : ""
                      }
                      onBack={(editQty, totalSelected, minorAmount, selectedLots) => {
                        if (this._showTextBarTimer) {
                          clearTimeout(this._showTextBarTimer);
                          this._showTextBarTimer = null;
                        }
                        if (Platform.OS === "web") {
                          this._suppressLotsReopenUntil = Date.now() + 400;
                        }
                        if (typeof window !== "undefined") {
                          window.dispatchEvent(new CustomEvent("gohaccp-lots-picker-closed"));
                        }
                        // Prevent FIFO lot rebuild while we sync quantity to the modal total.
                        this._suppressLotQtySyncUntil = Date.now() + 800;
                        this.setState({
                          showLotsByLocation: false,
                          minorAmountAndroid: this.addMinorAmountAndroidId(
                            minorAmount,
                            showTextBar.id,
                            showTextBar.position
                          ),
                          rerenderTable: !this.state.rerenderTable,
                        });
                        // Persist the lots chosen in the modal before updating quantity.
                        if (selectedLots != null && showTextBar?.id != null) {
                          this.onComponentChange(
                            showTextBar.id,
                            selectedLots,
                            "",
                            showTextBar.position,
                            false,
                            false
                          );
                        }
                        const quantityComponent = isShipmentLog
                          ? defaultLabel == "lotcode_finished"
                            ? getComponentByanotherComponentId(
                                showTextBar?.id,
                                "quantityFinishedGoods",
                                components
                              )
                            : defaultLabel == "lotcode_wip"
                              ? getComponentByanotherComponentId(
                                  showTextBar?.id,
                                  "quantityWIP",
                                  components
                                )
                              : getComponentByanotherComponentId(
                                  showTextBar?.id,
                                  "quantityIngredient",
                                  components
                                )
                          : getComponentByanotherComponentId(
                              showTextBar?.id,
                              "quantity",
                              components
                            );
                        if (quantityComponent && editQty) {
                          this.onComponentChange(
                            quantityComponent.id,
                            totalSelected,
                            "",
                            showTextBar.position,
                            false,
                            false
                          );
                        }
                      }}
                      placeholder={"Search by lot code"}
                      onSelect={(selected, location) => {
                        this.onComponentChange(
                          showTextBar.id,
                          selected,
                          "",
                          showTextBar.position,
                          false,
                          false
                        );
                        if (isRecipe) {
                          this.filllocationFromLotsView(
                            showTextBar.id,
                            location,
                            showTextBar.position
                          );
                        }
                      }}
                      openAlert={(value) =>
                        this.setState({ showLotsByLocation: !value })
                      }
                      components={components}
                      requiredAmount={getRequiredAmount(
                        components,
                        showTextBar.id,
                        showTextBar.position,
                        isRecipe,
                        submission,
                        defaultLabel,
                        defaultYield
                      )}
                      isInventoryReceivingForm={this.isInventoryReceivingForm()}
                      isInventoryType={
                        defaultLabel == "lotcode_finished" ||
                        defaultLabel == "lotcode_wip"
                      }
                      isRecipe={isRecipe}
                      isShipmentLog={isShipmentLog}
                      isReceivingLog={isReceivingLog}
                      complete_date={complete_date}
                      alreadyAllocatedShipmentLots={this.props.alreadyAllocatedShipmentLots}
                      currentSubmissionId={submissionSelected?._id}
                    />
                      );
                    })()}
                  </View>
                ) : null}
              <ScrollView
                contentContainerStyle={styles.innerView}
                ref={this.scrollViewRef}
                onLayout={this.getFormHeight}
                scrollEnabled={(!keyboarWithScandOpened || !!showTextBar?.hideLotsView) && this.state.formScroll}
              >
                {
                  status != "new" ?
                    <View>
                      <Text style={styles.reportId}>Report Id: {submissionId}</Text>
                    </View>
                    : null
                }


                {components.filter(section => (section.type == 'section' && !section.hide && this.shouldRenderInventoryTransferSection(section))).map((section, id) => {
                  isInventoryReceivingForm = this.isInventoryReceivingForm() && this.isDefaultSection(section);
                  const useInventoryTableDesign = this.usesInventoryFormTableDesign(section);
                  const inventoryTransferSectionLabel = isInventoryTransfer && section?.defaultLabel == "rawMaterials"
                    ? "In Process Transfers"
                    : null;
                  return (
                  section.direction && section.direction == 'table' ?
                    <Section
                      key={id}
                      showSeparator={id === 0}
                      isLast={id == components.filter(section => section.type == 'section' && !section.hide && this.shouldRenderInventoryTransferSection(section)).length - 1}
                      label={inventoryTransferSectionLabel || (isRecipe && this.isDefaultRecipeSection(section?.defaultLabel) ? "" : section.label)}
                      onChange={(id, value, subtype) => this.onComponentChange(id, value, subtype)}
                      id={section.id}
                      media={section.attachment}
                      formSubmission={formSubmission}
                      attachment_type={section.attachment_type}
                      mediaId={typeof section.attachmentId !== 'undefined' ? section.attachmentId : null}
                      formId={this.props.formId}
                      setBigFileIsLoading={this.props.setBigFileIsLoading}
                      direction={section.direction}
                      defaultData={section?.defaultData ? section?.defaultData : 1}
                      section={section}
                      components={components}
                      choicelist={choicelist}
                      checkboxkey={checkboxkey}
                      onSaveDefault={(defaultData, defaultSubmission, dataType) => {
                        this.editTableRows(defaultData, section?.section_id, defaultSubmission, dataType);
                      }}
                      defaultSubmission={section?.defaultSubmission ? section?.defaultSubmission : {}}
                      rerenderTable={rerenderTable}
                      status={status}
                      palletComponentChanged={palletComponentChanged}
                      itemComponentChanged={itemComponentChanged}
                      resetDropDown={()=> {
                        this.resetDropDown();
                      }}
                      closeSearch={closeSearch}
                      defaultLabel={section?.defaultLabel}
                      isRecipe={isRecipe}
                      isInventoryReceivingForm={useInventoryTableDesign}
                    >
                      <View style={{position: 'relative', zIndex: 1}}> 
                        <View style={{ marginTop: 10, overflow: hasTableSearchOpen ? "visible" : "auto", maxHeight: hasTableSearchOpen ? undefined : 480, zIndex: 1}}>
                            <View style={{ display: "flex", flexDirection: "column", borderColor: '#fff', height: 'auto', zIndex: 2 }}>
                              <View style={{display: "flex", flexDirection: "row", borderColor: useInventoryTableDesign? colors.orange : 'none', borderBottomWidth: (useInventoryTableDesign && section?.defaultLabel == "moreRecipeInformation") ? 1 : 0, borderTopWidth: (useInventoryTableDesign && section?.defaultLabel != "moreRecipeInformation") ? 1 : 0, paddingTop: useInventoryTableDesign ? 10 : 0 }}> 
                                {(!(isRecipe && this.isDefaultSection(section)) || (isRecipe && section?.defaultLabel == "moreRecipeInformation")) && <View style={{ width: this.usesMobileInventoryTableLayout() ? 32 : 40, flexShrink: 0, ...styles.head, backgroundColor: useInventoryTableDesign ? 'none' : colors.orange}}>
                                  <Text style={styles.text}></Text>
                                </View>}
                                {
                                  this.getTableHeaders(components, section.section_id, section?.defaultLabel, isInventoryReceivingForm).map((header, idx)=>{
                                    if(isInventoryReceivingForm && !header)return;

                                    var width = this.getCellArrayWidth(components, section.section_id, isInventoryReceivingForm);
                                    return <View key={idx} style={this.getShipmentMobileTableCellStyle(useInventoryTableDesign ? 'none' : colors.orange, width[idx], useInventoryTableDesign ? { backgroundColor: 'none' } : {})}>
                                      <Text style={{ color: 'white',...styles.text, ...styles.head, fontSize: useInventoryTableDesign ? 16 : 18, textAlign: (useInventoryTableDesign && (section?.defaultLabel == "ingredients" || section?.defaultLabel == "rawMaterials" || section?.defaultLabel == "packagingMaterials" || section?.defaultLabel == "finishedGoods" || section?.defaultLabel == "workInProgress" || section?.defaultLabel == "itemsByLocation" || (isOrder && section?.label == "Raw Materials") || (isOrder && section?.label == "Packaging Materials"))) || (isInventoryTransfer && section?.defaultLabel == "rawMaterials") ? 'center' : 'auto', color: useInventoryTableDesign ? 'black' : 'white', fontWeight: useInventoryTableDesign ? '700' : '100', backgroundColor: useInventoryTableDesign ? 'none' : colors.orange}}>{header}</Text>
                                      {useInventoryTableDesign && (section?.defaultLabel == "moreRecipeInformation" && idx == 0) && <Text style={{...styles.text, ...styles.head, fontSize: 12, color: 'black', backgroundColor: useInventoryTableDesign ? 'none' : colors.orange}}>Enter the actual amount produced.</Text>}
                                    </View>
                                  })
                                }
                              </View>
                              {
                                this.renderRows(this.checkForRows(components, section.section_id), components, section.section_id, section, isInventoryReceivingForm)
                              }
                            </View>
                        </View>
                        {
                          components.find((component) => component.type != "section" && this.state.compIssueId == component.id && component.section_id == section.section_id) &&
                          <NewIssue
                            visible={this.state.openTableIssue}
                            id={this.state.compIssueId}
                            label={this.state.issueLabel}
                            onSubmitIssue={(issue) => {
                              this.props.loadingIssue(this.state.compIssueId);
                              this.setState({ rerenderTable: !this.state.rerenderTable });
                              this.saveIssue({ ...issue, position: this.state.issuePosition }, issues, submissionId, () => {
                                setTimeout(() => {
                                  this.props.loadingIssue(null);
                                  this.setState({ rerenderTable: !this.state.rerenderTable });
                                }, 1000);
                              });
                            }}
                            handleClose={() => {
                              this.setState({
                                openTableIssue: false,
                                compIssueId: null,
                                issueLabel: '',
                                issuePosition: null,
                                issueWidth: "small",
                                rerenderTable: !rerenderTable
                              })
                            }}
                            width={this.state.issueWidth}
                          />
                        }
                      </View> 
                      {(status != 'archived' && status != 'approved' && !this.isFormLockedCompleted()
                      ) ?
                        <View style={styles.buttonsContainer}>
                          {!((isRecipe && this.isDefaultSection(section)) && section?.defaultLabel != "moreRecipeInformation") && <TouchableOpacity style={styles.btnAdd}
                            onPress={() => { this.addTableRow(section.section_id, choicelist); this.resetDropDown();}}
                          >
                            <Text>
                              <MaterialCommunityIcons name={"plus-circle-outline"} style={{ fontSize: 30, color: colors.add }} />
                            </Text>
                          </TouchableOpacity>}
                          {/* {!isRecipe && <TouchableOpacity style={styles.btnAdd}
                            onPress={() => {
                              var rows = this.checkForRows(components, section.section_id);
                              this.restTableRow(section.section_id, rows ? false : true);
                              this.resetDropDown();
                            }}
                          >
                            <View style={styles.iconContainer}>
                              <MaterialCommunityIcons name="plus-circle-outline" style={{ fontSize: 30, color: colors.quit, transform: [{ rotate: '45deg' }] }} />
                            </View>
                          </TouchableOpacity>} */}
                        </View> : null
                      }
                    </Section>
                    :

                    <Section
                      key={id}
                      showSeparator={id === 0}
                      isLast={id == components.filter(section => section.type == 'section').length - 1}
                      label={isRecipe && this.isDefaultRecipeSection(section?.defaultLabel) ? "" : section.label}
                      onChange={(id, value, subtype) => this.onComponentChange(id, value, subtype)}
                      id={section.id}
                      media={section.attachment}
                      formSubmission={formSubmission}
                      attachment_type={section.attachment_type}
                      mediaId={typeof section.attachmentId !== 'undefined' ? section.attachmentId : null}
                      formId={this.props.formId}
                      choicelist={choicelist}
                      setBigFileIsLoading={this.props.setBigFileIsLoading}
                      checkboxkey={checkboxkey}
                      defaultSubmission={{}}
                      rerenderTable={rerenderTable}
                      status={status}
                      palletComponentChanged={palletComponentChanged}
                      itemComponentChanged={itemComponentChanged}
                      sectionIndex={this.isIdInSection(section.section_id) ? 1 : 0}
                      resetDropDown={()=> {
                        this.resetDropDown();
                      }}
                      closeSearch={closeSearch}
                      defaultLabel={section?.defaultLabel}
                      isRecipe={isRecipe}
                      isInventoryReceivingForm={this.isInventoryReceivingForm() && this.isDefaultSection(section)}
                    >
                      {components.filter(component => component.section_id == section.section_id && component.type != 'section').map((component, idxComponent) => {
                        if(isRecipe && component?.defaultLabel == "skuNumber")return null;

                        let new_label;
                        var disabled = false;
                        switch (component.type) {
                          case "customlotcode":
                            new_label = `${component.label} - ${component.lotcodetypename}`;
                            break;
                          case "inventory":
                            new_label = `${component.label} - ${component.inventorytypename} Code`;
                            if (typeof submission[component.id] == "undefined")
                              submission[component.id] = { lotcode: "", productname: "", quantity: "" };
                            break;
                          default:
                            new_label = `${component.label}`;
                        }
                        if (component?.dataType) {
                          switch (component?.dataType) {
                            case "default_data":
                              if(component?.defaultLabel != "date&time")
                                disabled = true;
                              break;
                            default:
                              disabled = false;
                              break;
                          }
                        }

                        return <View key={component.id} style={component.type == "dropdown" ? { position: "relative", overflow: "visible", zIndex: componentDropDown == component.id ? 20 : 1 } : { position: 'none'}} onStartShouldSetResponder={()=> {
                          this.resetDropDown();
                        }}>
                          {
                            isLoadingIssue != null && component.id == isLoadingIssue ?
                              <ActivityIndicator key={idxComponent} size={150} color="rgb(0, 47, 108)"></ActivityIndicator>
                              :
                              <>
                              <View style={{ zIndex: componentDropDown == component.id ? 2 : 1 }}>
                                {
                                  !component?.hide &&
                                    <FormComponent
                                      id={component.id}
                                      type={component.type}
                                      key={component.id}
                                      label={component.mandatory && component.type != 'datetime' && component.type != 'datetime' ? new_label + " *" : new_label}
                                      placeholder={component.placeholder ? component.placeholder : ""}
                                      componentLink={component.componentLink ? component.componentLink : ""}
                                      enabledLink={component.enabledLink ? component.enabledLink : ""}
                                      initial={submission[component.id]}
                                      onChange={(id, value, subtype, prepopulate, item) => {
                                          if(component.type == "time" || component.type == "timer"){
                                            this.onTimeComponentChange(id, value, null);
                                          }else{
                                            this.onComponentChange(id, value, subtype, null, prepopulate, item)
                                          }
                                      }}
                                      options={choicelist[component.object_type_id]}
                                      checkboxkey={checkboxkey}
                                      status={submissionSelected ? submissionSelected.status : false}
                                      submissionSelected={submissionSelected ? submissionSelected : null}
                                      showLotGenerator={component.showLotGenerator ? component.showLotGenerator : null}
                                      lotConsecutive={lotConsecutive}
                                      customlot={false}
                                      isIssuable={submissionId != null}
                                      onSubmitIssue={(issue) => {
                                        this.props.loadingIssue(component.id);
                                        this.setState({ rerenderTable: !this.state.rerenderTable });

                                        this.saveIssue(issue, issues, submissionId, () => {
                                          setTimeout(() => {
                                            this.props.loadingIssue(null);
                                            this.setState({ rerenderTable: !this.state.rerenderTable });
                                          }, 1000);
                                        });
                                      }}
                                      companyTimezone={companyTimezone}
                                      defaultComponent={(status == 'archived' || status == 'approved') || formSubmission || (isInvoice && component?.searchClients) || (isInvoice && component?.defaultLabel == "invoiceNumber") || this.isFormLockedCompleted() ? true : disabled}
                                      promptMessages={promptMessages}
                                      showInventorySearch={component?.showInventorySearch || (isRecipe && component?.defaultLabel == "lotcode" && (section?.defaultLabel == "ingredients" || section?.defaultLabel == "packagingMaterials" ))}
                                      showFinishedGoodsSearch={component?.showFinishedGoodsSearch}
                                      showWorkInProgressSearch={component?.showWorkInProgressSearch}
                                      showItemsSearch={component?.showItemsSearch}
                                      showPackagingSearch={component?.showPackagingSearch}
                                      defaultLabel={component?.defaultLabel}
                                      isRecipe={isRecipe}
                                      isInvoice={isInvoice}
                                      submission={submission}
                                      isShipmentLog={isShipmentLog}
                                      resetInventorySearch={resetInventorySearch}
                                      components={components}
                                      inventoryTypes={inventoryTypes}
                                      searchClients={component?.searchClients}
                                      searchSuppliers={isReceivingLog && component?.defaultLabel == "approvedSupplier"}
                                      section_id={section?.section_id}
                                      isInventoryTransfer={isInventoryTransfer}
                                      inventoryLocations={inventoryLocations}
                                      newReport={newReport}
                                      openDropDown={(options)=>{this.openDropDown(0, component.section_id, component.id, options)}}
                                      backgroundColor={null}
                                      isLast={false}
                                      isDropDownOpened={component.id == componentDropDown}
                                      showProductCodeSearch={component.showProductCodeSearch}
                                      resetDropDown={()=> {
                                        this.resetDropDown();
                                      }}
                                      closeSearch={closeSearch}
                                      setFocusedInput={()=> this.setFocusedInput(component.id, -1)}
                                      setTableSearchOpen={(isOpen)=> this.setTableSearchOpen(component.id, -1, isOpen)}
                                      focused={null}
                                      addRmLine={null}
                                      lotcodeFirstPreselection={lotcodeFirstPreselection}
                                      isInventoryReceivingForm={isInventoryReceivingForm && this.isDefaultSection(section)}
                                      handleFocusOnElement={this.moveScrollToElement}
                                      focusLotCode={focusLotCode}
                                      focusQuantity={focusQuantity}
                                      focusComponent={focusComponent}
                                      isReceivingLog={isReceivingLog}
                                      batchSizeChanged={batchSizeChanged}
                                      quantityChanged={this.state.quantityChanged}
                                      defaultYield={this.props.defaultYield}
                                      complete_date={complete_date}
                                      quantityChangedPosition={this.state.quantityChangedPosition}
                                      showScanner={this.getLocationScanShowScanner(mobileWebScanner, component, isInventoryTransfer)}
                                      scannerInput={scannerInputFlat}
                                      setShowTextBar={(id, pos, options, ingredientName, value, units, amount, openLotsView, hideLotsView) =>
                                        this.setShowTextBar(id, pos, options, ingredientName, value, units, amount, openLotsView, hideLotsView)
                                      }
                                      openBarCodeScanner={openBarCodeScanner != null && component.id === openBarCodeScanner?.id && (openBarCodeScanner.position == null || openBarCodeScanner.position === 0)}
                                      setOpenBarcode={(val) => this.setOpenBarcode(val)}
                                      setFormScroll={(value) => this.setFormScroll(value)}
                                      minorAmountAndroid={this.state.minorAmountAndroid?.find(
                                        (item) =>
                                          item.id == component.id && item.position === 0
                                      )}
                                      rerenderTable={rerenderTable}
                                      showLocationsSearch={this.shouldUseLocationScanForComponent(component)}
                                      isShipmentByLocation={isShipmentByLocation}
                                      isTransferByLocation={isTransferByLocation}
                                      onLocationItemsLoadingChange={locationItemsLoadingChange}
                                      onLocationResolved={(location) => this.requestLocationItemsFetch(section?.section_id, 0, location)}
                                      locationItemsFetch={this.state.locationItemsFetch}
                                      alreadyAllocatedShipmentLots={this.props.alreadyAllocatedShipmentLots}
                                      currentSubmissionId={submissionSelected?._id}
                                      shouldSuppressLotQtySync={() =>
                                        !!(this._suppressLotQtySyncUntil && Date.now() < this._suppressLotQtySyncUntil)
                                      }
                                    />
                                }
                              </View>
                              {issues && this.renderIssue(issues, component) != null ? <View style={{
                                  flexDirection: "row",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  marginTop: 10,
                                  marginBottom: 10,
                                  zIndex: 1

                                }}>
                                  {this.printAllIssues(issues, component, null, false)}
                                </View> : null}
                              </>
                          }

                        </View>



                      })}
                    </Section>


                )}
                )}
                {
                  formSubmission ?
                    null : 
                    <RecordActions setCompleteStatus={() => { this.setCompleteStatus() }} 
                      formLoaded={formLoaded}
                      isShipmentByLocation={isShipmentByLocation}
                      isTransferByLocation={isTransferByLocation}
                      userRole={userRole}
                      submitForm={(sts) => sts ? (isRecipe && status == "edit_required") ? this.updateTimeSubmissions(()=>{this.resendRecipe(sts)})  : this.updateTimeSubmissions(()=>{this.submitForm(sts)}) :  this.updateTimeSubmissions(()=>{this.submitForm()})}
                      submitFormSave={(status) => status ? this.updateTimeSubmissions(()=>{this.submitFormSave(status)}) : this.updateTimeSubmissions(()=>{this.submitFormSave()})} record={this.props.submissionSelected} navigateTo={(page) => this.props.navigation.navigate(page)} />
                }
                {
                  formSubmission ?
                    null : 
                    this.props.isSaving? null : this.showSave()
                }
                {
                  formSubmission ?
                    <TouchableOpacity style={styles.readOnlyContainer}>
                      <Text style={{ alignSelf: "center" }}>This record is read only, the form was deleted from the admin and this record can not be modified.</Text>
                    </TouchableOpacity> : null
                }



              </ScrollView>
              </>
            ) : this.props.isLoading ? (
              <View style={styles.fixedContainer}>
                <ActivityIndicator></ActivityIndicator>
                <Text style={styles.loadingText}>Loading...</Text>
              </View>
            ) : this.props.isSaving && !this.state.autosave ? (
              <View style={styles.fixedContainer}>
                <ActivityIndicator></ActivityIndicator>
                <Text style={styles.loadingText}>Saving...</Text>
              </View>
            ) : this.props.isLoadingBigFile ?
              <View style={styles.fixedContainer}>
                <ActivityIndicator></ActivityIndicator>
                <Text style={styles.loadingText}>Uploading...</Text>
              </View>
              : (
                <View style={styles.fixedContainer}>
                  <View style={styles.fixedContainerHT}>
                    <MaterialCommunityIcons
                      name="alert-circle"
                      size={32}
                      color="#d00"
                      style={styles.icon}
                    />
                    <Text style={styles.errorText}>{this.props.error}</Text>
                  </View>
                  <View style={styles.fixedContainerHB}>
                    <TouchableOpacity
                      onPress={() => {
                        this.props.retry(
                          this.props.isErrorSave,
                          this.props.components,
                          this.props.choicelist,
                          this.state.submission,
                          this.props.newReport ? uuid.randomUUID() : this.state.uuid,
                          this.props.task_id
                        );
                      }}
                    >
                      <Text>Retry</Text>
                    </TouchableOpacity>
                  </View>
                </View>
              )}

          {/* <LogDialog /> */}
        </View>
        <View style={{ flex: 2 }} />
        {isLocationShipmentForm ? (
        <Modal
          visible={showShipmentLoadingOverlay}
          transparent
          animationType="fade"
          onRequestClose={() => {}}
        >
          <View style={styles.shipmentLoadingOverlayFullscreen}>
            <View style={styles.shipmentLoadingBox}>
              <ActivityIndicator size={100} color="rgb(0, 47, 108)" />
              {/* <Text style={styles.loadingText}>{shipmentLoadingMessage}</Text> */}
            </View>
          </View>
        </Modal>
        ) : null}
      </View>
    );


  }
}

export default connect(
  (state) => {
    return {
      company_id: state.user.get("company_id"),
      isLoading: state.forms.getIn(["form", "status"]) === "loading",
      isLoadingBigFile: state.forms.getIn(["form", "status"]) === "loading_big_file",
      isErrorSave: state.forms.getIn(["form", "status"]) === "errorSaving",
      isErrorRetrieve:
        state.forms.getIn(["form", "status"]) === "errorRetrieving",
      formId: state.forms.getIn(['form', 'id']),
      promptMessages: state.forms.getIn(['form', 'promptMessages']),
      isLoaded: state.forms.getIn(["form", "status"]) === "loaded",
      isSaving: state.forms.getIn(["form", "status"]) === "saving",
      error: state.forms.getIn(["form", "errorMessage"]),
      components: state.forms.getIn(["form", "components"]),
      choicelist: state.forms.getIn(["form", "choicelist"]),
      formSubmission: state.forms.getIn(["form", "formSubmission"]),
      alreadyAllocatedShipmentLots: state.forms.getIn(["form", "alreadyAllocatedShipmentLots"]) || [],
      previousSubmissions: state.submissions.get("previousSubmissions"),
      /*syncState: state.sync.get("state"),*/
      isLogGroup: state.loggroups.get("isLogGroup"),
      logGroupSelected: state.loggroups.get("logGroupSelected"),
      submissionSelected: state.submissions.get("submissionSelected"),
      isSubmission: state.submissions.get("isSubmission"),
      isLoadingIssue: state.submissions.get("loadingIssue"),
      payment_completed: state.user.get("payment_completed"),
      companyTimezone: state.user.get("companyTimezone"),
      userRole: state.user.get("userRole"),
      taskSelected: state.tasks.get("taskSelected"),
      inventoryTypes: state.forms.get("pallets"),
      items: state.forms.get("items"),
      packagingMaterials: state.forms.get("packagingMaterials"),
      updatedWizard: state.forms.get("updatedWizard"),
    };
  },
  (dispatch, props) => {

    return {
      sendSubmit: (submissionId, submissions, comment, callback) => dispatch(sendSubmit(submissionId, submissions, comment, callback)),
      checkRecordStatus: (uuid, callback) => dispatch(checkRecordStatus(uuid, callback)),
      showStatusError: (status) => dispatch(showStatusError(status)),
      checkLogStatus: (task_id, callback) => dispatch(checkLogStatus(task_id, callback)),
      showLogStatusError: (status) => dispatch(showLogStatusError(status)),
      loadingIssue: (value) => dispatch(loadingIssue(value)),
      getMyInventoryTypes: (data, callback) => dispatch(getMyInventoryTypes(data, callback)),
      getMyItems: (data, callback) => dispatch(getMyItems(data, callback)),
      getMyPackaging: (data, callback) => dispatch(getMyPackaging(data, callback)),
      setBigFileIsLoading: (payload) => dispatch(setBigFileIsLoading(payload)),
      getForm: (idSubmission, callback) => {
        dispatch(getForm(props.formId, idSubmission, callback));
      },
      quitOrderForm: (id) => {
        dispatch(quitOrderForm(id));
      },
      editDefaultData: (data, callback) => dispatch(editDefaultData(data, callback)),
      setStatusChange: () => { dispatch(setStatusChange()) },
      unsetStatusChange: () => { dispatch(unsetStatusChange()) },
      setLogGroupsSubAction: () => {
        dispatch(setLogGroupsSubAction());
      },
      getLocations: (data, callbak) => dispatch(getLocations(data, callbak)),
      approved: () => dispatch(approved()),
      getIngredientLotsByName: (data, callback) => {
        dispatch(getIngredientLotsByName(data, callback));
      },
      retry: (
        isErrorSave,
        components,
        choicelist,
        submission,
        uuid,
        task_id,
        status
      ) => {
        if (isErrorSave) {
          dispatch(
            beginSubmit(
              props.formId,
              props.title,
              components,
              choicelist,
              submission,
              uuid,
              task_id,
              false,
              status
            )
          );
        } else {
          dispatch(getForm(props.formId, props.submissionSelected?._id));
        }
      },
      startSubmit: (
        components,
        choicelist,
        submission,
        uuid,
        task_id,
        logroup,
        status,
        isRecipe,
        navigate,
        retry,
        sendAnyway,
        isInventoryTransfer,
        alertInventoryNoOpAfterComplete,
        isShipmentLog
      ) => {
        dispatch(
          beginSubmit(
            props.formId,
            props.title,
            components,
            choicelist,
            submission,
            uuid,
            task_id,
            false,
            logroup,
            status,
            isRecipe,
            navigate,
            retry,
            sendAnyway,
            isInventoryTransfer,
            alertInventoryNoOpAfterComplete,
            isShipmentLog
          )
        );
      },
      autoSave: (
        components,
        choicelist,
        submission,
        uuid,
        task_id,
        autosave
      ) => {
        dispatch(
          beginSubmit(
            props.formId,
            props.title,
            components,
            choicelist,
            submission,
            uuid,
            task_id,
            autosave
          )
        );
      },
    };
  }
)(Form);

const styles = StyleSheet.create({
  mainContainer: {
    backgroundColor: "#B3B7BC",
    flex: 1,
    flexDirection: "column",
  },
  issueContainer: {
    flex: 1,
    flexDirection: "column",
    borderRadius: 10,
    backgroundColor: 'pink',
  },
  readOnlyContainer: {
    flexGrow: 1,
    backgroundColor: "lightblue",
    padding: 10,
    marginHorizontal: 10,
    borderRadius: 10,
    marginBottom: 10,
  },
  container: {
    flex: 1,
    backgroundColor: "#B3B7BC",
    flexDirection: "column",
    justifyContent: "center",
  },
  keyboardAvoid: {
    flex: 1,
  },
  loadingText: {
    color: "#444",
    marginTop: 5,
  },
  fixedContainer: {
    flex: 1,
    flexDirection: "column",
    padding: 20,
    justifyContent: "center",
    alignItems: "center",
  },
  fixedContainerHT: {
    flexDirection: "row",
    alignItems: "center",
  },
  fixedContainerHB: {
    marginTop: 20,
  },
  errorText: {
    color: "#444",
    marginLeft: 5,
  },
  innerView: {
    flexDirection: "column",
    paddingTop: 10,
    paddingBottom: 10,
    backgroundColor: "#fff",
    marginBottom: 20,
    shadowOffset: {
      width: 7,
      height: 5,
    },
    shadowRadius: 5,
    shadowOpacity: 0.1,
  },
  menuContainer: {
    flex: 1,
    flexDirection: "column",
    paddingHorizontal: 10,
    paddingTop: 20,
    paddingBottom: 30,
    marginBottom: 20,
  },
  submitContainer: {
    flexDirection: "row",
    justifyContent: "center",
    paddingBottom: 20,
    paddingHorizontal: 10,
  },
  button: {
    alignItems: "center",
    backgroundColor: colors.save,
    borderRadius: 5,
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    padding: 10,
    height: 60,
  },
  buttonText: {
    color: colors.label_blue,
    fontSize: 18,
    fontFamily: "Roboto",
  },
  iconInProgress: {
    marginHorizontal: 10,
    fontSize: 30,
    alignSelf: "center",
    color: 'lightgray',
  },
  iconEditRequired: {
    marginHorizontal: 10,
    fontSize: 30,
    alignSelf: "center",
    color: 'lightgray',
  },
  iconReadyForReview: {
    marginHorizontal: 10,
    fontSize: 30,
    alignSelf: "center",
    color: 'lightgray',
  },
  iconReadyForApproval: {
    marginHorizontal: 10,
    fontSize: 30,
    alignSelf: "center",
    color: 'lightblue',
  },
  iconApproved: {
    marginHorizontal: 10,
    fontSize: 30,
    alignSelf: "center",
    color: 'lightgreen',
  },
  iconRejected: {
    marginHorizontal: 10,
    fontSize: 30,
    alignSelf: "center",
    color: 'pink',
  },
  issueBox: {
    alignItems: "center",
    backgroundColor: 'pink',
    borderRadius: 5,
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    padding: 10,
    marginBottom: 10,
    height: 60,
  },
  issueText: {
    fontSize: 18,
    fontFamily: "Roboto",
    color: "#444",
  },
  readOnlyTxt: {
    fontSize: 22,
    borderRadius: 4,
    backgroundColor: 'pink',
    margin: 10,
    padding: 10,
    fontFamily: "Roboto",
  },
  viewContainerMax: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 20,
    marginTop: 10,
    minWidth: '80%',
    paddingTop: 50,
    paddingLeft: 50,
    paddingRight: 50,
  },
  viewContainerMax1: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 20,
    marginTop: 10,
    minWidth: 450,
    paddingTop: 20,
    paddingLeft: 15,
    paddingRight: 15,
  },
  viewContainerMax2: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 20,
    marginTop: 10,
    minWidth: 350,
    paddingTop: 50,
    paddingLeft: 10,
    paddingRight: 10,
  },
  viewContainerMax3: {
    flex: 1,
    backgroundColor: '#fff',
    borderRadius: 20,
    marginTop: 10,
    minWidth: 300,
    paddingTop: 50,
    paddingLeft: 10,
    paddingRight: 10,
  },
  head: {
    backgroundColor: colors.orange,
    color: 'white',
    fontWeight: '300',
    fontFamily: 'Roboto',
  },
  text: {
    padding: 3
  },
  btnAdd: {
    width: 40
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 10,
    marginTop: 10,
  },
  reportId: {
    paddingLeft: 10,
    fontSize: 18,
    fontWeight: 'bold',
    color: colors.primary
  },
  iconContainer:{
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  animatedTextBar: {
    backgroundColor: "#EDEEEE",
    position: "absolute",
    zIndex: 10,
    padding: 10,
    height: 60,
  },
  shipmentLoadingOverlayFullscreen: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  shipmentLoadingBox: {
    paddingVertical: 20,
    paddingHorizontal: 24,
    borderRadius: 8,
    alignItems: "center",
  },

});